"use strict";var e=require("react"),t=require("react-popper"),r=require("react-outside-click-handler"),a=require("styled-components"),o=require("@cko/icons"),l=require("styled-system"),n=require("react-transition-group"),d=require("usehooks-ts"),i=require("@floating-ui/react"),s=require("@codemirror/lang-json"),c=require("@uiw/codemirror-themes"),u=require("@uiw/react-codemirror"),b=require("downshift");require("focus-visible");var f=require("react-focus-lock"),v=require("react-dom"),p=require("date-fns");function m(e){return e&&e.__esModule?e:{default:e}}function g(e){if(e&&e.__esModule)return e;var t=Object.create(null);return e&&Object.keys(e).forEach((function(r){if("default"!==r){var a=Object.getOwnPropertyDescriptor(e,r);Object.defineProperty(t,r,a.get?a:{enumerable:!0,get:function(){return e[r]}})}})),t.default=e,Object.freeze(t)}var h=g(e),x=m(r),y=m(a),E=m(c),w=m(u),k=m(b),C=m(f);const $=e.createContext(new Set),S=({children:t,flag:r,action:a="add"})=>{const o=new Set(e.useContext($));if("reset"===a)o.clear(),r&&o.add(r);else{if(!r)return h.default.createElement(h.default.Fragment,null,t);"delete"===a?o.delete(r):o.add(r)}return h.default.createElement($.Provider,{value:o},t)},I=()=>{const t=e.useContext($);return{flags:[...t.values()],hasFlag:e=>t.has(e)}};function T(){return T=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var a in r)({}).hasOwnProperty.call(r,a)&&(e[a]=r[a])}return e},T.apply(null,arguments)}const F=y.default.ul`
  margin: var(--layout-sandgrain);
  padding: var(--layout-sandgrain);
  list-style: none;
`,R=h.default.forwardRef((({children:e,...t},r)=>h.default.createElement(F,T({ref:r},t),e))),M=l.system({whiteSpace:!0,textTransform:!0,wordBreak:!0,font:!0}),L=l.compose(l.borders,l.boxShadow,l.color,l.layout,l.space,M,l.typography),O=a.css`
  margin: var(--layout-sandgrain);
  ${L}
`,A=y.default.p.attrs((({color:e="var(--base-text-primary)",font:t="var(--body-xs)"})=>({color:e,font:t})))`
  ${O}
`,P=y.default(A)`
  font: var(--card-xs);
`,N=y.default.h1`
  font: var(--heading-lg);
  color: var(--base-text-primary);
  ${O}
`,D=y.default.h2`
  font: var(--heading-md);
  color: var(--base-text-primary);
  ${O}
`,B=y.default.h3`
  font: var(--heading-sm);
  color: var(--base-text-primary);
  ${O}
`,H=y.default.h4`
  font: var(--heading-xs);
  color: var(--base-text-primary);
  ${O}
`,V=y.default(A).attrs((({as:e})=>({as:e??"span"})))``,z=y.default(A).attrs((({as:e})=>({font:"var(--code-xs)",as:e??"span"})))`
  letter-spacing: -0.24px;
  text-transform: uppercase;
`,W=y.default(N)((({inGrid:e=!1})=>`\n  margin: ${e?"var(--layout-sandgrain) var(--layout-sandgrain) var(--layout-sandgrain)":"var(--layout-saxophone) var(--layout-sandgrain) var(--layout-sandgrain)"};\n`)),j=y.default(A)`
  display: block;
  ${({ml:e})=>e&&`margin-left: ${e};`}
  ${({color:e})=>e&&`color: ${e};`}
  ${({lineHeight:e})=>e&&`line-height: ${e};`}
`,q=y.default.div`
  display: inline-flex;
  align-items: center;
  padding-right: var(--layout-stamp);
  line-height: inherit;

  /** Force prefix container to have the same height as text line height */
  &::before {
    /** hide pseudo content text from screen readers with alt text */
    content: 'A' / '';
    width: 0;
    visibility: hidden;
  }
`,G=h.default.forwardRef((({children:e,prefix:t,...r},a)=>h.default.createElement(h.default.Fragment,null,h.default.createElement(j,T({ref:a,as:"li"},r),t&&h.default.createElement(q,{"aria-hidden":"true"},t),e)))),K=y.default.ol`
  counter-reset: index;
  margin: var(--layout-sandgrain);
  padding: var(--layout-sandgrain);
  ${({ml:e})=>e&&`margin-left: ${e};`}
  ${({pl:e})=>e&&`padding-left: ${e};`}
  list-style-type: none;

  & ol {
    padding-left: var(--layout-shoe);
  }

  & li {
    counter-increment: index;

    /* top level lists use decimal style */
    &::before {
      content: counter(index, decimal) '.';
      display: inline-block;
      min-width: 20px;
      padding-right: var(--layout-seed);
    }

    /* all nested ordered lists use lower-alpha list style */
    & ol li::before {
      content: counter(index, lower-alpha) '.' !important;
    }
  }
`,U=h.default.forwardRef((({children:e,...t},r)=>h.default.createElement(K,T({ref:r},t),e))),Z=y.default.ul`
  margin: var(--layout-sandgrain);
  padding: var(--layout-sandgrain);
  ${({m:e})=>e&&`margin: ${e};`}
  ${({margin:e})=>e&&`margin: ${e};`}
  ${({py:e})=>e&&`padding-top: ${e}; padding-bottom: ${e};`}
  ${({px:e})=>e&&`padding-left: ${e}; padding-right: ${e};`}
  ${({paddingLeft:e})=>e&&`padding-left: ${e};`}
  list-style: none;

  & li {
    &::before {
      content: '\u23FA';
      padding-right: var(--layout-stamp);
      padding-left: var(--layout-soybean);
      font-size: inherit;
    }
  }
`,_=h.default.forwardRef((({children:e,...t},r)=>h.default.createElement(Z,T({ref:r},t),e))),Y=y.default(A)`
  display: inline-block;

  margin-top: var(--layout-sandgrain);
  margin-bottom: var(--layout-soybean);

  font: var(--body-xs);
  color: var(--control-text-primary);
`,X=a.keyframes`
  100% {
    transform: rotate(360deg);
  }
`,J=a.keyframes`
  0% {
    stroke-dasharray: 1,200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89,200;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89,200;
    stroke-dashoffset: -124;
  }
`,Q=y.default.div`
  display: flex;
  flex-direction: column;
  gap: var(--layout-soybean);
  margin: var(--layout-sandgrain) auto;
`,ee=y.default.svg`
  transform-origin: center center;
  animation: ${X} 2s linear infinite;
`,te=y.default.circle`
  stroke-dasharray: 150, 200;
  stroke-dashoffset: -10;
  stroke-linecap: round;
  animation: ${J} 1.5s ease-in-out infinite;
`;let re=function(e){return e.STANDALONE="standalone",e.NESTED="nested",e}({});const ae=({width:e,variant:t=re.NESTED,...r})=>h.default.createElement(Q,null,h.default.createElement(ee,T({viewBox:"25 25 50 50",width:e,color:"var(--action-bg-primary)",role:"status","aria-label":"Loading","aria-live":"polite"},r),h.default.createElement(te,{cx:"50",cy:"50",r:"20",fill:"none",strokeWidth:"2",stroke:"currentColor"})),t===re.STANDALONE&&h.default.createElement(Y,{"aria-hidden":"true"},"Loading...")),oe=y.default(ae)`
  color: var(--action-icon-disabled);
`,le=a.css`
  &[aria-disabled='true'] {
    color: var(--action-text-disabled);
    background: var(--action-bg-disabled);

    &:hover {
      color: var(--action-text-disabled);
      background: var(--action-bg-disabled);
    }

    &:focus,
    &:focus-visible {
      color: var(--action-text-disabled);
      background: var(--action-bg-disabled);
    }

    &:active {
      color: var(--action-text-disabled);
      background: var(--action-bg-disabled);
    }
  }
`,ne=a.css`
  padding: var(--layout-sandgrain);
  background: none;

  &[aria-disabled='true'] {
    color: inherit;
  }
`,de=a.css`
  color: var(--action-text-oninvert-primary);
  background: var(--action-bg-primary);

  &:hover {
    color: var(--action-text-oninvert-hover);
    background: var(--action-bg-hover);
  }

  &:focus,
  &:focus-visible {
    color: var(--action-text-oninvert-focus);
    background: var(--action-bg-focus);
  }

  &:active {
    color: var(--action-text-oninvert-pressed);
    background: var(--action-bg-pressed);
  }

  ${le}
`,ie=a.css`
  color: var(--action-text-secondary);
  background: var(--action-bg-secondary);

  &:hover {
    color: var(--action-text-secondary-hover);
    background: var(--action-bg-decorative-hover);
  }

  &:focus,
  &:focus-visible {
    color: var(--action-text-secondary-focus);
    background: var(--action-bg-decorative-focus);
  }

  &:active {
    color: var(--action-text-secondary-pressed);
    background: var(--action-bg-decorative-pressed);
  }

  ${le}
`,se=a.css`
  color: var(--action-text-oninvert-destructive-default);
  background: var(--action-bg-destructive-default);

  &:hover {
    color: var(--action-text-oninvert-destructive-hover);
    background: var(--action-bg-destructive-hover);
  }

  &:focus,
  &:focus-visible {
    color: var(--action-text-oninvert-destructive-focus);
    background: var(--action-bg-destructive-focus);
  }

  &:active {
    color: var(--action-text-oninvert-destructive-pressed);
    background: var(--action-bg-destructive-pressed);
  }

  ${le}
`,ce=a.css`
  padding: var(--layout-sandgrain) var(--layout-seed);
  color: var(--action-text-primary);
  background: none;

  &:hover {
    color: var(--action-text-hover);
    text-decoration: underline;
  }

  &:focus,
  &:focus-visible {
    color: var(--action-text-focus);
    text-decoration: underline;
  }

  &:active {
    color: var(--action-text-pressed);
    text-decoration: underline;
  }

  &[aria-disabled='true'] {
    color: var(--action-text-disabled);
  }
`,ue=a.css`
  padding: var(--layout-sandgrain) var(--layout-soybean);
`,be=a.css`
  padding: var(--layout-seed) var(--layout-stamp);
`,fe={primary:de,secondary:ie,unstyled:ne,destructive:se,link:ce},ve={sm:ue,md:be},pe=y.default.button`
  cursor: pointer;

  display: inline-flex;
  gap: var(--layout-soybean);
  align-items: center;

  height: fit-content;

  font: var(--body-xs-medium);

  border: none;
  border-radius: var(--border-r-seed);

  &:focus,
  &:focus-visible {
    outline: var(--border-b-soybean) solid var(--action-border-focus-ring);
  }

  ${({size:e})=>e&&ve[e]}
  ${({variant:e})=>e&&fe[e]}

  &[aria-disabled='true'] {
    cursor: not-allowed;
  }
`,me=e.forwardRef((({children:e,size:t="md",variant:r="primary",type:a="button",disabled:o=!1,isLoading:l=!1,loadingText:n="Loading...",onClick:d,...i},s)=>h.default.createElement(pe,T({variant:r,size:t,type:a,"aria-disabled":!!l||o,onClick:e=>{if(l||o)return e.preventDefault(),void e.stopPropagation();d?.(e)}},i,{ref:s}),l&&"link"!==r&&"sm"!==t&&h.default.createElement(oe,{"aria-hidden":!0,width:16}),l?h.default.createElement("output",{"aria-label":"Loading","aria-live":"polite"},n):e))),ge=a.css`
  background-color: var(--control-bg-primary);
  border: var(--border-b-seed) solid var(--control-border-default);

  /* Prevent content shift by setting to the same colour as the background instead of removing entirely when accordion open */
  border-bottom-color: var(--control-bg-primary);
  border-radius: var(--border-r-stamp) var(--border-r-stamp) var(--border-r-sandgrain)
    var(--border-r-sandgrain);
`,he=a.css`
  background-color: var(--control-bg-secondary);
  border: var(--border-b-seed) solid var(--control-bg-secondary);
`,xe=a.css`
  background-color: var(--control-bg-primary);
  border: var(--border-b-seed) solid var(--control-bg-primary);
`,ye=y.default(me)`
  gap: var(--layout-stamp);

  width: 100%;
  padding: var(--layout-spoon);

  font: var(--heading-xs);
  color: var(--control-text-primary);

  border-radius: var(--border-r-stamp);

  transition: border 120ms ease-out;

  ${({accordionVariant:e})=>"primary"===e?he:xe};

  ${({isOpen:e})=>e&&ge}

  &:focus,
  &:focus-visible {
    color: var(--control-text-focus);
    border: var(--border-b-seed) solid var(--control-border-focus);
    outline: var(--border-b-soybean) solid var(--action-border-focus-ring);

    svg {
      color: var(--control-icon-focus);
    }
  }

  &:hover {
    color: var(--comtrol-text-hover);
    border: var(--border-b-seed) solid var(--control-border-hover);

    svg {
      color: var(--control-icon-hover);
    }
  }
`,Ee=y.default.div`
  width: 16px;
  height: 16px;
  line-height: 0px;
`,we=y.default(o.IconActionAccordionChevronClosed)`
  transform: ${({$isOpen:e})=>e?"rotate(90deg)":"rotate(0deg)"};
  transition: transform 0.3s cubic-bezier(0.5, -0.4, 0, 1);
`,ke=(t={})=>{const{name:r,strict:a=!0,hookName:o="useContext",providerName:l="Provider",errorMessage:n}=t,d=e.createContext(void 0);return d.displayName=r,[d.Provider,function t(){const r=e.useContext(d);if(!r&&a){const e=new Error(n??`${o} returned \`undefined\`. Seems you forgot to wrap component within ${l}`);throw e.name="ContextError",Error.captureStackTrace?.(e,t),e}return r},d]},[Ce,$e]=ke({hookName:"useAccordionContext",providerName:"Accordion"}),Se=({children:e,...t})=>{const{isOpen:r,variant:a,buttonId:o,description:l}=$e();return h.default.createElement(ye,T({variant:"unstyled","data-testid":"accordion-btn",isOpen:r,accordionVariant:a,id:o,"aria-controls":`accordion-body-${o}`,"aria-expanded":r},l&&{"aria-description":l},t),h.default.createElement(Ee,null,h.default.createElement(we,{$isOpen:r,"data-testid":r?"accordion-icon-open":"accordion-icon-closed"})),e)},Ie=a.css`
  border: var(--border-b-seed) solid var(--control-border-default);
  border-top-style: none;
`,Te=a.css`
  border: var(--border-b-seed) solid var(--control-bg-primary);
  border-top-style: none;
`,Fe=y.default.div`
  overflow: hidden;

  height: ${({isOpen:e})=>e?"auto":0};

  background-color: var(--control-bg-primary);
  border-radius: var(--border-r-sandgrain) var(--border-r-sandgrain) var(--border-r-stamp)
    var(--border-r-stamp);

  transition: height 220ms ease-out;

  ${({isOpen:e})=>e?Ie:"border: none;"}

  &.accordion-enter {
    height: 0;
    ${Te}
  }

  &.accordion-enter-active {
    height: ${({bodyHeight:e})=>`${e}px`};
    opacity: 1;
    ${Ie}
  }

  &.accordion-enter-done {
    height: auto;
    ${Ie}
  }

  &.accordion-exit {
    height: ${({bodyHeight:e})=>`${e}px`};
    ${Ie}
  }

  &.accordion-exit-active {
    height: 0;
    ${Te}
  }
`,Re=y.default.div`
  padding: var(--layout-soybean) var(--layout-spoon) var(--layout-spoon) var(--layout-saxophone);
`,Me=({children:t,...r})=>{const{isOpen:a,buttonId:o}=$e(),l=e.useRef(null),d=e.useMemo((()=>l?.current?.scrollHeight??"0"),[a]);return h.default.createElement(n.CSSTransition,{in:a,timeout:220,classNames:"accordion"},h.default.createElement(Fe,T({"data-testid":"accordion-content",id:`accordion-body-${o}`,"aria-labelledby":o,role:"region",ref:l,isOpen:a,bodyHeight:d},r),h.default.createElement(Re,null,t)))},Le={2:"var(--heading-md)",3:"var(--heading-sm)",4:"var(--heading-xs)",5:"var(--heading-xs)",6:"var(--heading-xs)"},Oe=y.default.div`
  display: flex;
  flex-direction: row;
  gap: var(--layout-stamp);
  align-items: ${({placement:e})=>"below"===e?"flex-start":"center"};
  justify-content: ${({placement:e})=>"end"===e?"space-between":"flex-start"};

  width: 100%;

  font: ${({headingLevel:e})=>Le[e]};
  color: inherit;
  text-align: start;

  ${({placement:e})=>"below"===e&&"\n    flex-direction: column;\n    gap: var(--layout-sandgrain);\n"}
`,Ae=y.default(A)`
  font: var(--body-xs-medium);
  color: var(--base-text-secondary);
`,Pe=({children:e})=>{const{title:t,description:r,descriptionPlacement:a,headingLevel:o}=$e();return h.default.createElement(Oe,{"data-testid":"accordion-wrapper",placement:a,headingLevel:o},t,e,r&&h.default.createElement(Ae,{"aria-hidden":!0},r))},Ne=y.default.div`
  width: 100%;
`,De=y.default.h4`
  /* Used for accessibility */
  margin: var(--layout-sandgrain);
`,Be=y.default.span`
  color: var(--base-text-secondary);
`,He=y.default.span`
  display: flex;
  align-self: flex-start;
`;let Ve=function(e){return e.PAGE="page",e.SECTION="section",e}({});const ze=y.default.div`
  ${l.space}
  ${l.layout}
  ${l.color}
  ${l.boxShadow}
  ${l.border}
  ${l.order}
  ${l.grid}
`,We=y.default.div`
  width: 100%;
  border-radius: var(--border-r-shoe);

  > * {
    padding: var(--layout-shoe);
  }

  ${l.variant({prop:"variant",variants:{primary:{backgroundColor:"var(--base-bg-primary)",border:"var(--border-b-seed) solid  var(--base-border-secondary)"},secondary:{backgroundColor:"var(--base-bg-secondary)"}}})}
`,je=y.default.div`
  width: 100%;
  padding-bottom: var(--layout-shoe);
  font: var(--body-xs-medium);
  color: var(--base-text-secondary);
`,qe=y.default.div`
  display: flex;
  gap: var(--layout-spoon);
  justify-content: flex-start;

  /* TODO: remove after legacy buttons removed */
  && > button + button {
    margin-left: var(--layout-sandgrain);
  }
`,Ge=a.css`
  width: 100%;
  padding-bottom: var(--layout-soybean);
`,Ke=y.default(N)`
  ${Ge}
`,Ue=y.default(D)`
  ${Ge}
`,Ze=y.default(B)`
  ${Ge}
`,_e=y.default(H)`
  ${Ge}
`,Ye=({condition:e,wrap:t,children:r})=>e?t(r):r,Xe=y.default.div`
  display: flex;
  margin: var(--layout-sandgrain);
  padding-bottom: var(--layout-soybean);

  ul {
    display: flex;
    margin: var(--layout-sandgrain);
    padding: var(--layout-sandgrain);
    list-style: none;
  }

  li:not(:last-child)::after {
    content: '/';
    margin: var(--layout-sandgrain) var(--layout-seed);
    font: var(--body-xs-medium);
    color: var(--control-text-secondary);
  }
`;y.default(A)`
  margin: var(--layout-sandgrain) var(--layout-seed);
  font: var(--body-xs-medium);
  color: var(--control-text-secondary);
`;const Je=y.default.a`
  cursor: pointer;

  display: inline-flex;
  gap: var(--layout-seed);
  align-items: center;

  width: fit-content;
  height: fit-content;

  font: var(--body-xs-medium);
  color: var(--action-text-primary);
  text-decoration: none;

  border: none;
  border-radius: var(--border-r-seed);
  outline-offset: var(--layout-seed);

  &:hover {
    color: var(--action-text-hover);
    text-decoration: underline;
  }

  &:focus,
  &:focus-visible {
    color: var(--action-text-focus);
    text-decoration: underline;
    outline: var(--border-b-soybean) solid var(--action-border-focus-ring);
  }

  &:active {
    color: var(--action-text-pressed);
    text-decoration: underline;
  }
`,Qe=e.forwardRef((({children:e,variant:t="default",arrowPlacement:r="end",as:a,...l},n)=>{const d=a||"a";return h.default.createElement(Je,T({as:d,target:"external"===t?"_blank":"_self",role:"link",ref:n},l),"default"===t&&"start"===r&&h.default.createElement(o.IconActionArrowLeft,null),e,"default"===t&&"end"===r&&h.default.createElement(o.IconActionArrowRight,null),"external"===t&&h.default.createElement(o.IconActionArrowUpRight,null))})),et=y.default(Qe)`
  padding: var(--layout-sandgrain) var(--layout-seed);
  font: var(--body-xs-medium);
  color: var(--control-text-secondary);
  text-decoration: none;

  &:first-child {
    padding-left: var(--layout-sandgrain);
  }

  &:hover {
    color: var(--control-text-hover);
    text-decoration: underline;
  }

  &:focus {
    color: var(--control-text-focus);
    text-decoration: underline;
    outline: none;
  }

  &:focus-visible {
    color: var(--control-text-focus);
    text-decoration: underline;
    outline: var(--border-b-soybean) solid var(--action-border-focus-ring);
  }

  &:active {
    color: var(--control-text-selected);
    text-decoration: underline;
  }
`,tt=y.default(A)`
  cursor: auto;
  font: var(--body-xs-medium);
  color: var(--control-text-primary);
  visibility: hidden;
`,rt=e.forwardRef((({children:e,selected:t,...r},a)=>t?h.default.createElement("li",null,h.default.createElement(tt,null,e)):h.default.createElement("li",null,h.default.createElement(et,T({variant:"inline",ref:a},r),e)))),[at,ot]=ke(),[lt,nt]=ke({hookName:"useTab",providerName:"TabProvider"}),dt=a.css`
  left: 0;
  width: 100%;
  opacity: 1;
`,it=y.default(me).attrs((()=>({variant:"unstyled"})))`
  display: flex;
  flex-direction: column;
  padding-bottom: 12px;

  &:focus,
  &:focus-visible {
    outline: none;

    p {
      color: var(--control-text-selected);
      outline: var(--border-b-soybean) solid var(--action-border-focus-ring);
    }
  }

  &:hover {
    p::after {
      ${dt}
    }
  }
`,st=y.default(A)`
  position: relative;

  padding: var(--layout-sandgrain) var(--layout-seed);

  font: var(--body-xs-emphasis);
  color: ${({active:e})=>e?"var(--control-text-selected)":"var(--control-text-secondary)"};

  border-radius: var(--border-r-seed);

  &::after {
    content: '';

    position: absolute;
    bottom: -12px;
    left: 50%;

    width: 0%;
    height: 4px;

    opacity: 0;
    background-color: var(--control-border-selected);

    transition:
      left 0.2s linear,
      width 0.2s linear,
      opacity 0.2s linear;

    ${({active:e})=>e&&dt}
  }
`,ct=({children:t,value:r,...a})=>{const{currentValue:o,registerTabId:l,deregisterTabId:n,tabPanelIds:d,handleOnChange:i,tabIds:s}=nt(),{setTabRoveFocusIndex:c,currentRoveFocusTab:u,tabListFocusedWithin:b}=ot(),f=e.useRef(null),v=e.useId(),p=o===r,m=u===v;e.useEffect((()=>(l(r,v),()=>n(v))),[]),e.useEffect((()=>{m&&b&&f?.current&&f.current.focus()}),[m,b]);return h.default.createElement(it,T({},a,{ref:f,id:v,role:"tab","aria-selected":p,tabIndex:m?0:-1},d.get(r)&&{"aria-controls":d.get(r)},{onClick:()=>{i(r)},onFocus:()=>c([...s.keys()].findIndex((e=>e===r)))}),h.default.createElement(st,{active:p},t))},ut=a.css((({disabled:e,tabVariant:t,selected:r})=>{let a="var(--control-text-secondary)",o="var(--control-bg-selected)";return e?(a="var(--control-text-disabled)",o="var(--control-border-disabled)"):"error"===t?(a="var(--control-text-bad)",o="var(--control-border-bad)"):"warning"===t?(a="var(--control-text-warn)",o="var(--control-border-warn)"):r&&(a="var(--control-text-selected)"),`\n    color: ${a};\n    cursor: ${e?"not-allowed":"pointer"};\n    padding: ${r?"var(--layout-seed) var(--layout-soybean) calc(var(--layout-soybean) - var(--border-b-seed))":"var(--layout-seed) var(--layout-soybean) calc(var(--layout-stamp) - var(--border-b-seed))"};\n    gap: var(--layout-soybean);\n    border-bottom: ${r&&`var(--border-b-stamp) solid ${o}`};\n    border-radius: var(--border-r-sandgrain);\n    font: var(--body-sm-emphasis);\n    width: fit-content;\n    min-width: max-content;\n\n    &:focus {\n      border-radius: var(--border-r-seed);\n    }\n\n    &:focus,\n    &:hover {\n      border-bottom: ${r&&`var(--border-b-stamp) solid ${o}`};\n      text-decoration: underline;\n    }\n  `})),bt=y.default(me).attrs((()=>({variant:"unstyled"})))`
  ${ut}

  &:focus {
    outline-offset: -4px;
  }
`,ft=y.default.div`
  display: flex;
  gap: var(--layout-soybean);
  align-items: center;
`;let vt=function(e){return e.WARNING="warning",e.ERROR="error",e}({});const pt=({selected:t=!1,variant:r,disabled:a=!1,icon:o,id:l=e.useId(),label:n,onClick:d,onFocus:i,focus:s=!1,index:c,selectedPanelId:u,onSelect:b,...f})=>{const v=e.useRef(null);return e.useEffect((()=>{s&&v.current&&v.current.focus()}),[s]),h.default.createElement(bt,T({selected:t,tabVariant:r,disabled:a,"data-testid":"tab-item",ref:v,role:"tab","aria-selected":t,"aria-disabled":a||void 0,"aria-controls":u,id:l,className:u,tabIndex:s||t?0:-1,onClick:()=>{d(),b()},onFocus:i},f),h.default.createElement(ft,null,o&&h.default.createElement(o,null),n))},mt="ArrowRight",gt="ArrowLeft",ht="Home",xt="End";function yt(t,r,a,o){const[l,n]=e.useState(t),d=e.useMemo((()=>{let e=a;return void 0!==o&&null!==l&&l>-1&&(e=o[l]),e}),[a,l,o]),i=e.useCallback((e=>{(e.target?.classList?.contains(d)||e.target?.id===d)&&(e.key===gt?(e.preventDefault(),n(0===l?r:Number(l)-1)):e.key===mt?(e.preventDefault(),n(l===r?0:Number(l)+1)):e.key===xt?(e.preventDefault(),n(r)):e.key===ht&&(e.preventDefault(),n(0)))}),[t,l,n,d]);return e.useEffect((()=>(document.addEventListener("keydown",i,!1),()=>{document.removeEventListener("keydown",i,!1)})),[i]),[l,n,d]}const Et=y.default(R)`
  border-bottom: var(--border-b-seed) solid var(--base-border-secondary);
  display: flex;
  gap: var(--layout-shoebox);
  list-style: none;
  margin: var(--layout-sandgrain);
  padding: var(--layout-sandgrain);
  overflow-x: auto;
`,wt=({items:t,onClick:r,selectedItem:a,selectedPanelId:o})=>{const[l,n]=yt(null,t.length-1,o),d=e.useCallback((e=>{n&&n(e)}),[n]);return h.default.createElement(Et,{role:"tablist","aria-orientation":"horizontal"},t.map(((e,t)=>h.default.createElement("li",{key:e.id},h.default.createElement(pt,T({},e,{onClick:()=>r(e.id),selected:a===e.id,index:t,focus:l===t,onSelect:()=>d(t),onFocus:()=>n(t),"data-testid":`tab-${t}`,selectedPanelId:o}))))))},kt=(e,t)=>{const[r,a]=h.useState();return h.useLayoutEffect((()=>{const{current:r}=e,o=()=>{if(!r)return;const e=r.scrollWidth>r.clientWidth;a(e),t&&t(e)};r&&("ResizeObserver"in window&&new ResizeObserver(o).observe(r),o())}),[t,e]),r},Ct=t=>{const[r,a]=e.useState(!1),o=e.useRef(null),l=e.useCallback((e=>{a(e.matches)}),[]);return e.useLayoutEffect((()=>(window?.matchMedia?(o.current=window.matchMedia(t),o.current.addEventListener("change",l),o.current.matches!==r&&a(o.current.matches)):a(!1),()=>o.current?.removeEventListener("change",l))),[t]),r},$t=y.default.div`
  display: flex;
  gap: var(--layout-shoebox);
  width: 100%;
  border-bottom: var(--border-b-seed) solid var(--base-border-secondary);
`,St=({children:t,...r})=>{const{tabIds:a,currentValue:o}=nt(),[l,n]=e.useState(!1),[d,i,s]=yt(null,a.size-1,a.get(o),[...a.values()]),c=e.useCallback((e=>{const t=e.currentTarget;requestAnimationFrame((()=>{t?.contains(document.activeElement)||(n(!1),i([...a.keys()].findIndex((e=>e===o))))}))}),[n,i]);return h.default.createElement($t,T({role:"tablist","aria-orientation":"horizontal",onFocus:()=>n(!0),onBlur:c},r),h.default.createElement(at,{value:{currentRoveFocusTab:s,setTabRoveFocusIndex:i,tabListFocusedWithin:l}},t))},It=y.default.div`
  width: 100%;
`,Tt=({children:t,value:r,...a})=>{const{currentValue:o,registerTabPanelId:l,deregisterTabPanelId:n,tabIds:d}=nt(),i=e.useId();return e.useEffect((()=>(l(r,i),()=>n(i))),[i,r]),o!==r?null:h.default.createElement(It,T({},a,{role:"tabpanel",id:i},d.get(r)&&{"aria-labelledby":d.get(r)}),t)},Ft=y.default.div`
  display: flex;
  flex-direction: column;
  gap: var(--layout-shoe);
  width: 100%;
`,Rt=({children:t,currentValue:r,onChange:a,...o})=>{const[l,n]=d.useMap(),[i,s]=d.useMap(),c=e.useCallback(((e,t)=>{n.set(e,t)}),[n]),u=e.useCallback((e=>{n.remove(e)}),[n]),b=e.useCallback(((e,t)=>{s.set(e,t)}),[i]),f=e.useCallback((e=>{s.remove(e)}),[i]),v=e.useCallback((e=>{a(e)}),[a]);return h.default.createElement(Ft,o,h.default.createElement(lt,{value:{currentValue:r,tabIds:l,tabPanelIds:i,registerTabId:c,deregisterTabId:u,registerTabPanelId:b,deregisterTabPanelId:f,handleOnChange:v}},t))},Mt={sm:a.css`
  padding: var(--layout-seed);
`,md:a.css`
  padding: var(--layout-soybean);
`},Lt=y.default(me).attrs((()=>({variant:"unstyled"})))`
  gap: 0;

  line-height: 0px;
  color: var(--action-text-secondary);

  background: ${({noBackground:e})=>e?"transparent":"var(--action-bg-secondary)"};
  border-radius: var(--layout-seed);

  ${({size:e})=>e&&Mt[e]}

  &:hover {
    color: var(--action-text-secondary-hover);
    background: var(--action-bg-decorative-hover);
  }

  &:focus,
  &:focus-visible {
    color: var(--action-text-secondary-focus);
    background: var(--action-bg-decorative-focus);
  }

  &:active {
    color: var(--action-text-secondary-pressed);
    background: var(--action-bg-decorative-pressed);
  }

  &[aria-disabled='true'] {
    color: var(--action-text-disabled);
    background: ${({noBackground:e})=>e?"transparent":"var(--action-bg-disabled)"};
  }
`,Ot=e.forwardRef((({children:e,size:t="md",noBackground:r=!1,...a},o)=>h.default.createElement(Lt,T({ref:o,size:t,noBackground:r,loadingText:""},a),e))),[At,Pt]=ke({strict:!1}),Nt=e.createContext(null),Dt=()=>{const t=e.useContext(Nt);if(null==t)throw new Error("Tooltip components must be wrapped in <Tooltip />");return t},Bt=({children:t,...r})=>{const a=(({initialOpen:t=!1,placement:r="top",delay:a={open:0,close:500},onClose:o})=>{const[l,n]=e.useState(t),d=e.useCallback(((e,t)=>{!1===e&&o&&o(),n(e)}),[o,n]),s=i.useFloating({placement:r,open:l,onOpenChange:d,whileElementsMounted:i.autoUpdate,middleware:[i.offset(8),i.flip({fallbackAxisSideDirection:"start"}),i.shift({padding:8})]}),{context:c}=s,u=Pt();i.useDelayGroup(c,{id:c.floatingId});const{delay:b}=i.useDelayGroupContext(),f=i.useHover(c,{move:!1,enabled:!0,delay:u?b:a,handleClose:i.safePolygon()}),v=i.useFocus(c,{enabled:!0}),p=i.useDismiss(c,{ancestorScroll:!0}),m=i.useRole(c,{role:"tooltip"}),g=i.useInteractions([f,v,p,m]);return e.useMemo((()=>({open:l,setOpen:n,...g,...s})),[l,n,g,s])})(r);return h.default.createElement(Nt.Provider,{value:a},t)},Ht=e.forwardRef((({children:t,...r},a)=>{const o=Dt(),l=t.ref,n=i.useMergeRefs([o.refs.setReference,a,l]);return e.isValidElement(t)?e.cloneElement(t,o.getReferenceProps({ref:n,...r,...t.props,"data-state":o.open?"open":"closed"})):null})),Vt=y.default.div`
  z-index: 10000;

  padding: var(--layout-seed) var(--layout-soybean);

  font: var(--helper-sm);
  color: var(--base-text-oninvert-primary);
  text-align: left;
  word-wrap: break-word;

  background-color: var(--control-bg-oninvert-primary);
  border-radius: var(--border-r-seed);
`,zt=y.default(A)`
  width: 100%;
  max-width: 400px;
  color: inherit;
`,Wt=({text:e})=>{const{open:t,refs:r,floatingStyles:a,getFloatingProps:o}=Dt();return t?h.default.createElement(i.FloatingPortal,null,h.default.createElement(Vt,T({ref:r.setFloating,style:a},o(),{"data-testid":"tooltip"}),h.default.createElement(zt,null,e))):null},jt=({label:t,value:r,size:a="sm",...l})=>{const[n,i]=d.useCopyToClipboard(),[s,c]=e.useState(!1);return h.default.createElement(Bt,{onClose:()=>c(!1)},h.default.createElement(Ht,null,h.default.createElement(Ot,T({onClick:()=>{i(r),c(!0)}},s&&{style:{backgroundColor:"var(--action-bg-selected)",color:"var(--action-icon-oninvert-secondary)"}},{"aria-label":"Copy to clipboard",size:a},l),s?h.default.createElement(o.IconActionCheckmark,null):h.default.createElement(o.IconActionCopy,null))),h.default.createElement(Wt,{text:s?`${t} copied`:`Copy ${t}`}))},qt=y.default(ze)`
  display: flex;
  ${l.flexbox}
`,Gt=y.default(qt)`
  flex-grow: 0;
  flex-shrink: 0;

  @media (min-width: 940px) {
    justify-content: flex-end;
    align-items: center;
    order: initial;
  }
`,Kt="var(--border-b-seed) solid var(--base-border-secondary)",Ut=y.default.hr`
  width: 0;
  height: 0;
  margin: 0;

  color: transparent;

  border-width: var(--border-b-sandgrain);

  ${({orientation:e})=>"horizontal"===e?`width: 100%; border-top: ${Kt}`:`height: 100%; border-left: ${Kt}`};
`,Zt=({orientation:e="horizontal",...t})=>h.default.createElement(Ut,T({"aria-orientation":e,orientation:e},t)),_t=y.default(ze)`
  display: grid;
  grid-gap: var(--layout-spoon);
  ${l.grid}
`,Yt=({children:e,...t})=>h.default.createElement(_t,t,e),Xt=y.default(ze)`
  ${l.grid}

  ${l.variant({prop:"align",variants:{right:{placeSelf:"end"},center:{placeSelf:"center"}}})}

  ${l.variant({prop:"placement",variants:{fullWidth:{gridColumn:"1 / -1"},alone:{gridColumnStart:"1","&& + *":{gridColumnStart:1}},first:{gridColumnStart:"1"},last:{"&& + *":{gridColumnStart:1}}}})}
`,Jt=y.default(ze)((({fullWidth:e})=>`\n  display: grid;\n  gap: var(--layout-shoe) var(--layout-spoon);\n  grid-template-columns: repeat(24, 1fr);\n  min-width: 1024px;\n  ${e?"":"max-width: 1200px;"}\n  margin: var(--layout-sandgrain) auto;\n`)),Qt=y.default(ze)`
  grid-column: 7 / 19;
`,er=y.default(ze)((({span:e,newRow:t=!1,grid:r=!1})=>`\n  ${r?"display: grid;":""}\n  ${t?"grid-column-start: 1;":""}\n  grid-column-end: span ${e};\n`)),tr=y.default(ze)((({position:e})=>`\n  grid-column: ${"start"===e?"1 / 17":"9 / 25"};\n`)),rr=y.default(ze)((({position:e})=>`\n  grid-column: ${"start"===e?"1 / 8":"18 / 25"};\n`)),ar=y.default(ze)`
  width: 100%;
  margin: var(--layout-sandgrain);
  padding: var(--layout-spoon);
  padding-bottom: var(--layout-sandgrain);

  background-color: var(--base-bg-secondary);
  border-bottom: var(--border-b-seed) solid var(--base-border-secondary);
  border-top-left-radius: var(--border-r-stamp);
  border-top-right-radius: var(--border-r-stamp);
`,or=y.default(St)`
  border: none;
`;y.default(A)`
  padding-left: var(--layout-spoon);
  white-space: nowrap;
`;const lr=y.default(qt)`
  justify-content: flex-end;
`,nr=y.default(qt)`
  align-items: flex-start;
  justify-content: flex-end;
`,dr=({code:e,headerActions:t,tabListAriaLabel:r,tabNames:a})=>h.default.createElement(ar,null,h.default.createElement(lr,null,h.default.createElement(S,{flag:"v11"},h.default.createElement(or,{"aria-label":r},a.map((e=>h.default.createElement(ct,{key:e,value:e},e))))),t,h.default.createElement(nr,null,h.default.createElement(jt,{label:"Data",value:e})))),ir=y.default(ze)`
  width: 100%;
  margin: var(--layout-sandgrain);
  padding: var(--layout-spoon);

  background-color: var(--base-bg-secondary);
  border-bottom: var(--border-b-seed) solid var(--base-border-secondary);
  border-top-left-radius: var(--border-r-stamp);
  border-top-right-radius: var(--border-r-stamp);
`,sr=y.default(qt)`
  align-items: center;
  justify-content: space-between;
  color: var(--base-text-primary);
`,cr=y.default(H)`
  width: 100%;
  color: var(--base-text-primary);
`,ur=y.default(qt)`
  align-items: center;
  justify-content: flex-end;
`,br=({title:e,code:t,headerActions:r})=>h.default.createElement(ir,null,h.default.createElement(sr,null,h.default.createElement(cr,null,e),r,h.default.createElement(ur,null,h.default.createElement(jt,{label:e,value:t})))),fr=y.default.div`
  width: 100%;
  margin: var(--layout-sandgrain);
  padding: var(--layout-spoon);

  border-bottom-left-radius: var(--border-r-stamp);
  border-bottom-right-radius: var(--border-r-stamp);
  background-color: var(--base-bg-secondary);

  align-self: flex-end;
  ${({$hasOverflow:e})=>e?"":"padding-top: var(--layout-sandgrain);"}
`,vr=y.default(me)`
  color: var(--action-text-primary);
  background: none;

  &:hover,
  &:focus,
  &:focus-visible {
    color: var(--action-text-visited);
    background: none;
    outline: none;
  }
`,pr=({isExpanded:e,hasOverflow:t,onToggleExpand:r})=>h.default.createElement(fr,{$hasOverflow:t},(t||e)&&h.default.createElement(vr,{onClick:r},e?"Show less":"Show more",e?h.default.createElement(o.IconActionChevronUp,null):h.default.createElement(o.IconActionChevronDown,null)));let mr=0;class gr{constructor(e={}){this.id=mr++,this.perNode=!!e.perNode,this.deserialize=e.deserialize||(()=>{throw new Error("This node type doesn't define a deserialize function")})}add(e){if(this.perNode)throw new RangeError("Can't add per-node props to node types");return"function"!=typeof e&&(e=xr.match(e)),t=>{let r=e(t);return void 0===r?null:[this,r]}}}gr.closedBy=new gr({deserialize:e=>e.split(" ")}),gr.openedBy=new gr({deserialize:e=>e.split(" ")}),gr.group=new gr({deserialize:e=>e.split(" ")}),gr.isolate=new gr({deserialize:e=>{if(e&&"rtl"!=e&&"ltr"!=e&&"auto"!=e)throw new RangeError("Invalid value for isolate: "+e);return e||"auto"}}),gr.contextHash=new gr({perNode:!0}),gr.lookAhead=new gr({perNode:!0}),gr.mounted=new gr({perNode:!0});const hr=Object.create(null);class xr{constructor(e,t,r,a=0){this.name=e,this.props=t,this.id=r,this.flags=a}static define(e){let t=e.props&&e.props.length?Object.create(null):hr,r=(e.top?1:0)|(e.skipped?2:0)|(e.error?4:0)|(null==e.name?8:0),a=new xr(e.name||"",t,e.id,r);if(e.props)for(let r of e.props)if(Array.isArray(r)||(r=r(a)),r){if(r[0].perNode)throw new RangeError("Can't store a per-node prop on a node type");t[r[0].id]=r[1]}return a}prop(e){return this.props[e.id]}get isTop(){return(1&this.flags)>0}get isSkipped(){return(2&this.flags)>0}get isError(){return(4&this.flags)>0}get isAnonymous(){return(8&this.flags)>0}is(e){if("string"==typeof e){if(this.name==e)return!0;let t=this.prop(gr.group);return!!t&&t.indexOf(e)>-1}return this.id==e}static match(e){let t=Object.create(null);for(let r in e)for(let a of r.split(" "))t[a]=e[r];return e=>{for(let r=e.prop(gr.group),a=-1;a<(r?r.length:0);a++){let o=t[a<0?e.name:r[a]];if(o)return o}}}}var yr;xr.none=new xr("",Object.create(null),0,8),function(e){e[e.ExcludeBuffers=1]="ExcludeBuffers",e[e.IncludeAnonymous=2]="IncludeAnonymous",e[e.IgnoreMounts=4]="IgnoreMounts",e[e.IgnoreOverlays=8]="IgnoreOverlays"}(yr||(yr={})),new gr({perNode:!0});let Er=0;class wr{constructor(e,t,r,a){this.name=e,this.set=t,this.base=r,this.modified=a,this.id=Er++}toString(){let{name:e}=this;for(let t of this.modified)t.name&&(e=`${t.name}(${e})`);return e}static define(e,t){let r="string"==typeof e?e:"?";if(e instanceof wr&&(t=e),null==t?void 0:t.base)throw new Error("Can not derive from a modified tag");let a=new wr(r,[],null,[]);if(a.set.push(a),t)for(let e of t.set)a.set.push(e);return a}static defineModifier(e){let t=new Cr(e);return e=>e.modified.indexOf(t)>-1?e:Cr.get(e.base||e,e.modified.concat(t).sort(((e,t)=>e.id-t.id)))}}let kr=0;class Cr{constructor(e){this.name=e,this.instances=[],this.id=kr++}static get(e,t){if(!t.length)return e;let r=t[0].instances.find((r=>{return r.base==e&&(a=t,o=r.modified,a.length==o.length&&a.every(((e,t)=>e==o[t])));var a,o}));if(r)return r;let a=[],o=new wr(e.name,a,e,t);for(let e of t)e.instances.push(o);let l=function(e){let t=[[]];for(let r=0;r<e.length;r++)for(let a=0,o=t.length;a<o;a++)t.push(t[a].concat(e[r]));return t.sort(((e,t)=>t.length-e.length))}(t);for(let t of e.set)if(!t.modified.length)for(let e of l)a.push(Cr.get(t,e));return o}}new gr;const $r=wr.define,Sr=$r(),Ir=$r(),Tr=$r(Ir),Fr=$r(Ir),Rr=$r(),Mr=$r(Rr),Lr=$r(Rr),Or=$r(),Ar=$r(Or),Pr=$r(),Nr=$r(),Dr=$r(),Br=$r(Dr),Hr=$r(),Vr={comment:Sr,lineComment:$r(Sr),blockComment:$r(Sr),docComment:$r(Sr),name:Ir,variableName:$r(Ir),typeName:Tr,tagName:$r(Tr),propertyName:Fr,attributeName:$r(Fr),className:$r(Ir),labelName:$r(Ir),namespace:$r(Ir),macroName:$r(Ir),literal:Rr,string:Mr,docString:$r(Mr),character:$r(Mr),attributeValue:$r(Mr),number:Lr,integer:$r(Lr),float:$r(Lr),bool:$r(Rr),regexp:$r(Rr),escape:$r(Rr),color:$r(Rr),url:$r(Rr),keyword:Pr,self:$r(Pr),null:$r(Pr),atom:$r(Pr),unit:$r(Pr),modifier:$r(Pr),operatorKeyword:$r(Pr),controlKeyword:$r(Pr),definitionKeyword:$r(Pr),moduleKeyword:$r(Pr),operator:Nr,derefOperator:$r(Nr),arithmeticOperator:$r(Nr),logicOperator:$r(Nr),bitwiseOperator:$r(Nr),compareOperator:$r(Nr),updateOperator:$r(Nr),definitionOperator:$r(Nr),typeOperator:$r(Nr),controlOperator:$r(Nr),punctuation:Dr,separator:$r(Dr),bracket:Br,angleBracket:$r(Br),squareBracket:$r(Br),paren:$r(Br),brace:$r(Br),content:Or,heading:Ar,heading1:$r(Ar),heading2:$r(Ar),heading3:$r(Ar),heading4:$r(Ar),heading5:$r(Ar),heading6:$r(Ar),contentSeparator:$r(Or),list:$r(Or),quote:$r(Or),emphasis:$r(Or),strong:$r(Or),link:$r(Or),monospace:$r(Or),strikethrough:$r(Or),inserted:$r(),deleted:$r(),changed:$r(),invalid:$r(),meta:Hr,documentMeta:$r(Hr),annotation:$r(Hr),processingInstruction:$r(Hr),definition:wr.defineModifier("definition"),constant:wr.defineModifier("constant"),function:wr.defineModifier("function"),standard:wr.defineModifier("standard"),local:wr.defineModifier("local"),special:wr.defineModifier("special")};for(let e in Vr){let t=Vr[e];t instanceof wr&&(t.name=e)}!function(e,t){let r=Object.create(null);for(let t of e)if(Array.isArray(t.tag))for(let e of t.tag)r[e.id]=t.class;else r[t.tag.id]=t.class;let{scope:a,all:o=null}={}}([{tag:Vr.link,class:"tok-link"},{tag:Vr.heading,class:"tok-heading"},{tag:Vr.emphasis,class:"tok-emphasis"},{tag:Vr.strong,class:"tok-strong"},{tag:Vr.keyword,class:"tok-keyword"},{tag:Vr.atom,class:"tok-atom"},{tag:Vr.bool,class:"tok-bool"},{tag:Vr.url,class:"tok-url"},{tag:Vr.labelName,class:"tok-labelName"},{tag:Vr.inserted,class:"tok-inserted"},{tag:Vr.deleted,class:"tok-deleted"},{tag:Vr.literal,class:"tok-literal"},{tag:Vr.string,class:"tok-string"},{tag:Vr.number,class:"tok-number"},{tag:[Vr.regexp,Vr.escape,Vr.special(Vr.string)],class:"tok-string2"},{tag:Vr.variableName,class:"tok-variableName"},{tag:Vr.local(Vr.variableName),class:"tok-variableName tok-local"},{tag:Vr.definition(Vr.variableName),class:"tok-variableName tok-definition"},{tag:Vr.special(Vr.variableName),class:"tok-variableName2"},{tag:Vr.definition(Vr.propertyName),class:"tok-propertyName tok-definition"},{tag:Vr.typeName,class:"tok-typeName"},{tag:Vr.namespace,class:"tok-namespace"},{tag:Vr.className,class:"tok-className"},{tag:Vr.macroName,class:"tok-macroName"},{tag:Vr.propertyName,class:"tok-propertyName"},{tag:Vr.operator,class:"tok-operator"},{tag:Vr.comment,class:"tok-comment"},{tag:Vr.meta,class:"tok-meta"},{tag:Vr.invalid,class:"tok-invalid"},{tag:Vr.punctuation,class:"tok-punctuation"}]);const zr=E.default({theme:"dark",settings:{background:"var(--base-bg-secondary)",foreground:"var(--control-bg-secondary)",selection:"var(--control-bg-light-selected);",selectionMatch:"var(--control-bg-light-selected)",lineHighlight:"var(--control-bg-light-selected)",gutterBorder:"var(--control-bg-neutral-emphasis)",gutterBackground:"var(--base-bg-secondary)",gutterForeground:"var(--control-text-neutral)"},styles:[{tag:Vr.propertyName,color:"var(--base-text-code-keys)"},{tag:Vr.string,color:"var(--base-text-code-values)"},{tag:Vr.number,color:"var(--base-text-code-values)"},{tag:Vr.punctuation,color:"var(--base-text-primary)"},{tag:Vr.operator,color:"var(--base-text-primary)"},{tag:Vr.brace,color:"var(--base-text-primary)"}]}),Wr=y.default(w.default)`
  overflow: hidden;
  flex-grow: 1;

  width: 100%;
  padding-left: var(--layout-spoon);

  font: var(--code-xs);

  background-color: var(--base-bg-secondary);

  .cm-scroller {
    line-height: var(--layout-shoe);
  }

  .cm-line {
    padding-left: var(--layout-shoe);
  }
`,jr=[s.json()],qr=({content:e,handleEditorCreate:t})=>h.default.createElement(Wr,{value:e.rawCode,theme:zr,extensions:jr,editable:!1,onCreateEditor:t,basicSetup:{lineNumbers:!0}}),Gr=y.default(qt)`
  overflow: hidden;
  flex-direction: column;
  justify-content: flex-end;

  min-width: 540px;
  min-height: 296px;
  margin-bottom: var(--layout-spoon);

  transition: height 0.3s ease;
`,Kr=y.default(qt)`
  position: relative;
`,Ur=y.default.div`
  position: absolute;
  bottom: 0;

  width: 100%;
  height: 40px;

  background: linear-gradient(0deg, var(--base-bg-secondary) 0%, rgb(29 34 43 / 0%) 58.27%);
`,Zr=y.default(qt)`
  overflow: ${({$isExpanded:e,$hasOverflow:t})=>!e&&t?"auto":"hidden"};

  width: 100%;
  height: ${({$isExpanded:e})=>e?"auto":"112px"};
  min-height: 112px;

  transition: height 0.3s ease-in-out;
`,_r=y.default(ze)`
  padding: var(--layout-spoon);
  padding-bottom: var(--layout-stamp);
  background: var(--base-bg-secondary);
`,Yr=y.default(A)`
  font: var(--heading-xs);
  color: var(--base-text-primary);
`,Xr="transform 300ms cubic-bezier(0.5, -0.4, 0, 1) 100ms",Jr=y.default.div`
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
`,Qr=y.default(ze)`
  display: flex;
  flex-direction: column;

  width: 490px;
  height: 100vh;
  padding-top: var(--layout-shoebox);

  background-color: var(--base-bg-primary);
  border-left: var(--border-b-seed) solid var(--base-border-secondary);
  box-shadow: var(--control-e-spoon);

  &.drawer-enter {
    transform: translateX(100%);
  }

  &.drawer-enter-active {
    transform: translateX(0);
    transition: ${Xr};
  }

  &.drawer-enter-done {
    transform: translateX(0);
  }

  &.drawer-exit {
    transform: translateX(0);
  }

  &.drawer-exit-active {
    transform: translateX(100%);
    transition: ${Xr};
  }
`,ea=y.default(ze)`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  margin-bottom: var(--layout-shoebox);
  padding: var(--layout-sandgrain) var(--layout-shoebox);
`,ta=y.default(ze)`
  overflow: hidden auto;
  justify-content: center;

  width: 100%;
  height: 100%;
  padding: var(--layout-sandgrain) var(--layout-shoebox) var(--layout-shoebox);
`,ra=y.default(ze)`
  margin-left: var(--layout-shoe);
  opacity: ${({open:e})=>e?"1":"0"};
  transition: opacity 100ms linear;
`,aa=y.default.hr`
  display: inline-block;

  width: 100%;
  margin: 0;

  opacity: ${({open:e})=>e?"1":"0"};
  border: var(--border-b-sandgrain);
  border-top: 1px solid var(--base-border-secondary);

  transition: opacity 100ms linear;
`,oa=y.default(me).attrs((()=>({variant:"unstyled"})))`
  padding: var(--layout-seed);
  color: var(--action-icon-secondary);
`,la=({...e})=>h.default.createElement(oa,e,h.default.createElement(o.IconActionCross,null)),[na,da]=ke({hookName:"useDrawerContext",providerName:"DrawerProvider"}),ia=h.default.forwardRef((({onClose:t,children:r,headerTitle:a,headerActions:o,...l},d)=>{const[s,c]=e.useState(!1),[u,b]=e.useState(!1),f=e.useRef(null),v=e.useRef(null),{context:p,...m}=da(),g=i.useMergeRefs([d,m.refs.setFloating]);return e.useEffect((()=>{p.open&&b(!0)}),[p.open]),e.useEffect((()=>{const e=()=>{const e=f.current?.scrollTop??0;c(e>20)},t=new MutationObserver((()=>{const r=f.current;r&&(r.addEventListener("scroll",e),t.disconnect())}));return t.observe(document.body,{childList:!0,subtree:!0}),()=>{const r=f.current;r&&r.removeEventListener("scroll",e),t.disconnect()}}),[]),p.open||u?h.default.createElement(i.FloatingPortal,null,h.default.createElement(i.FloatingFocusManager,{context:p},h.default.createElement(Jr,T({ref:g},m.getFloatingProps(l)),h.default.createElement(n.CSSTransition,{in:p.open&&u,nodeRef:v,timeout:400,unmountOnExit:!0,onExited:()=>b(!1),classNames:"drawer"},h.default.createElement(Qr,{ref:v},h.default.createElement(ea,null,h.default.createElement(qt,{flexDirection:"row"},o,a&&h.default.createElement(ra,{open:s},a)),h.default.createElement(la,{"aria-label":"Close Drawer",onClick:t})),a&&h.default.createElement(aa,{open:s}),h.default.createElement(ta,{ref:f},r)))))):null})),sa=h.forwardRef((({children:e,...t},r)=>{const a=da(),o=e.ref,l=i.useMergeRefs([a.refs.setReference,r,o]);return h.isValidElement(e)?h.cloneElement(e,a.getReferenceProps({ref:l,...t,...e.props,"data-state":a.open?"open":"closed",className:`${e.props.className} drawer-trigger`})):null})),ca=y.default(ze)`
  background-color: var(--control-bg-primary);
  border-radius: var(--border-r-seed);
  box-shadow: var(--control-e-spoon);
`,ua=({anchor:r,onClose:a,children:o})=>{const[l,n]=e.useState(),{styles:d,attributes:i}=t.usePopper(r,l,{placement:"bottom-end",modifiers:[{name:"offset",options:{offset:[0,4]}}]});return r?h.default.createElement(x.default,{onOutsideClick:a},h.default.createElement(ca,T({ref:n,style:d.popper},i.popper),o)):null},ba=y.default(ze)`
  cursor: pointer;
  padding: var(--layout-soybean) var(--layout-stamp);
  border-radius: var(--border-r-seed);

  svg {
    min-width: var(--layout-spoon);
    margin-right: ${({iconStart:e})=>e?"var(--layout-soybean)":"var(--layout-sandgrain)"};
    margin-left: ${({iconEnd:e})=>e?"var(--layout-soybean)":"var(--layout-sandgrain)"};
  }

  ${({iconStart:e,iconEnd:t})=>e&&t&&a.css`
      svg:nth-of-type(1) {
        margin-left: var(--layout-sandgrain);
      }

      svg:nth-of-type(2) {
        margin-right: var(--layout-sandgrain);
      }
    `}

  &:not(:last-child) {
    margin-bottom: var(--layout-seed);
  }

  &:hover {
    background-color: var(--control-bg-decorative-hover);
  }

  &:focus {
    outline: var(--border-b-stamp) solid var(--control-border-focus-ring);
  }
`,fa=y.default(A)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`,va=({title:e,iconStart:t,iconEnd:r,onClick:a})=>h.default.createElement(ba,{tabIndex:0,title:e,iconStart:t,iconEnd:r,onClick:a},h.default.createElement(qt,{alignItems:"center"},t&&h.default.createElement(t,null),h.default.createElement(fa,null,e),r&&h.default.createElement(r,null))),pa=y.default(A)`
  user-select: none;

  overflow: hidden;

  padding: var(--layout-soybean) var(--layout-stamp);

  font: var(--body-xs-emphasis);
  text-overflow: ellipsis;
  white-space: nowrap;
`,ma=({title:e,actions:t})=>h.default.createElement(h.default.Fragment,null,h.default.createElement(pa,null,e),t.map((e=>h.default.createElement(va,T({key:e.id},e))))),ga=y.default(ze)`
  overflow-y: auto;
  max-width: 320px;
  max-height: 320px;
  padding: var(--layout-soybean);
`,ha=({actions:t,...r})=>{const[a,o]=e.useMemo((()=>t.reduce((([e,t],r)=>r.actions?[[...e,r],t]:[e,[...t,r]]),[[],[]])),[t]);return h.default.createElement(ua,r,h.default.createElement(ga,null,o.map((e=>h.default.createElement(va,T({key:e.id},e)))),a.map((e=>h.default.createElement(ma,T({key:e.id},e))))))},[xa,ya]=ke({hookName:"useActionMenuContext",providerName:"ActionMenu"}),Ea=({children:t})=>{const r=(()=>{const[t,r]=e.useState(!1),a=()=>{r(!0)},o=()=>{r(!1)},{context:l,floatingStyles:n,refs:d}=i.useFloating({middleware:[i.flip({crossAxis:!0,fallbackAxisSideDirection:"end",padding:4}),i.offset(4),i.shift({padding:4})],onOpenChange:r,open:t,placement:"bottom-start",whileElementsMounted:i.autoUpdate}),[s,c]=e.useState(null),u=e.useRef([]),b=i.useListNavigation(l,{activeIndex:s,listRef:u,onNavigate:c}),f=i.useDismiss(l),{getFloatingProps:v}=i.useInteractions([b,f]);return e.useMemo((()=>({activeIndex:s,context:l,closeMenu:o,floatingStyles:n,getFloatingProps:v,listRef:u,isOpen:t,openMenu:a,refs:d,setActiveIndex:c})),[s,l,o,n,v,u,t,a,d,c])})();return h.default.createElement(xa,{value:r},t)},wa=({children:e})=>h.default.createElement(Ea,null,e),ka=e.forwardRef((({children:e,prefix:t,size:r,...a},o)=>h.default.createElement(me,T({ref:o,variant:"destructive",size:r},a),"sm"!==r&&t,e))),Ca=e.forwardRef((({children:e,prefix:t,size:r,...a},o)=>h.default.createElement(me,T({ref:o,variant:"primary",size:r},a),"sm"!==r&&t,e))),$a=e.forwardRef((({children:e,prefix:t,suffix:r,size:a,...o},l)=>h.default.createElement(me,T({ref:l,variant:"secondary",size:a},o),"sm"!==a&&t,e,"sm"!==a&&r))),Sa=y.default(Zt)`
  display: inline-block;
  margin: var(--layout-soybean) var(--layout-sandgrain);
`,Ia=y.default.div`
  display: flex;
  flex-direction: column;
`,Ta=y.default.div`
  font: var(--body-xs-emphasis);
  margin: var(--layout-seed) var(--layout-soybean);
`,Fa=y.default(me)`
  display: flex;
  flex-direction: row;
  gap: var(--layout-soybean);
  align-items: center;

  width: 100%;
  margin-bottom: var(--layout-seed);
  padding: var(--layout-seed) var(--layout-soybean);

  font: var(--body-xs);
  color: var(--control-text-primary);

  background-color: var(--base-bg-floating);

  &:last-of-type {
    margin-bottom: 0;
  }

  svg {
    color: var(--control-icon-primary);
  }

  :hover {
    color: var(--control-text-hover);
    background-color: var(--control-bg-decorative-hover);

    svg {
      color: var(--control-icon-hover);
    }
  }

  :focus {
    color: var(--control-text-focus);
    background-color: var(--control-bg-decorative-focus);

    svg {
      color: var(--control-icon-focus);
    }
  }

  :disabled {
    color: var(--control-text-disabled);
    background-color: var(--control-bg-primary-disabled);

    svg {
      color: var(--control-icon-disabled);
    }
  }
`,Ra=e.forwardRef((({"aria-haspopup":t,"aria-expanded":r,children:a,disabled:o,icon:l,onClick:n,...d},s)=>{const{index:c,ref:u}=i.useListItem(),b=i.useMergeRefs([s,u]),f="dialog"===t,[v,p]=e.useState(!f&&void 0),{activeIndex:m,closeMenu:g}=ya();return e.useEffect((()=>{"true"===r?p(!0):"false"===r&&v&&(g(),p(!1))}),[r]),h.default.createElement(Fa,T({},d,{"aria-expanded":r,"aria-haspopup":t,onClick:()=>{!o&&n&&(n(),f||g())},ref:b,role:"menuitem",tabIndex:m===c?0:-1,variant:"secondary"}),l,a)})),Ma=y.default.menu`
  min-width: 180px;
  max-width: 400px;
  margin: var(--layout-sandgrain);
  padding: var(--layout-soybean);

  background-color: var(--base-bg-floating);
  border: var(--border-b-seed) solid var(--base-border-secondary);
  border-radius: var(--border-r-stamp);
  box-shadow: var(--control-e-spoon);
`,La=()=>h.default.createElement("svg",{"data-testid":"loader-icon",version:"1.1",id:"loader-1",x:"0px",y:"0px",width:"16px",height:"16px",viewBox:"0 0 50 50",role:"status","aria-label":"Loading","aria-live":"polite"},h.default.createElement("path",{fill:"var(--action-icon-disabled)",d:"M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"},h.default.createElement("animateTransform",{attributeType:"xml",attributeName:"transform",type:"rotate",from:"0 25 25",to:"360 25 25",dur:"0.85s",repeatCount:"indefinite"}))),Oa=a.css`
  cursor: pointer;

  text-align: center;

  border-radius: var(--border-r-seed);

  transition: 0.2s;
  transition-property: background-color, border-color, box-shadow;
`,Aa=a.css`
  &:disabled {
    cursor: not-allowed;

    color: var(--action-text-disabled);

    background-color: var(--action-bg-disabled);
    border: var(--border-b-seed) solid var(--action-border-disabled);
    box-shadow: var(--control-e-sandgrain);

    &:focus {
      outline: none;
    }

    svg {
      color: var(--action-icon-disabled);
    }
  }
`,Pa=a.css`
  display: inline-flex;
  align-items: center;
  width: ${({fullWidth:e})=>e?"100%":""};

  button + & {
    margin-left: var(--layout-spoon);
  }

  svg {
    margin-right: ${({iconStart:e})=>e?"var(--layout-soybean)":"var(--layout-sandgrain)"};
    margin-left: ${({iconEnd:e})=>e?"var(--layout-soybean)":"var(--layout-sandgrain)"};
    vertical-align: middle;
  }

  &:disabled {
    ${({isLoading:e})=>e&&"svg { color: var(--action-icon-disabled); }"}
  }
`,Na=y.default.button((()=>a.css`
    ${l.variant({variants:{small:{padding:"calc(var(--layout-seed) - var(--border-b-seed)) calc(var(--layout-soybean) - var(--border-b-seed))",font:"var(--legacy-sm)"},medium:{padding:"calc(var(--layout-seed) - var(--border-b-seed)) calc(var(--layout-stamp) - var(--border-b-seed))",font:"var(--body-xs)"},large:{padding:"calc(var(--layout-soybean) - var(--border-b-seed)) calc(var(--layout-spoon) - var(--border-b-seed))",font:"var(--body-xs)"}}})}

    ${Pa}
    ${Oa}
  `)),Da=e.forwardRef((({isLoading:e,disabled:t,children:r,variant:a="medium",iconEnd:o,iconStart:l,fullWidth:n=!1,loadingMessage:d="Loading...",...i},s)=>{const c="small"!==a;return h.default.createElement(Na,T({ref:s,disabled:t||e,variant:a,iconStart:l,iconEnd:o,fullWidth:n,isLoading:e},i),c&&l&&(e?h.default.createElement(La,null):h.default.createElement(l,null)),e?d:r,c&&o&&(e?h.default.createElement(La,null):h.default.createElement(o,null)))})),Ba=a.css`
  border: none;
  font: var(--body-xs-medium);
  background: var(--action-bg-secondary);
  color: var(--action-text-secondary);

  &:hover {
    background: var(--action-bg-decorative-hover);
    color: var(--action-text-secondary-hover);
  }

  &:focus {
    outline: var(--border-b-soybean) solid var(--action-border-focus-ring);
    background: var(--action-bg-decorative-focus);
    color: var(--action-text-secondary-focus);
  }

  &:active {
    background: var(--action-bg-decorative-pressed);
    color: var(--action-text-secondary-pressed);
  }

  &:disabled {
    background: var(--action-bg-disabled);
    color: var(--action-text-disabled);
    &:hover {
      background: var(--action-bg-disabled);
      color: var(--action-text-disabled);
    }

    &:focus,
    &:focus-visible {
      background: var(--action-bg-disabled);
      color: var(--action-text-disabled);
    }

    &:active {
      background: var(--action-bg-disabled);
      color: var(--action-text-disabled);
    }
  }
`,Ha=y.default(Da)`
  ${Ba}
`,Va=a.css`
  border: none;
  font: var(--body-xs-medium);
  background: var(--action-bg-secondary);
  color: var(--action-text-secondary);

  &:hover {
    background: var(--action-bg-decorative-hover);
    color: var(--action-text-secondary-hover);
  }

  &:focus {
    outline: var(--border-b-soybean) solid var(--action-border-focus-ring);
    background: var(--action-bg-decorative-focus);
    color: var(--action-text-secondary-focus);
  }

  &:active {
    background: var(--action-bg-decorative-pressed);
    color: var(--action-text-secondary-pressed);
  }

  &:disabled {
    background: var(--action-bg-disabled);
    color: var(--action-text-disabled);
    &:hover {
      background: var(--action-bg-disabled);
      color: var(--action-text-disabled);
    }

    &:focus,
    &:focus-visible {
      background: var(--action-bg-disabled);
      color: var(--action-text-disabled);
    }

    &:active {
      background: var(--action-bg-disabled);
      color: var(--action-text-disabled);
    }
  }
`,za=y.default(Da)`
  ${Va}
`,Wa=a.css`
  padding: calc(var(--layout-soybean) - var(--border-b-seed));
  font: var(--body-xs);
  line-height: 0;

  button + & {
    margin-left: var(--layout-spoon);
  }

  svg {
    vertical-align: middle;
  }
`,ja=y.default.button`
  ${Oa}
  ${({variant:e})=>"secondary"===e?Va:Ba};
  ${Wa}

  &:disabled {
    ${Aa};
  }
`,qa=e.forwardRef((({icon:e,variant:t="secondary",isLoading:r,disabled:a,...o},l)=>h.default.createElement(ja,T({ref:l,disabled:a||r,variant:t},o),r?h.default.createElement(La,null):h.default.createElement(e,null)))),Ga=e.forwardRef(((e,t)=>{const{hasFlag:r}=I();return r("v10")?h.default.createElement(Ot,T({ref:t},e)):h.default.createElement(qa,T({ref:t},e))})),Ka=a.css`
  border: none;
  font: var(--body-xs-medium);

  background: var(--action-bg-primary);
  color: var(--action-text-oninvert-primary);

  &:hover {
    background: var(--action-bg-hover);
    color: var(--action-text-oninvert-hover);
  }

  &:focus,
  &:focus-visible {
    background: var(--action-bg-focus);
    color: var(--action-text-oninvert-focus);
    outline: var(--border-b-soybean) solid var(--action-border-focus-ring);
  }

  &:active {
    background: var(--action-bg-pressed);
    color: var(--action-text-oninvert-pressed);
  }

  &:disabled {
    background: var(--action-bg-disabled);
    color: var(--action-text-disabled);
    &:hover {
      background: var(--action-bg-disabled);
      color: var(--action-text-disabled);
    }

    &:focus,
    &:focus-visible {
      background: var(--action-bg-disabled);
      color: var(--action-text-disabled);
    }

    &:active {
      background: var(--action-bg-disabled);
      color: var(--action-text-disabled);
    }
  }
`,Ua=y.default(Da)`
  ${Ka}
`,Za=e.forwardRef(((e,t)=>{const{hasFlag:r}=I();return r("v10")?h.default.createElement(Ca,T({ref:t},e)):h.default.createElement(Ua,T({ref:t},e))})),_a=e.forwardRef(((e,t)=>{const{hasFlag:r}=I();return r("v10")?h.default.createElement($a,T({ref:t},e)):h.default.createElement(za,T({ref:t},e))})),Ya=a.css`
  background-color: #ffffff;
  border: var(--border-b-seed) solid var(--action-border-destructive-default);
  color: var(--action-text-destructive-default);
  box-shadow: var(--control-e-sandgrain);

  svg {
    color: var(--action-icon-destructive-default);
  }

  &:hover {
    border-color: var(--action-border-destructive-hover);
    box-shadow: var(--control-e-spoon);
    color: var(--action-text-destructive-hover);
    svg {
      color: var(--action-icon-destructive-hover);
    }
  }
  &:focus {
    border-color: var(--action-border-destructive-focus);
    box-shadow: var(--control-e-spoon);
    color: var(--action-text-destructive-focus);
    outline: var(--border-b-stamp) solid var(--control-border-focus-ring);
    svg {
      color: var(--action-icon-destructive-focus);
    }
  }
  &:active {
    border-color: var(--action-border-destructive-pressed);
    box-shadow: var(--control-e-spoon);
    color: var(--action-text-destructive-pressed);
    svg {
      color: var(--action-icon-destructive-pressed);
    }
  }

  ${Aa}
`,Xa=y.default(Da)`
  ${Ya}
`,Ja=y.default.button.attrs((({type:e})=>({type:e||"button"})))`
  border-radius: var(--border-r-seed);
  background-color: inherit;
  color: inherit;
  font: inherit;
  border-width: var(--border-b-sandgrain);
  padding: var(--layout-sandgrain);
  cursor: pointer;
  &:focus {
    outline: var(--control-border-focus-ring) solid var(--border-b-stamp);
    color: var(--control-text-focus);
  }
  &:disabled {
    color: var(--control-text-disabled);
    cursor: not-allowed;
  }
  &:hover {
    color: var(--control-text-hover);
  }
  span {
    font: inherit;
  }
`,Qa=a.css`
  background: var(--action-bg-destructive-default);
  border: var(--border-b-seed) solid transparent;
  box-shadow: var(--control-e-sandgrain);
  color: var(--action-text-oninvert-destructive-default);

  svg {
    color: var(--action-icon-oninvert-destructive-default);
  }

  &:hover {
    background: var(--action-bg-destructive-hover);
    box-shadow: var(--control-e-spoon);
    color: var(--action-text-oninvert-hover);
    svg {
      color: var(--action-icon-oninvert-destructive-hover);
    }
  }

  &:focus {
    background: var(--action-bg-destructive-focus);
    box-shadow: var(--control-e-spoon);
    color: var(--action-text-oninvert-focus);
    outline: var(--border-b-stamp) solid var(--action-border-focus-ring);
    svg {
      color: var(--action-icon-oninvert-destructive-focus);
    }
  }

  &:active {
    background: var(--action-bg-destructive-pressed);
    box-shadow: var(--control-e-spoon);
    color: var(--action-text-oninvert-pressed);
    svg {
      color: var(--action-icon-oninvert-destructive-pressed);
    }
  }

  ${Aa}
`,eo=y.default(Da)`
  ${Qa}
`,[to,ro]=ke({hookName:"useFilterMenuContext",providerName:"FilterMenu"}),ao=y.default.div`
  align-items: center;
  background-color: var(--control-bg-neutral-emphasis);
  border-radius: var(--border-r-pill);
  color: var(--control-text-oninvert-selected);
  display: inline-flex;
  font-size: var(--body-xs);
  height: 20px;
  justify-content: center;
  min-width: 20px;
  padding-inline: var(--layout-seed);
  text-align: center;
  ${l.space};
  ${l.layout};
  ${l.flexbox};
`,oo=h.default.forwardRef((({count:t=0,children:r="Filter",...a},l)=>{const n=ro(),d=r.ref,s=i.useMergeRefs([n.refs.setReference,l,d]),c=e.useMemo((()=>t>0&&t<=99?t:t>99?"99+":void 0),[t]);return h.default.createElement($a,T({ref:s,prefix:h.default.createElement(o.IconActionFilter,null)},c&&{suffix:h.default.createElement(ao,{"data-testid":"badge-btn-value"},c)},{onClick:()=>n.onOpenChange(),"data-state":n.open?"open":"closed"},n.getReferenceProps(a)),r)})),lo=y.default(ze)`
  ${({noMaxHeight:e})=>`\n  display: flex;\n  flex-direction: column;\n  gap: var(--layout-spoon);\n  background-color: var(--base-bg-floating);\n  border: var(--border-b-seed) solid var(--base-border-secondary);\n  border-radius: var(--border-r-stamp);\n  box-shadow: var(--control-e-shoe);\n  overflow: hidden;\n  padding: var(--layout-spoon);\n  position: relative;\n  min-width: 320px;\n  max-width: 920px;\n  ${!e&&"max-height: 500px;"}\n  z-index: 10000;\n  `}
`,no=h.default.forwardRef((({style:e,noMaxHeight:t=!1,...r},a)=>{const{context:o,...l}=ro(),n=i.useMergeRefs([l.refs.setFloating,a]);return o.open?h.default.createElement(i.FloatingPortal,null,h.default.createElement(i.FloatingFocusManager,{context:o,modal:l.modal},h.default.createElement(lo,T({ref:n,style:{...l.floatingStyles,...e},noMaxHeight:t},l.getFloatingProps(r)),r.children))):null})),io=y.default("div")`
  overflow-y: auto;
  width: 100%;
  border-radius: var(--border-r-stamp);
`,so=y.default("div")`
  display: flex;
  gap: var(--layout-soybean);
  width: 100%;
  align-items: center;
  ${l.flexbox}
`,co=y.default(Ot)`
  max-height: 32px;
  padding: var(--layout-soybean);
`,uo=y.default.div`
  display: flex;
  flex-direction: row;
  gap: var(--layout-sandgrain) var(--layout-soybean);
  align-items: flex-end;

  width: 100%;
`,bo=y.default.div`
  flex: 0 0 25%;
`,fo=y.default.div`
  flex: 1 0 25%;
`,vo=y.default(qt)`
  flex-direction: column;
  gap: var(--layout-spoon) var(--layout-sandgrain);
  width: 100%;
`,po="\n  text-decoration: none;\n  font: var(--body-xs);\n  color: var(--action-text-primary);\n  padding: var(--layout-seed);\n  border-radius: var(--border-r-seed);\n  transition: 0.2s;\n  border-width: var(--border-b-sandgrain);\n\n  &:hover {\n    color: var(--action-text-hover);\n    text-decoration: underline;\n  }\n\n  &:focus {\n    color: var(--action-text-focus);\n    outline: var(--border-b-stamp) solid var(--action-border-focus-ring);\n    text-decoration: underline;\n  }\n\n  &:active {\n    text-decoration: underline;\n  }\n\n  &:visited {\n    color: var(--action-text-visited);\n    text-decoration: underline;\n  }\n",mo=y.default.a`
  ${po}
`,go=h.default.forwardRef((({badgeValue:e,children:t,...r},a)=>h.default.createElement($a,T({ref:a,suffix:e?h.default.createElement(ao,{"data-testid":"badge-btn-value"},e):void 0},r),t))),ho=y.default.div`
  font: var(--body-xs);
  color: var(--control-text-secondary);
`,xo=y.default.div`
  position: absolute;
  top: auto;
  left: -10000px;

  overflow: hidden;

  width: 1px;
  height: 1px;
`,yo=({currentLength:e,id:t,maximumLength:r,...a})=>{const o=r-e;return h.default.createElement(h.default.Fragment,null,h.default.createElement(ho,T({},a,{"aria-hidden":"true","data-testid":"character-count"}),e,"/",r),h.default.createElement(xo,{id:t},"You can enter up to ",r," characters"),h.default.createElement(xo,{"aria-live":"polite"},"You have ",o," characters remaining"))},Eo=y.default.div`
  width: 100%;
`,wo=a.keyframes`
  0%, 100% {
    background-color: var(--control-bg-neutral-decorative);
  }

  50% {
    background-color: var(--control-bg-secondary);
  }
`,ko=a.css`
  background-color: var(--control-bg-neutral-decorative);
  animation: ${wo} 1.5s ease-in-out infinite;

  @media (prefers-reduced-motion) {
    animation: none !important;
  }
`,Co=y.default.div`
  width: 16px;
  height: 16px;
  border-radius: var(--border-r-circle);
  ${ko}
`,$o=y.default.div`
  width: 68px;
  height: 32px;
  border-radius: var(--border-r-seed);
  ${ko}
`,So=({...e})=>h.default.createElement($o,T({"aria-hidden":"true"},e)),Io=y.default.div`
  display: flex;
  flex-direction: column;
  gap: var(--layout-spoon);
  width: 100%;

  ${({isReversed:e,numberOfLines:t})=>t>1&&a.css`
      &>*: ${e?"last":"first"}-child {
        width: 66.66%;
      }
    `}
`,To=14,Fo=16,Ro=20,Mo=28,Lo=24,Oo=24,Ao=32,Po={xs:To,sm:Fo,md:Ro,lg:Mo},No=(e,t)=>(e-t)/2+"px",Do={xs:`${No(24,To)} var(--layout-sandgrain)`,sm:`${No(Lo,Fo)} var(--layout-sandgrain)`,md:`${No(Oo,Ro)} var(--layout-sandgrain)`,lg:`${No(Ao,Mo)} var(--layout-sandgrain)`},Bo=y.default.div`
  width: 100%;
  height: ${({size:e})=>Po[e]}px;
  margin: ${({size:e})=>Do[e]};
  border-radius: var(--border-r-shoe);
  ${ko}
`,Ho=({numberOfLines:e=1,isReversed:t=!1,size:r="sm",...a})=>{const o=Math.max(e,1),l=Array.from({length:o},((t,a)=>h.default.createElement(Bo,{size:r,key:`skeleton-text-${e}-${a}`})));return h.default.createElement(Io,T({"aria-hidden":"true",isReversed:t,numberOfLines:o},a),l)},Vo=y.default(A)`
  color: var(--control-text-secondary);
`,zo=y.default(Ho)`
  width: 80%;
`,Wo=({children:e,...t})=>h.default.createElement(Vo,t,e),jo=()=>h.default.createElement(zo,{size:"xs"}),qo=y.default.div`
  display: flex;
  gap: var(--layout-soybean);
`,Go=y.default.div`
  width: 16px;
  height: 16px;

  /* centered to first line of warning text if long enough to wrap */
  margin-top: var(--layout-seed);
  color: var(--control-icon-bad);
`,Ko=y.default(A)`
  color: var(--control-text-bad);
`,Uo=({children:e,...t})=>h.default.createElement(qo,T({"data-testid":"form-error",role:"alert"},t),h.default.createElement(Go,null,h.default.createElement(o.IconActionAlert,null)),h.default.createElement(Ko,null,e)),Zo=y.default.div`
  display: flex;
  gap: var(--layout-soybean);
`,_o=y.default.div`
  width: 16px;
  height: 16px;

  /* centered to first line of warning text if long enough to wrap */
  margin-top: var(--layout-seed);
  color: var(--control-icon-warn);
`,Yo=y.default(A)`
  color: var(--control-text-warn);
`,Xo=({children:e,...t})=>h.default.createElement(Zo,T({"data-testid":"form-warning"},t),h.default.createElement(_o,null,h.default.createElement(o.IconActionAlert,null)),h.default.createElement(Yo,null,e)),[Jo,Qo]=ke({strict:!1}),el=y.default(A)`
  display: inline-block;
  font: var(--body-xs-emphasis);
  color: var(--control-text-primary);
  ${({hidden:e})=>e&&"display: none;"}
`,tl=y.default(Ho)`
  width: 50%;
`,rl=({isRequired:e,hidden:t=!1,children:r,as:a,...o})=>h.default.createElement(el,T({as:a??"label",hidden:t},o),r," ",!e&&"(optional)"),al=()=>h.default.createElement(tl,{size:"sm"}),ol=y.default.fieldset`
  display: flex;
  flex-direction: column;
  gap: var(--layout-soybean);

  margin: var(--layout-sandgrain);
  padding: var(--layout-sandgrain);

  border: none;
`,ll=y.default(rl)`
  padding: var(--layout-sandgrain);
`,nl=({children:t,label:r,isRequired:a=!1,helpText:o,errorText:l,warningText:n,role:d,disabled:i=!1,...s})=>{const c=e.useId(),u=e.useId(),b=Boolean(l);return h.default.createElement(ol,T({"aria-describedby":c},"radiogroup"===d&&{"aria-invalid":Boolean(l),"aria-required":a},"radiogroup"===d&&b&&{"aria-errormessage":u},{role:d,disabled:i},s),h.default.createElement(Jo,{value:{disabled:i,hasError:b}},h.default.createElement("div",null,h.default.createElement(ll,{isRequired:a,forwardedAs:"legend"},r),o&&h.default.createElement(Wo,{id:c},o)),h.default.createElement("div",null,t),h.default.createElement("div",null,n&&!l&&h.default.createElement(Xo,null,n),l&&h.default.createElement(Uo,{id:u},l))))},dl=({helpText:e,children:t})=>h.default.createElement(ol,{as:"div"},h.default.createElement(al,null),e&&h.default.createElement(jo,null),t),il=y.default.span`
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
`,sl=({text:e,defaultDirection:t})=>h.default.createElement("span",{"aria-hidden":!0},h.default.createElement(Bt,{placement:t,delay:{open:1e3,close:0}},h.default.createElement(Ht,null,h.default.createElement(il,null)),h.default.createElement(Wt,{text:e}))),cl=y.default.div`
  display: flex;
  flex: 1 1 0;
  gap: var(--layout-soybean);
  align-items: center;

  min-width: 0;
`,ul=y.default(A)`
  position: relative;

  overflow: hidden;

  color: inherit;
  text-overflow: ellipsis;
  white-space: nowrap;
`,bl=y.default.div`
  display: flex;
  align-items: center;
  line-height: 0;
`,fl=({children:t,prefix:r,defaultDirection:a="right",...o})=>{const l=e.useRef(null),n=kt(l);return h.default.createElement(cl,o,r&&("string"==typeof r?h.default.createElement(A,{color:"inherit"},r.substring(0,3)):h.default.createElement(bl,null,r)),h.default.createElement(ul,{ref:l},t,n&&h.default.createElement(sl,{text:t,defaultDirection:a})))},vl=y.default.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--layout-soybean);
  align-items: center;

  box-sizing: border-box;
  min-width: 0;
  max-width: 228px;
  padding: var(--layout-sandgrain) var(--layout-soybean);

  background-color: var(--control-bg-secondary);
  border-radius: var(--border-r-seed);
`,pl=y.default.button`
  cursor: pointer;

  padding: var(--layout-sandgrain);

  line-height: 0px;
  color: var(--control-icon-secondary);

  background: none;
  border: none;

  &:focus,
  &:hover {
    color: var(--control-icon-selected);
  }
`,ml=({children:e,prefix:t,onClick:r,...a})=>h.default.createElement(vl,a,h.default.createElement(fl,{prefix:t,defaultDirection:"top"},e),h.default.createElement(pl,{onClick:e=>{e.stopPropagation(),r()},"aria-label":"Remove","aria-description":`Remove ${e} option`},h.default.createElement(o.IconActionCross,null))),gl=({children:e,defaultDirection:t="top",text:r})=>h.default.createElement(Bt,{placement:t},h.default.createElement(Ht,null,e),h.default.createElement(Wt,{text:r})),hl=({children:e,delay:t={open:0,close:500},...r})=>h.default.createElement(i.FloatingDelayGroup,T({delay:t},r),h.default.createElement(At,{value:!0},e)),xl=y.default(ze)`
  --base-icon-primary-alt: var(--control-icon-primary);

  display: inline-flex;
  align-items: center;

  :focus-visible {
    outline: var(--control-border-focus-ring) solid var(--border-b-stamp);
  }
`,yl=({children:e,...t})=>h.default.createElement(gl,t,h.default.createElement(xl,null,e)),El=y.default(A)`
  display: inline-block;
  font: var(--body-xs-emphasis);
  color: var(--control-text-primary);
`,wl=({isRequired:e,children:t,as:r,...a})=>h.default.createElement(El,T({as:r??"label"},a),t," ",!e&&"(optional)"),kl=y.default.fieldset`
  display: flex;
  flex-direction: column;

  margin: var(--layout-sandgrain);
  padding: var(--layout-sandgrain);

  border: var(--border-b-sandgrain);
`,Cl=y.default(_)`
  display: flex;
  flex-direction: column;
  gap: var(--layout-soybean);

  margin: var(--layout-sandgrain);
  padding: var(--layout-sandgrain);

  list-style: none;
`,$l=y.default(G)`
  margin: var(--layout-sandgrain);
  padding: var(--layout-sandgrain);
`,Sl=y.default(qt)`
  gap: var(--layout-seed);
  margin-bottom: var(--layout-soybean);
`,Il=y.default(wl)`
  padding: var(--layout-sandgrain);
  ${({withTooltip:e})=>!e&&"margin-bottom: var(--layout-soybean);"}
`;class Tl extends h.default.Component{constructor(e){super(e),this.state={hasError:!1}}static getDerivedStateFromError(){return{hasError:!0}}componentDidCatch(e,t){"function"==typeof this.props.logger&&this.props.logger(e,t)}render(){return this.state.hasError?this.props.fallback??null:this.props.children}}const Fl=({isOpen:t,transition:r="0.35s ease-in-out"})=>{const[a,o]=e.useState("auto"),[l,n]=e.useState(t?"visible":"hidden"),d=e.useRef(null),i=d.current?.scrollHeight;return e.useLayoutEffect((()=>{d.current&&o(t?d.current.scrollHeight:0)}),[t,i]),e.useEffect((()=>{const e=d.current,r=t=>{t.target===e&&n("hidden")},a=r=>{r.target===e&&n(t?"visible":"hidden")};return e?.addEventListener("transitionstart",r),e?.addEventListener("transitionend",a),()=>{e?.removeEventListener("transitionstart",r),e?.removeEventListener("transitionend",a)}}),[t]),e.useEffect((()=>{const e=()=>{t&&d.current&&o(d.current.scrollHeight)};return window.addEventListener("resize",e),()=>{window.removeEventListener("resize",e)}}),[t]),{ref:d,styles:{maxHeight:(s=a,"string"==typeof s?s:`${s}px`),transition:`max-height ${r}`,overflow:l}};var s},Rl=e=>h.default.createElement(Wo,e),Ml=y.default(Uo)`
  ${({mt:e})=>e&&`margin-top: ${e};`}
  ${e=>e["margin-top"]&&`margin-top: ${e["margin-top"]};`}
`,Ll=e=>h.default.createElement(Ml,e),Ol=e=>h.default.createElement(Xo,e),Al=y.default(wl)`
  /* stylelint-disable no-empty-source */
`,Pl=y.default(qt)`
  flex-direction: column;

  ${Al} {
    margin-bottom: var(--layout-seed);
  }
`,Nl=(t,r)=>{const[a,o]=e.useState("down");return e.useLayoutEffect((()=>{if(!t)return;const e=((e,t)=>{if(!document.documentElement)return null;const{top:r,bottom:a,height:o}=e.getBoundingClientRect(),l=document.documentElement;return(window.innerHeight||l&&l.clientHeight||0)-("up"===t?a:r)<o?"up":"down"})(t,a);e&&o(e)}),r),a},Dl=h.default.createContext(void 0),Bl=()=>{const t=e.useContext(Dl);if(void 0===t)throw new Error("useMenuContext must be used within a MenuContext provider");return t},Hl=y.default.div`
  position: relative;
`,Vl=y.default(qt)`
  flex-direction: column;
`,zl=(e,t)=>t.type===k.default.stateChangeTypes.keyDownEscape?{...e,isOpen:!1}:t,Wl=({children:t,direction:r,itemToString:a=(()=>""),placeholder:o,errorText:l,warningText:n,helpText:d,label:i,isRequired:s,id:c=e.useId(),...u})=>{const[b,f]=e.useState(null),v=e.useCallback((e=>{f(e)}),[]),p=Nl(b,[v]);let m=h.default.createElement("div",null);return l?m=h.default.createElement(Ll,null,l):n?m=h.default.createElement(Ol,null,n):d&&(m=h.default.createElement(Rl,null,d)),h.default.createElement(Vl,null,i&&h.default.createElement(wl,{isRequired:s,htmlFor:c,mb:"var(--layout-seed)"},i),h.default.createElement(k.default,T({itemToString:a,stateReducer:zl},u),(e=>h.default.createElement("div",null,h.default.createElement(Dl.Provider,{value:{...e,ref:v,direction:r??p,placeholder:o,id:c}},h.default.createElement(Hl,null,t))))),m)},jl=a.css`
  color: ${({disabled:e})=>e?"var(--control-text-disabled)":"var(--control-text-primary)"};
  font: var(--body-xs);

  display: flex !important;
  gap: var(--layout-soybean);

  svg {
    margin: auto var(--layout-sandgrain);
  }

  &:hover {
    color: ${({disabled:e})=>e?"var(--control-text-disabled)":"var(--control-text-hover)"};
  }
  &:focus {
    color: ${({disabled:e})=>e?"var(--control-text-disabled)":"var(--control-text-focus)"};
  }
`,ql=a.css((({disabled:e,hasErrors:t,hasWarnings:r})=>{let o="var(--control-border-default)";return e?o="var(--control-border-disabled)":t?o="var(--control-border-bad)":r&&(o="var(--control-border-warn)"),a.css`
    ${jl}
    padding: calc(var(--layout-seed) - var(--border-b-seed)) calc(var(--layout-stamp) - var(--border-b-seed));
    width: 100%;
    ${l.width}
    background-color: ${e?"var(--control-bg-primary-disabled)":"var(--control-bg-primary)"};
    border: var(--border-b-seed) solid ${o};
    ${l.border}
    border-radius: var(--border-r-seed);
    cursor: ${e?"not-allowed":""};
    transition: 0.25s;
    transition-property: border-color, box-shadow;

    &:focus-within,
    &:focus {
      outline: var(--control-border-focus-ring) solid var(--border-b-stamp);
      border-color: ${!e&&"var(--control-border-focus)"};
    }

    &::placeholder {
      color: var(--control-text-secondary);
    }

    &:hover {
      border-color: ${!e&&"var(--control-border-hover)"};
    }
  `})),Gl=y.default(o.IconActionSelect)`
  margin-left: var(--layout-soybean);
  color: inherit;

  path {
    fill: ${({disabled:e})=>e?"var(--control-icon-disabled)":"var(--control-icon-primary)"};
  }
`,Kl=y.default(Ja)`
  ${ql}
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;

  ${({isOpen:e})=>e&&"z-index: 30;"}

  &:hover {
    span {
      color: var(--control-text-hover);
    }
    ${Gl} path {
      fill: var(--control-icon-hover);
    }
  }

  &:focus {
    span {
      color: var(--control-text-focus);
    }
    ${Gl} path {
      fill: var(--control-icon-focus);
    }
  }

  &:focus:not(.focus-visible) {
    outline: none;
  }

  &.placeholder span {
    color: ${({disabled:e})=>e?"var(--control-text-disabled)":"var(--control-text-secondary)"};
  }
`,Ul=y.default.span`
  ${jl}
  overflow: hidden;
  display: flex !important;
  gap: var(--layout-soybean);

  width: 100%;
  height: 24px; /* maintaining height when value is empty */

  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;

  svg {
    flex-shrink: 0;
    margin: auto var(--layout-sandgrain);
  }

  .placeholder & {
    color: var(--control-text-secondary);
  }
`,Zl=y.default(me).attrs((()=>({variant:"link"})))`
  margin-right: var(--layout-spoon);
  padding: 0;
`,_l=y.default.span`
  width: 100%;
  min-width: 0;
`,Yl=({children:t,itemToString:r,disabled:a=!1,hasErrors:o=!1,hasWarnings:l=!1,isFilter:n=!1,isClearable:d=!1,buttonRef:i,placeholderIcon:s,...c})=>{const u=e.useRef(null),{id:b,getToggleButtonProps:f,selectedItem:v,isOpen:p,direction:m,itemToString:g,placeholder:x,clearSelection:y}=Bl();e.useEffect((()=>{const e=e=>{"Escape"===e.key&&document.activeElement===u.current&&(e.stopPropagation(),y())};return window.addEventListener("keydown",e),()=>window.removeEventListener("keydown",e)}),[y]);const E=t||r&&r(v)||g(v)||v&&v.value||x,w=!(v||v?.value||!x);let k=null;s&&"string"==typeof s&&(k=()=>h.default.createElement(A,{color:"var(--control-text-secondary)"},s)),s&&"object"==typeof s&&(k=s),v?.icon&&(k=v.icon);const C=h.default.createElement(Kl,T({},f({ref:i,id:b}),c,{isOpen:p,direction:m,disabled:a,hasErrors:o,hasWarnings:l,className:w?"placeholder":void 0,ref:u}),h.default.createElement(Ul,{title:v?.value||x,disabled:a},k&&h.default.createElement(k,null),h.default.createElement(_l,null,E)),!a&&d&&v?.value?h.default.createElement(Zl,{onClick:e=>{e.stopPropagation(),y()},"data-testid":"select-menu-clear-button"},"Clear"):null,h.default.createElement(Gl,{disabled:a}));return n&&p?null:C},Xl={up:a.css`
    top: auto;
    bottom: 100%;
    margin-bottom: var(--layout-seed);
  `,down:a.css`
    top: 100%;
    bottom: auto;
    margin-top: var(--layout-seed);
  `},Jl=y.default.div`
  ${e=>Xl[e.direction]}
  position: absolute;
  width: 100%;
`,Ql=y.default(R)`
  position: relative;
  z-index: 20;

  overflow-y: auto;

  height: auto;
  max-height: 250px;

  background-color: var(--control-bg-primary);
  border-radius: var(--border-r-stamp);
  box-shadow: var(--control-e-shoe);
`,en=({noResults:e,children:t,...r})=>{const{id:a,isOpen:o,direction:l,ref:n}=Bl();return o?e?null:h.default.createElement(Jl,{direction:l,ref:n,"data-testid":"menu-list",id:a},h.default.createElement(Ql,T({},r,{isOpen:o,direction:l}),t)):null},tn=y.default(G)`
  ${jl}
  cursor: pointer;

  overflow: hidden;
  display: flex !important;
  gap: var(--layout-soybean);

  padding: var(--layout-seed) calc(var(--layout-stamp) - var(--border-b-seed));

  text-overflow: ellipsis;
  white-space: nowrap;

  svg {
    flex-shrink: 0;
    margin: auto 0;
  }

  ${e=>e.isActive?"\n  background-color: var(--control-bg-selected);\n  color: var(--control-text-oninvert-selected);\n  --base-icon-primary-alt: var(--base-icon-oninvert-primary);\n  &:hover {\n    background-color: var(--control-bg-selected-hover);\n    color: var(--control-text-oninvert-selected);\n  }\n":e.isHighlighted?"\n  background-color: var(--control-bg-decorative-hover);\n  color: var(--control-text-primary);\n  &:hover {\n    background-color: var(--control-bg-decorative-hover);\n    color: var(--control-text-hover);\n  }\n":e.isDisabled?"\n  background-color: var(--control-bg-disabled);\n  color: var(--control-text-disabled);\n":"\n  background-color: var(--control-bg-primary);\n  color: var(--control-text-primary);\n  &:hover {\n    background-color: var(--control-bg-hover);\n    color: var(--control-text-hover);\n  }\n"};
`,rn=({item:e,itemToString:t,index:r,disabled:a,children:o})=>{const{getItemProps:l,selectedItem:n,highlightedIndex:d,itemToString:i}=Bl(),s=o||t&&t(e)||i(e)||e&&e.value,c=e.icon;return h.default.createElement(tn,T({},l({key:e.value,index:r,item:e,disabled:a}),{isActive:n&&n.value===e.value||!1,isHighlighted:d===r,isDisabled:!!a,title:e.value}),c&&h.default.createElement(c,null),s)},an=y.default.input`
  ${jl}
  ${l.color}
  flex: 1;

  width: 100%;
  margin: var(--layout-sandgrain);
  padding: var(--layout-sandgrain);

  background: none;
  border: var(--border-b-sandgrain);
  outline: none;

  ${l.border}
  ${l.width}
  &::placeholder {
    color: var(--control-text-secondary);
  }
`,on=y.default(ze)`
  ${ql}
  display: flex;
  flex: 1;
  align-items: center;

  svg g {
    fill: var(--control-icon-primary);
  }
`,ln=e.forwardRef((({disabled:e,error:t=!1,prefix:r,suffix:a,width:o,type:l="text",border:n,warning:d,...i},s)=>h.default.createElement(on,{disabled:e,border:n,width:o,hasErrors:t,hasWarnings:Boolean(d),"data-testid":"textfield"},r&&h.default.createElement(qt,null,r),h.default.createElement(an,T({ref:s},i,{type:l,disabled:e})),a&&h.default.createElement(qt,null,a)))),nn=({disabled:t,hasErrors:r,hasWarnings:a,onKeyDown:o,onKeyUp:l,...n})=>{const{isOpen:d,getInputProps:i}=Bl(),s=e.useRef(null);return e.useEffect((()=>{s&&s.current&&s.current.focus()})),d?h.default.createElement(Kl,T({},n,{isOpen:d,disabled:t,hasErrors:r,hasWarnings:a}),h.default.createElement(an,T({},i({onKeyDown:e=>{o&&o(e)},onKeyUp:e=>{l&&l(e)}}),{ref:s,"data-testid":"select-menu-filter"}))):null},dn=y.default(G)`
  ${jl}
  pointer-events: none;

  overflow: hidden;

  padding: var(--layout-seed) calc(var(--layout-stamp) - var(--border-b-seed));

  font: var(--body-xs-emphasis);
  color: var(--control-text-secondary);
  text-overflow: ellipsis;

  background-color: var(--control-bg-secondary);
`,sn=({item:e,itemToString:t,children:r})=>{const{itemToString:a}=Bl(),o=r||t&&t(e)||a(e)||e&&e.value;return h.default.createElement(dn,{title:e.value},o)},cn=y.default.textarea.attrs((e=>({...e,disabled:e.disabled??!1,hasErrors:e.hasErrors??!1,hasWarnings:e.warning??!1,rows:e.rows??3,"data-testid":"multiline-textfield"})))`
  ${ql}
  ${l.height}
  display: block;
  padding: calc(var(--layout-seed) - var(--border-b-seed)) var(--layout-stamp);
  margin: var(--layout-sandgrain);
`,un=y.default.button((({RestingIcon:e,ActiveIcon:t})=>`\n  background: url(${e}) no-repeat 0 50%;\n  background-color: inherit;\n  border-width: var(--border-b-sandgrain);\n  border-radius: var(--border-r-seed);\n  color: var(--action-text-primary);\n  cursor: pointer;\n  font: var(--body-xs);\n  margin: var(--layout-sandgrain) var(--layout-sandgrain) var(--layout-sandgrain) 36px;\n\n  &:active,\n  &:hover {\n    background-image: url(${t});\n    color: var(--action-text-hover);\n    text-decoration: underline;\n  }\n\n  &:focus {\n    color: var(--action-text-focus);\n    outline: var(--border-b-stamp) solid var(--action-border-focus-ring);\n    text-decoration: underline;\n  }\n`)),bn=y.default.hr`
  display: block;
  width: 16px;
  height: 0;
  margin: var(--layout-shoebox) var(--layout-sandgrain);
  border: var(--border-b-seed) solid var(--base-border-primary);
`,fn=a.css((({slotPlacement:e})=>{let t="flex-start",r="row",o="var(--layout-spoon)";return"end"===e?t="space-between":"below"===e&&(r="column",o="var(--layout-seed)"),a.css`
    display: flex;
    justify-content: ${t};
    flex-direction: ${r};
    gap: ${o};
    font: var(--body-xs);
    text-align: start;

    svg {
      margin-right: var(--layout-soybean);
    }

    span {
      color: var(--base-text-secondary);
    }
  `})),vn=y.default.div`
  width: 100%;
  border-radius: var(--border-r-stamp);
  border-width: var(--border-b-seed);
  border-style: solid;
  border-color: ${({hasError:e})=>e?"var(--control-border-bad)":"var(--control-border-default)"};

  &:hover {
    border-color: var(--control-border-hover);
  }
`,pn=y.default(me).attrs((()=>({variant:"unstyled"})))`
  font: var(--body-xs);
  color: var(--control-text-primary);
  width: 100%;
  padding: calc(var(--layout-spoon) - var(--border-b-seed));
  background: ${({isOpen:e,showHighlightOnSelected:t})=>e&&t?"var(--control-bg-secondary)":"var(--control-bg-primary)"};

  border-radius: var(--border-r-stamp);

  &:hover {
    .optional-form-group-title {
      text-decoration: underline;
    }
  }

  &:focus {
    outline: none;
    z-index: 2;
    position: relative;
    .optional-form-group-title {
      text-decoration: underline;
    }
  }

  &:focus-visible {
    outline: var(--control-border-focus-ring) solid var(--border-b-stamp);
    outline-offset: var(--border-b-seed);
  }
`,mn=y.default(ze)`
  margin-right: var(--layout-spoon);
  display: inline-block;
  svg {
    margin-top: 0px;
  }
`,gn=y.default.div`
  ${fn};

  width: 100%;
`,hn=y.default(ze)`
  padding: var(--layout-sandgrain) var(--layout-spoon) var(--layout-spoon);
  ${({isOpen:e})=>!e&&"padding-bottom: var(--layout-sandgrain)"};
  background: ${({isOpen:e,showHighlightOnSelected:t})=>e&&t?"var(--control-bg-secondary)":"var(--control-bg-primary)"};
  border-radius: 0 0 var(--border-r-stamp) var(--border-r-stamp);
`,xn=y.default.input`
  position: absolute;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap; /* added line */
`,yn=y.default.div`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 16px;
  min-width: 16px;
  height: 16px;
  margin: var(--layout-seed) 0;

  color: transparent;

  background-color: var(--control-bg-primary);
  border: var(--border-b-seed) solid var(--control-border-default);
  border-radius: var(--border-r-seed);
  box-shadow: none;

  ${({checked:e,indeterminate:t,hasErrors:r,disabled:a})=>{if(a)return In;return e||t?r?Sn:$n:r?Cn:kn}}

  ${({isFocused:e})=>e&&"outline: var(--control-border-focus-ring) solid var(--border-b-stamp);"}
`,En=y.default.div`
  position: relative;
  display: flex;
  flex-direction: column;
`,wn=y.default.label`
  cursor: pointer;
  display: flex;
  gap: var(--layout-soybean);
  font: var(--body-xs-medium);

  ${({isHovered:e,isFocused:t,disabled:r})=>r?"color: var(--control-text-disabled); cursor: not-allowed;":e?"color: var(--control-text-hover);":t?"color: var(--control-text-focus);":"color: var(--control-text-primary);"}
`,kn=a.css`
  background-color: var(--control-bg-primary);
  border-color: var(--control-border-default);

  ${({isHovered:e})=>e&&"background-color: var(--control-bg-hover); border-color: var(--control-border-hover);"}
  ${({isFocused:e})=>e&&"background-color: var(--control-bg-focus); border-color: var(--control-border-focus);"}
`,Cn=a.css`
  background-color: var(--control-bg-primary);
  border-color: var(--control-border-bad);
`,$n=a.css`
  color: var(--control-icon-oninvert-selected);
  background-color: var(--control-bg-selected);
  border-color: var(--control-border-selected);

  ${({isHovered:e})=>e&&"background-color: var(--control-bg-selected-hover); border-color: var(--control-border-hover);"}
  ${({isFocused:e})=>e&&"background-color: var(--control-bg-selected-focus); border-color: var(--control-border-focus);"}
`,Sn=a.css`
  color: var(--control-icon-oninvert-selected);
  background-color: var(--control-bg-bad-emphasis);
  border-color: var(--control-border-bad);
`,In=a.css`
  background-color: var(--control-bg-primary-disabled);
  border-color: var(--control-border-disabled);

  ${({checked:e,indeterminate:t})=>(e||t)&&"color: var(--control-icon-disabled);"}
`,Tn=({id:t,showCharacterCount:r,showHelpText:a=!1,showWarning:o=!1})=>{const l=e.useId(),n=e.useId(),d=e.useId(),i=e.useId(),s=e.useId(),c=e.useId(),u=e.useMemo((()=>t??c),[c,t]);return{ariaDescribedByValues:e.useMemo((()=>[a?i:void 0,r?l:void 0,o?s:void 0].filter(Boolean).join(" ")),[l,i,r,o,a,s]),componentIds:{characterCount:l,error:d,help:i,input:u,warning:s,label:n}}},Fn=({disabled:t=!1,hasError:r=!1})=>{const{disabled:a,hasError:o}=Qo()??{};return e.useMemo((()=>({isDisabled:a??t,isError:o??r})),[t,a])},Rn=({errorText:t,helpText:r,warningText:a})=>{const o=e.useMemo((()=>Boolean(t)),[t]),l=e.useMemo((()=>Boolean(a)&&!o),[o,a]),n=e.useMemo((()=>Boolean(r)),[r]);return{showError:o,showHelpText:n,showWarning:l}},Mn=({multiSelect:t,initialSelected:r,disabled:a,type:o="select"})=>{const[l,n]=e.useState(!1),[s,c]=e.useState(null),[u,b]=e.useState(void 0),f=e.useRef([]),v=e.useRef([]),[p,m]=d.useMap(r?((e,t)=>{if(!Array.isArray(t))return[[t.label,t]];const r=t.map((e=>[e.label,e]));return e?r:[r[0]]})(t,r):void 0),g=e.useMemo((()=>{const e=[...p.values()].map((e=>e?.index??0));return Math.min(...e)}),[p]),h=i.useFloating({placement:"bottom-start",open:l,onOpenChange:e=>{!e&&b(void 0),n(e)},whileElementsMounted:i.autoUpdate,middleware:[i.flip(),i.offset(4),i.size({apply({rects:e,elements:t}){Object.assign(t.floating.style,{width:`${e.reference.width}px`})}})]}),x=i.useListNavigation(h.context,{listRef:f,activeIndex:s,selectedIndex:g,onNavigate:c,virtual:"combobox"===o,loop:"combobox"===o}),y=i.useClick(h.context,{enabled:!a}),E=i.useDismiss(h.context,{outsidePress:"combobox"!==o}),w=i.useRole(h.context,{role:"listbox"}),k=i.useInteractions([x,y,E,w]),C=e.useCallback((({label:e,value:r,prefix:a,index:o})=>{t&&p.has(e)?m.remove(e):(t||m.reset(),m.set(e,{value:r,label:e,prefix:a,index:o})),t||(b(void 0),n(!1))}),[p,m,t,n]),$=e.useMemo((()=>{if(0===p.size)return;const e=[...p.values()].map((({label:e,value:t,prefix:r})=>({label:e,value:t,prefix:r})));return t?e:e[0]}),[p,t]);return{activeSelectItem:e.useMemo((()=>({activeIndex:s,setActiveIndex:c,activeItem:u,setActiveItem:b})),[s,u,c,b]),selectedItems:e.useMemo((()=>({selectedIndex:g,selectedLabels:[...p.keys()],selectedValues:$,selectedOptions:p})),[g,p,$]),floatingData:h,interactions:k,listRefs:{elementsRef:f,labelsRef:v},handleSelect:C,handleClear:()=>m.reset(),isOpen:l,setIsOpen:n,multiSelect:t}},Ln=e.forwardRef((({indeterminate:t,checked:r,label:a,disabled:l,warningText:n,errorText:d,onChange:i,style:s,className:c,...u},b)=>{const f=e.useId(),[v,p]=e.useState(!1),[m,g]=e.useState(!1),[x,y]=e.useState(!1),{isDisabled:E,isError:w}=Fn({disabled:l,hasError:Boolean(d)}),k=void 0!==r?r:v;return h.default.createElement(En,{style:s,className:c},h.default.createElement(wn,{onMouseEnter:()=>y(!0),onMouseLeave:()=>y(!1),disabled:E,isHovered:x,isFocused:m},h.default.createElement(xn,T({type:"checkbox","data-testid":"styled-checkbox",ref:b,checked:k,"aria-checked":t?"mixed":k,onFocus:()=>g(!0),onBlur:()=>g(!1),disabled:E,onChange:e=>{p(e.target.checked),i(e)}},d&&{"aria-invalid":!0,"aria-errormessage":f},u)),h.default.createElement(yn,{hasErrors:w,checked:k,indeterminate:t,isFocused:m,isHovered:x,disabled:E,"aria-hidden":"true"},t?h.default.createElement(o.IconActionCheckboxMinus,null):h.default.createElement(o.IconActionCheckboxTick,null)),a),n&&!d&&h.default.createElement(Xo,null,n),d&&h.default.createElement(Uo,{id:f},d))})),On=y.default.div`
  display: flex;
  flex-direction: column;
  gap: var(--layout-seed);
  ${({selectAll:e})=>e&&"\n   & > *:first-child {\n    padding-bottom: var(--layout-seed);\n   }\n   & > *:not(:first-child) {\n    padding-left: var(--layout-shoe);\n   }\n  "}
`,An=y.default(me).attrs((()=>({variant:"unstyled"})))`
  color: var(--action-text-primary);
  border-radius: var(--border-r-seed);
  font: var(--body-xs);
  min-width: 24px;
  min-height: 24px;
  padding: var(--layout-sandgrain) var(--layout-seed);
  margin: var(--layout-sandgrain);
  border: var(--border-b-seed) solid transparent;
  cursor: pointer;
  display: block;

  &:hover:not(:disabled):not([data-active='true']) {
    background: none;
    text-decoration: underline;
    color: var(--action-text-hover);
    path {
      fill: var(--action-icon-hover);
    }
  }
  &:focus:not(:disabled):not([data-active='true']) {
    text-decoration: underline;
    border-color: var(--control-border-focus);
    path {
      fill: var(--action-icon-focus);
    }
  }
  &:disabled {
    cursor: auto;
    background: transparent;
    color: var(--action-text-oninvert-disabled);
  }
  &[data-active='true'] {
    background: var(--action-bg-selected);
    color: var(--action-text-oninvert-primary);
  }

  &.ellipsis {
    color: var(--base-text-primary);
  }
`,Pn=y.default(o.IconActionArrowLeft)`
  margin-right: 6px;
`,Nn=y.default(o.IconActionArrowRight)`
  margin-left: 6px;
`,Dn=y.default(An)`
  display: flex;
  align-items: center;
  padding: var(--layout-sandgrain) calc(var(--layout-seed) - var(--border-b-seed));
  color: var(--action-text-primary);

  path {
    fill: var(--action-icon-primary);
  }

  &:disabled {
    cursor: not-allowed;
    color: var(--action-text-disabled);

    path {
      fill: var(--action-icon-disabled);
    }
  }
`,Bn=({ref:e,as:t,control:r,...a})=>h.default.createElement(Dn,a,"prev"===r&&h.default.createElement(Pn,null),h.default.createElement("span",null,"next"===r?"Next":"Previous"),"next"===r&&h.default.createElement(Nn,null)),Hn=y.default.ul`
  display: flex;
  gap: var(--layout-seed);
  justify-content: center;

  margin: var(--layout-sandgrain);
  padding: var(--layout-sandgrain);
`,Vn=y.default.li`
  display: inline-block;
  height: 24px;
`,zn="...",Wn=(e,t)=>Array.from(Array(Math.max(0,t-e+1)),((t,r)=>r+e)),jn=(e,t,r)=>Math.max(t,Math.min(e,r)),qn=({itemCount:t,limit:r,skip:a,onPageChange:o,showNumbers:l})=>{const n=0===a?1:Math.floor(a/r+1),d=Math.ceil(t/r),i=e.useMemo((()=>(({totalPages:e,currentPage:t})=>{if(e<8)return Wn(1,e);const r=e-2,a=jn(t-1,3,e-4),o=jn(t+1,5,r),l=o<r;return[1,a>3?zn:2,...Wn(a,o),l?zn:e-1,e]})({totalPages:d,currentPage:n})),[d,n]);return h.default.createElement(Hn,null,d>1&&h.default.createElement(Vn,{key:"previous"},h.default.createElement(Bn,{control:"prev",onClick:()=>{o(a-r)},disabled:1===n,"data-testid":"previous-button"})),Boolean(l)&&i.map(((e,t)=>h.default.createElement(Vn,{key:"number"!=typeof e&&t<=1?"first":e},h.default.createElement(An,{onClick:()=>{let t=0;"number"==typeof e&&1!==e&&(t=r*(e-1)),o(t)},"data-after-ellipsis":i[t-1]===zn,disabled:e===zn,className:e===zn?"ellipsis":"","data-active":e===n},e)))),d>1&&h.default.createElement(Vn,{key:"next"},h.default.createElement(Bn,{control:"next",onClick:()=>{o(a+r)},disabled:n===d,"data-testid":"next-button"})))},Gn=({skip:e,limit:t,itemCount:r,maxTotal:a})=>{const o=t<r,l=`${e+1} - ${e+t>r?r:e+t}`;let n=r;return a&&r>=a&&(n=`${a.toLocaleString()}+`),h.default.createElement(A,{color:"var(--control-text-primary)"},o&&h.default.createElement(h.default.Fragment,null,l," of "),n," results")},Kn=y.default.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
`,Un=y.default(ze)`
  background: var(--base-bg-primary);
  box-shadow: var(--control-e-shoe);
  border-radius: var(--border-r-seed);
`,Zn=y.default.div`
  font: var(--body-xs-emphasis);
  color: var(--base-text-oninvert-primary);
  background-color: var(--control-icon-neutral);
  line-height: 12px;
  padding: var(--layout-seed) var(--layout-soybean);
  border-radius: var(--border-r-shoe);
  width: max-content;
  white-space: no-wrap;
`,_n=y.default(ze)`
  display: flex;
  align-items: center;

  border-color: var(--control-border-default);
  border-style: solid;
  border-width: var(--border-b-seed);
  border-radius: var(--border-r-seed);
  box-shadow: none;

  transition: 0.25s;
  transition-property: border-color;

  ${({isInputHovered:e})=>e&&a.css`
      border-color: var(--control-border-hover);
    `}

  ${({isInputFocused:e})=>e&&a.css`
      border-color: var(--control-border-hover);
      outline: var(--border-b-stamp) solid var(--control-border-focus-ring);
    `}

  ${({isButtonFocused:e})=>e&&a.css`
      border-color: var(--control-border-hover);
    `}
`,Yn=y.default(an)`
  padding: calc(var(--layout-seed) - var(--border-b-seed))
    calc(var(--layout-stamp) - var(--border-b-seed));

  &::placeholder {
    color: var(--control-text-secondary);
  }
`,Xn=y.default(me).attrs((()=>({variant:"unstyled"})))`
  cursor: pointer;

  position: relative;

  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;
  margin: calc(-1 * var(--border-b-seed)) calc(-1 * var(--border-b-seed))
    calc(-1 * var(--border-b-seed)) var(--border-b-sandgrain);
  padding: var(--layout-sandgrain);

  border: var(--border-b-seed) solid var(--control-border-default);
  border-radius: var(--border-r-sandgrain) var(--border-r-seed) var(--border-r-seed)
    var(--border-r-sandgrain);
  box-shadow: none;

  ::after {
    content: '';

    position: absolute;
    top: var(--layout-sandgrain);
    left: calc(-1 * var(--border-b-seed));

    display: block;

    width: 1px;
    height: 100%;

    background: var(--control-border-default);

    transition-duration: 0.2s;
  }

  ${({isInputHovered:e})=>e&&a.css`
      border-color: var(--control-border-hover);
    `}

  ${({isInputFocused:e})=>e&&a.css`
      border-color: var(--control-border-hover);
    `}


  ${({isButtonHovered:e})=>e&&a.css`
      ::after {
        background: var(--control-border-hover);
      }

      &:hover {
        border-color: var(--control-border-hover);
        box-shadow: var(--control-e-spoon);
      }
    `}

  ${({isButtonFocused:e})=>e&&a.css`
      ::after {
        background: var(--control-border-hover);
      }

      &:focus {
        border-color: var(--control-border-hover);
        outline: var(--border-b-stamp) solid var(--action-border-focus-ring);
      }
    `}
`,Jn={large:"calc(var(--layout-soybean) - var(--border-b-seed)) var(--layout-spoon) calc(var(--layout-soybean) - var(--border-b-soybean))",medium:"calc(var(--layout-seed) - var(--border-b-seed)) var(--layout-stamp) calc(var(--layout-seed) - var(--border-b-soybean))"},Qn=y.default.div`
  overflow: hidden;
  display: flex;

  background-color: var(--control-bg-primary);
  border: var(--border-b-seed) solid
    ${({errors:e})=>e?"var(--control-border-bad)":"var(--control-border-default)"};
  border-radius: var(--border-r-seed);

  ${({disabled:e})=>e&&"border: var(--border-b-seed) solid var(--control-border-disabled)"}
`,ed=y.default.div`
  flex-grow: 1;
  min-width: 0;
  ${({equalWidth:e})=>e&&a.css`
      flex-basis: 0;
    `};

  && + && {
    border-left: var(--border-b-seed) solid var(--control-border-default);
    border-left: var(--border-b-seed) solid
      ${({disabled:e})=>e?"var(--control-border-disabled)":"var(--control-border-default)"};
  }
`,td=y.default.label((({checked:e,variant:t,selectedColor:r="var(--control-border-selected)"})=>`\n    font: var(--body-xs);\n    border-bottom: var(--border-b-soybean) solid transparent;\n    color: ${e?"var(--control-text-selected)":"var(--control-text-primary)"};\n    cursor: pointer;\n    display: flex;\n    overflow: hidden;\n    padding: ${Jn[t]};\n    justify-content: center;\n    text-overflow: ellipsis;\n    transition-property: background-color, border-color, box-shadow;\n    transition: 0.2s;\n    white-space: nowrap;\n\n    &:hover {\n      box-shadow: var(--control-e-spoon);\n      border-bottom-color: var(--control-border-hover);\n      color: var(--control-text-hover);\n    }\n\n    &:active {\n      box-shadow: inset var(--control-e-spoon);\n      border-bottom-color: ${r};\n    }\n\n    ${xn}:checked + &&,\n    ${xn}:checked:not(:disabled) + &&:hover {\n      border-bottom-color: ${r};\n    }\n\n    ${xn}:focus + & {\n      color: var(--control-text-focus);\n      outline: var(--control-border-focus-ring) solid var(--border-b-stamp);\n      position: relative;\n      z-index: 1;\n    }\n\n    ${xn}:disabled + & {\n      background: var(--control-bg-primary-disabled);\n      border-color: var(--control-border-disabled);\n      border-bottom-color: transparent;\n      box-shadow: var(--control-e-sandgrain);\n      color: var(--control-text-disabled);\n      cursor: not-allowed;\n    }\n\n    ${xn}:disabled:checked + & {\n      border-bottom-color: var(--control-border-default);\n    }\n  `)),rd=({children:t,disabled:r,errors:a,equalWidth:o,name:l,onChange:n,checked:d,selectedColor:i,value:s,variant:c})=>{const u=e.useId();return h.default.createElement(ed,{errors:a,disabled:r,equalWidth:o,"data-testid":"segmented-control-item-wrapper"},h.default.createElement(xn,{checked:d,"data-testid":"hidden-radio-button",disabled:r,id:u,name:l,onChange:n,type:"radio",value:s}),h.default.createElement(td,{htmlFor:u,variant:c,selectedColor:i,checked:d,"data-testid":"segmented-control-item"},t))},ad=y.default.div`
  ${l.flexbox}
  ${l.display}

  && > * + * {
    ${l.system({mx:{property:"marginLeft",scale:"space"},my:{property:"marginTop",scale:"space"}})}
  }
`;let od=function(e){return e.START="start",e.END="end",e}({});const ld=y.default.div`
  display: flex;
  flex-direction: ${({position:e})=>e===od.START?"row":"row-reverse"};
  gap: var(--layout-soybean);
`,nd=y.default(ze)`
  display: inline-block;
  flex-shrink: 0;

  width: 46px;
  height: 24px;

  border-radius: var(--border-r-pill);
  box-shadow: none;

  ${({disabled:e,checked:t})=>e?a.css`
        background-color: var(--control-bg-primary-disabled);
        border: var(--border-b-seed) solid var(--control-border-disabled);

        svg {
          color: var(--control-icon-disabled);
        }

        &:hover {
          background-color: var(--control-bg-primary-disabled);
          border: var(--border-b-seed) solid var(--control-border-disabled);
        }

        &:focus {
          background-color: var(--control-bg-primary-disabled);
          border: var(--border-b-seed) solid var(--control-border-disabled);
          outline: none;
        }
      `:t?a.css`
        background-color: var(--control-bg-selected);
        border: var(--border-b-seed) solid var(--control-border-hover);

        &:hover {
          background-color: var(--control-bg-selected-hover);
          border: var(--border-b-seed) solid var(--control-border-hover);

          div {
            border: var(--border-b-seed) solid transparent;
          }
        }

        &:focus {
          background-color: var(--control-bg-selected-focus);
          border: var(--border-b-seed) solid var(--control-border-focus);

          div {
            border: var(--border-b-seed) solid transparent;
          }
        }
      `:a.css`
      background-color: var(--control-bg-secondary);
      border: var(--border-b-seed) solid var(--control-border-default);
      transition:
        box-shadow 0.3s,
        border 0.3s,
        background-color 0.3s 0.1s;
    `}
`,dd=y.default(ze)((({checked:e,disabled:t})=>a.css`
    width: 20px;
    height: 20px;

    color: ${e?"var(--control-icon-oninvert-selected)":"var(--control-icon-primary)"};

    background-color: var(--control-bg-primary);
    border-radius: var(--border-r-circle);
    outline: none;

    transition: transform 0.1s;

    ${e?"transform: translate(23px, 1px);":"transform: translate(1px, 1px);"}
    ${()=>t?"\n          background-color: var(--control-bg-primary-disabled);\n          border: var(--border-b-seed) solid var(--control-border-disabled);\n          color: var(--control-icon-disabled);\n        ":e?"\n          border: var(--border-b-seed) solid var(--control-border-oninvert-selected);\n        ":"\n        border: var(--border-b-seed) solid var(--control-border-default);\n        transition: box-shadow 0.3s, border 0.3s, background-color 0.3s 0.1s, transform 0.1s;\n      "}
  `)),id=y.default(xn)`
  &:focus + ${ld} > ${nd} {
    border: var(--border-b-seed) solid var(--control-border-focus);
    outline: var(--control-border-focus-ring) solid var(--border-b-stamp);
  }

  &:focus + ${ld} label:first-child {
    text-decoration: underline;
  }
  ${({checked:e})=>e?`\n      &:focus + ${ld} ${dd} {\n        background-color: var(--control-bg-oninvert-selected);\n      }\n      &:focus + ${ld} ${nd} {\n        background-color: var(--control-bg-selected-focus);\n        border-color: var(--control-border-focus);\n      }\n\n      &:hover + ${ld} ${nd} {\n        background-color: var(--control-bg-selected-hover);\n        border-color: var(--control-border-hover);\n      }\n\n      &:hover + ${ld} ${dd} {\n        background-color: var(--control-bg-oninvert-selected);\n        border-color: var(--control-bg-neutral-decorative);\n      }\n      &:hover + ${ld} label:first-child {\n        text-decoration: underline;\n      }\n  `:`\n      &:focus + ${ld} ${dd} {\n        background-color: var(--control-bg-focus);\n        border-color: var(--control-border-focus);\n      }\n\n      &:hover + ${ld} ${nd} {\n        border-color: var(--control-border-hover);\n      }\n\n      &:hover + ${ld} ${dd} {\n        background-color: var(--control-bg-hover);\n        border-color: var(--control-border-hover);\n      }\n      &:hover + ${ld} label:first-child {\n        text-decoration: underline;\n      }\n  `}
`,sd=y.default.label`
  cursor: ${({disabled:e})=>e?"not-allowed":"pointer"};
`,cd=y.default.span`
  display: flex;
  flex-direction: column;
`,ud=y.default.div`
  display: flex;
  gap: var(--layout-seed);
  width: ${({width:e})=>e};
`,bd=y.default.label`
  font: var(--body-xs);
  color: ${({color:e="var(--control-text-secondary)"})=>e};
`,fd=y.default.fieldset`
  display: flex;
  flex-direction: column;
  gap: var(--layout-soybean);

  margin: var(--layout-sandgrain);
  padding: var(--layout-sandgrain);

  border: none;
`,vd=y.default(qt)`
  height: 24px;
`,pd=y.default(R)`
  display: flex;
  flex-direction: column;
  gap: var(--layout-seed);

  margin: var(--layout-sandgrain);
  padding: var(--layout-sandgrain);
`,md=y.default(G)`
  margin: var(--layout-sandgrain);
  padding: var(--layout-sandgrain);

  :not(:last-child) {
    margin-bottom: var(--layout-soybean);
  }
`,[gd,hd]=ke({hookName:"useModalContext",providerName:"ModalProvider"}),xd=({children:t,...r})=>{const a=(({open:t,onOpenChange:r})=>{const[a,o]=e.useState(),[l,n]=e.useState(!1),d=i.useFloating({open:t,onOpenChange:r}),s=d.context,c=i.useClick(s,{enabled:null==t}),u=i.useDismiss(s,l?{outsidePress:!1}:{outsidePressEvent:"mousedown"}),b=i.useRole(s),f=i.useInteractions([c,u,b]);return e.useMemo((()=>({open:t,onOpenChange:r,...f,...d,labelId:a,setLabelId:o,destructive:l,setDestructive:n})),[t,r,f,d,a,l])})({...r});return h.createElement(gd,{value:a},t)},yd=y.default(i.FloatingOverlay)`
  z-index: 10000;
  display: grid;
  place-items: center;
  background: var(--control-bg-onoverlay);
`,Ed=({children:e,...t})=>h.default.createElement(yd,T({lockScroll:!0},t),e),wd=y.default(D)`
  color: var(--control-text-primary);
`,kd=y.default.div`
  flex: 1;

  width: 520px;
  margin: var(--layout-shoe) var(--layout-sandgrain);
  padding: var(--layout-saxophone);

  background: var(--control-bg-primary);
  border-radius: var(--border-r-stamp);
  box-shadow: var(--control-e-sea);
`,Cd=y.default(qt)`
  gap: var(--layout-soybean);
  align-items: baseline;
  justify-content: space-between;
  padding-bottom: var(--layout-shoe);
`,$d=h.forwardRef((({children:e,title:t,destructive:r=!1,...a},o)=>{const{context:l,setLabelId:n,setDestructive:d,...s}=hd(),c=i.useMergeRefs([s.refs.setFloating,o]),u=i.useId();return h.useLayoutEffect((()=>(n(u),d(r),()=>n(void 0))),[u,n,r,d]),l.open?h.createElement(i.FloatingPortal,null,h.createElement(Ed,null,h.createElement(i.FloatingFocusManager,{context:l},h.createElement(kd,T({ref:c,"aria-labelledby":s.labelId},s.getFloatingProps(a)),h.createElement(Cd,null,h.createElement(wd,{id:u},t),!r&&h.createElement(la,{"aria-label":"Close Modal",onClick:()=>s.onOpenChange()})),e)))):null})),Sd=y.default.div`
  display: flex;
  gap: var(--layout-spoon);
  padding-top: var(--layout-saxophone);
`,Id=h.forwardRef((({children:e,...t},r)=>{const a=hd(),o=e.ref,l=i.useMergeRefs([a.refs.setReference,r,o]);return h.isValidElement(e)?h.cloneElement(e,a.getReferenceProps({ref:l,...t,...e.props,"data-state":a.open?"open":"closed"})):null})),Td=y.default.div`
  position: absolute;
  bottom: var(--layout-saxophone);
  left: var(--layout-saxophone);

  display: flex;
  flex-direction: column;
  gap: var(--layout-spoon);

  width: 520px;
  padding: var(--layout-saxophone);

  background: var(--control-bg-primary);
  border-radius: var(--border-r-stamp);
  box-shadow: var(--control-e-sea);
`,Fd=y.default(qt)`
  gap: var(--layout-spoon);
  align-items: baseline;
  justify-content: space-between;
`,Rd=y.default(D)`
  color: var(--control-text-primary);
`,Md=y.default.div`
  font: var(--body-xs);
  color: var(--control-base-text-primary);
`,Ld=h.default.forwardRef((({children:e,title:t,...r},a)=>{const{context:o,setLabelId:l,setDestructive:n,...d}=hd(),s=i.useMergeRefs([d.refs.setFloating,a]),c=i.useId();return h.default.useLayoutEffect((()=>(l(c),()=>l(void 0))),[c,l,n]),o.open?h.default.createElement(i.FloatingPortal,null,h.default.createElement(Ed,null,h.default.createElement(i.FloatingFocusManager,{context:o},h.default.createElement(Td,T({ref:s,"aria-labelledby":d.labelId},d.getFloatingProps(r)),h.default.createElement(Fd,null,h.default.createElement(Rd,{id:c},t),h.default.createElement(la,{"data-testid":"announcement-close-button","aria-label":"Close",type:"button",onClick:()=>d.onOpenChange()})),h.default.createElement(Md,null,e))))):null})),Od=y.default(A)`
  overflow: hidden;

  max-width: max-content;
  height: fit-content;
  padding: var(--layout-sandgrain) var(--layout-soybean);

  font: var(--body-xs-medium);
  color: var(--control-text-primary);
  text-overflow: ellipsis;
  white-space: nowrap;

  border-radius: var(--border-r-seed);

  ${l.variant({prop:"variant",variants:{default:{backgroundColor:"var(--control-bg-neutral-decorative)"},highlight:{color:"var(--control-text-oninvert-selected)",backgroundColor:"var(--control-bg-neutral-emphasis)"},success:{backgroundColor:"var(--control-bg-good-decorative)"},alert:{backgroundColor:"var(--control-bg-bad-decorative)"},warning:{backgroundColor:"var(--control-bg-warn-decorative)"}}})}
`,Ad=({children:e,variant:t="default",...r})=>h.default.createElement(Od,T({variant:t,"data-testid":"text-status"},r),e),[Pd,Nd]=ke({hookName:"useCoachMarkContext",providerName:"CoachMarkProvider"}),Dd=y.default.div`
  z-index: 10000;

  width: 320px;
  padding: var(--layout-shoe);

  color: var(--base-text-oninvert-primary);

  background-color: var(--base-bg-oninvert-secondary);
  border: var(--border-b-seed) solid var(--base-border-oninvert-secondary);
  border-radius: var(--border-r-stamp);
`,Bd=y.default.span`
  display: flex;
  flex-direction: column;
  gap: var(--layout-spoon);
`,Hd=y.default(D)`
  color: var(--base-text-oninvert-primary);
`,Vd=y.default(A)`
  color: var(--base-text-oninvert-primary);
`,zd=y.default(la)`
  color: var(--base-icon-oninvert-primary);
`,Wd=y.default.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: var(--layout-soybean);
`,jd=y.default.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: var(--layout-shoe);
`,qd=h.forwardRef((({index:e,continueButtonAttributes:t,doneButtonAttributes:r,...a},o)=>{const{steps:l,context:n,currentStep:d,arrowRef:s,handleFinish:c,handleContinue:u,handleSkipped:b,isNew:f,...v}=Nd(),p=i.useMergeRefs([v.refs.setFloating,o]),m=i.useId(),g=i.useId(),x=l.length>1,y=d===l.length,E=d<l.length||!x;return n.open&&d===e?h.createElement(i.FloatingOverlay,{lockScroll:!0},h.createElement(i.FloatingPortal,null,h.createElement(i.FloatingFocusManager,{context:n,modal:!0},h.createElement(Dd,T({style:{...v.floatingStyles},ref:p,"aria-labelledby":m,"aria-describedby":g},v.getFloatingProps(a)),h.createElement(Wd,null,h.createElement(Bd,null,f&&h.createElement(Ad,{variant:"success"},"New"),h.createElement(Hd,{id:m},l[d-1].title)),E&&h.createElement(zd,{"data-testid":"coachmark-close-button","aria-label":"Close Guide",onClick:x?b:c})),h.createElement(Vd,{id:g},l[d-1].description),x&&h.createElement(jd,null,y?h.createElement(Ca,T({onClick:c},r),"Done"):h.createElement(Ca,T({onClick:u},t),"Continue"),h.createElement(Vd,null,`${d} of ${l.length}`)),h.createElement(i.FloatingArrow,{fill:"var(--base-bg-oninvert-secondary)",stroke:"var(--base-border-oninvert-secondary)",strokeWidth:1,ref:s,context:n,staticOffset:v.ARROW_OFFSET,height:v.ARROW_HEIGHT,width:v.ARROW_WIDTH,tipRadius:2}))))):null})),Gd=({children:t,...r})=>{const a=(({open:t,onOpenChange:r,steps:a,onCompleted:o,onDismissed:l,isNew:n,handleScrollToNext:s})=>{const[c,u]=d.useStep(a.length),b=e.useRef(null),f=i.useFloating({open:t,onOpenChange:(e,t)=>{t instanceof KeyboardEvent&&"Escape"===t.key?u.canGoToNextStep?x():E():r()},whileElementsMounted:i.autoUpdate,elements:{reference:a[c-1]?.anchorRef.current??null},transform:!1,middleware:[i.offset((({rects:e,placement:t})=>({mainAxis:20,alignmentAxis:(t.includes("right")||t.includes("left")?e.reference.height:e.reference.width)/2-28}))),i.autoPlacement({allowedPlacements:["bottom-start","bottom-end","right-start","right-end","left-start","left-end"]}),i.arrow({element:b})]}),v=f.context,p=i.useClick(v,{enabled:null==t}),m=i.useDismiss(v,{outsidePress:!1}),g=i.useRole(v),h=i.useInteractions([p,m,g]),x=e.useCallback((()=>{u.canGoToNextStep&&u.goToNextStep()}),[u.goToNextStep,u.reset]),y=e.useCallback((()=>{r(),u.reset(),l?.()}),[r,u.reset,l]),E=e.useCallback((()=>{r(),u.reset(),o?.()}),[r,u.reset,o]);return e.useLayoutEffect((()=>{if(v.refs.floating?.current&&v.isPositioned){if(s){const e=a[c-1].anchorRef;return void s(e)}v.refs.floating.current.scrollIntoView({behavior:"smooth"})}}),[v.refs.floating?.current,v.isPositioned]),e.useMemo((()=>({open:t,onOpenChange:r,...h,...f,steps:a,currentStep:c,isNew:n,arrowRef:b,ARROW_HEIGHT:16,ARROW_OFFSET:16,ARROW_WIDTH:24,handleFinish:E,handleContinue:x,handleSkipped:y})),[t,r,h,f,a,c,n,b,E,x,y])})({...r});return h.createElement(Pd,{value:a},t)},Kd=y.default(ze)`
  height: auto;
  padding: var(--layout-spoon);
  line-height: 0px;
  color: var(--control-icon-primary);

  svg {
    width: 16px;
    height: 16px;
    margin-top: var(--layout-seed);
  }
`,Ud={alert:"var(--control-bg-bad-decorative)",neutral:"var(--control-bg-information-decorative)",success:"var(--control-bg-good-decorative)",warning:"var(--control-bg-warn-decorative)"},Zd={alert:"var(--control-border-bad)",neutral:"var(--control-border-information)",success:"var(--control-border-good)",warning:"var(--control-border-warn)"},_d=y.default.div`
  overflow: hidden;
  display: flex;
  align-items: stretch;

  padding: var(--layout-sandgrain);

  border: var(--border-b-seed) solid ${({type:e})=>Zd[e]};
  border-radius: var(--border-r-stamp);

  & ${Kd} {
    background-color: ${({type:e})=>Ud[e]};
  }
`,Yd=y.default(ze)`
  padding: var(--layout-spoon);
  font: var(--body-xs-medium);
  color: var(--base-text-secondary);
`,Xd={alert:h.default.createElement(o.IconActionError,null),neutral:h.default.createElement(o.IconActionInfo,null),success:h.default.createElement(o.IconActionCheckmark,null),warning:h.default.createElement(o.IconActionAlert,null)},Jd=({children:e})=>v.createPortal(e,document.body),Qd=y.default(ze)`
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  z-index: 9999;
  background: var(--control-bg-onoverlay);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
`,ei=y.default(C.default)`
  position: relative;
`,ti=y.default(D)`
  margin-bottom: var(--layout-shoe);
  color: var(--control-text-primary);
`,ri=y.default.div`
  flex: 1;

  max-width: 400px;
  margin: var(--layout-shoe) var(--layout-sandgrain);
  padding: var(--layout-saxophone);

  background: var(--control-bg-primary);
  border-radius: var(--border-r-stamp);
  box-shadow: var(--control-e-sea);

  ${l.variant({prop:"size",variants:{medium:{maxWidth:"400px"},large:{maxWidth:"744px"}}})}
`,ai=y.default(Ja)`
  margin: var(--layout-seed);
  font: var(--body-xs);

  svg {
    path {
      fill: var(--control-icon-primary);
    }
  }
`,oi=y.default(qt)`
  gap: var(--layout-soybean);
  align-items: baseline;
  justify-content: space-between;
`,li=({title:t,children:r,closeModal:a,focusWhitelist:l=(()=>!1),size:n="medium"})=>{const d=e.useCallback((e=>e.stopPropagation()),[]),i=e.useCallback((e=>{e.stopPropagation(),a()}),[a]),s=e.useCallback((e=>{"Escape"===e.key&&(e.stopPropagation(),a())}),[a]);return e.useEffect((()=>(window.addEventListener("keyup",s),()=>{window.removeEventListener("keyup",s)})),[s]),h.default.createElement(Jd,null,h.default.createElement(Qd,{onClick:i,tabIndex:-1,role:"dialog","aria-labelledby":"modal-title","aria-describedby":"modal-content","aria-modal":"true"},h.default.createElement(ri,{onClick:d,"data-testid":"modal-wrapper",size:n},h.default.createElement(ei,{whiteList:l},h.default.createElement(oi,null,t&&h.default.createElement(ti,{id:"modal-title"},t),h.default.createElement(ai,{type:"button",onClick:i},h.default.createElement(o.IconActionCross,null))),h.default.createElement(f.AutoFocusInside,null,h.default.createElement("div",{id:"modal-content","data-testid":"modal-content"},r))))))},ni=y.default.div`
  z-index: 10000;

  overflow: auto;
  display: flex;

  box-sizing: border-box;
  padding: var(--layout-spoon);

  background-color: var(--base-bg-floating);
  border: var(--border-b-seed) solid var(--base-border-secondary);
  border-radius: var(--border-r-stamp);
  box-shadow: var(--control-e-shoe);
`,[di,ii]=ke({hookName:"usePopoverContext",providerName:"PopoverProvider"}),si=h.forwardRef((({children:e,defaultDirection:t="bottom-end",style:r,...a},o)=>{const{context:l,setLabelId:n,setDefaultDirection:d,...s}=ii(),c=i.useMergeRefs([s.refs.setFloating,o]),u=i.useId();return h.useLayoutEffect((()=>(n(u),d(t),()=>n(void 0))),[u,n,d]),l.open?h.createElement(i.FloatingPortal,null,h.createElement(i.FloatingFocusManager,{context:l,modal:!1},h.createElement(ni,T({style:{...s.floatingStyles,...r},ref:c,"aria-labelledby":s.labelId},s.getFloatingProps(a)),e))):null})),ci=h.forwardRef((({children:e,...t},r)=>{const a=ii(),o=e.ref,l=i.useMergeRefs([a.refs.setReference,r,o]);return h.isValidElement(e)?h.cloneElement(e,a.getReferenceProps({ref:l,...t,...e.props,"data-state":a.open?"open":"closed"})):null})),ui=y.default.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  min-height: var(--layout-saxophone);
  padding: var(--layout-stamp);

  text-align: center;

  background-color: var(--control-bg-highlight);

  @media (width <= 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: var(--layout-spoon);
  }
`,bi=y.default(ze)`
  display: flex;
  align-items: flex-start;
  justify-content: center;

  @media (width <= 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`,fi=y.default(ze)`
  max-width: 702px;
  margin-right: var(--layout-shoe);
  text-align: left;

  @media (width <= 768px) {
    width: 100%;
    margin-right: 0;
    margin-bottom: var(--layout-spoon);
  }
`,vi=y.default(D)`
  display: inline;

  margin-right: var(--layout-soybean);

  font: var(--body-xs-emphasis);
  color: var(--base-text-persistent-primary);
  white-space: nowrap;

  @media (width <= 768px) {
    display: block;
    margin-right: 0;
    margin-bottom: var(--layout-seed);
  }
`,pi=y.default(A)`
  display: inline;

  font: var(--body-xs);
  color: var(--base-text-persistent-primary);
  overflow-wrap: break-word;
  white-space: normal;
`,mi="all 300ms cubic-bezier(0.5, -0.4, 0, 1) 100ms",gi=y.default.div`
  position: fixed;
  z-index: 10000;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);

  height: 0;
`,hi=y.default.div`
  transform: translateY(calc(100% + 24px));

  width: 320px;

  opacity: 1;
  background-color: var(--base-bg-primary-oninvert);
  border-radius: var(--border-r-seed);

  &.toast-enter {
    transform: translateY(calc(100% + 24px));
    opacity: 1;
  }

  &.toast-enter-active {
    transform: translateY(calc(-100% - 24px));
    opacity: 1;
    transition: ${mi};
  }

  &.toast-enter-done {
    transform: translateY(calc(-100% - 24px));
    opacity: 1;
  }

  &.toast-exit {
    transform: translateY(calc(-100% - 24px));
    opacity: 1;
  }

  &.toast-exit-active {
    transform: translateY(calc(-100% - 8px));
    opacity: 0;
    transition: ${mi};
  }
`,xi=a.keyframes`
0% {
  width: 100%;
}
100% {
  width: 0;
}
`,yi=y.default.div`
  width: 100%;
  height: ${"4px"};
`,Ei=y.default.div`
  width: 100%;
  height: 100%;

  background-color: var(--control-border-oninvert-good);
  border-bottom-left-radius: var(--border-r-seed);

  animation: ${xi} ${5e3}ms linear
    ${400}ms;
  animation-fill-mode: forwards;
`,wi=y.default.div`
  display: flex;
  gap: var(--layout-saxophone);
  justify-content: space-between;
  padding: var(--layout-stamp) var(--layout-spoon)
    calc(var(--layout-spoon) - ${"4px"});
`,ki=y.default.div`
  display: flex;
  gap: var(--layout-stamp);
`,Ci=y.default(la)`
  color: var(--base-icon-oninvert-primary);
`,$i=y.default.div`
  height: fit-content;
  padding: var(--layout-seed);

  line-height: 0;
  color: var(--base-icon-oninvert-primary);

  background-color: var(--control-bg-bad-emphasis);
  border-radius: var(--border-r-seed);
`,Si=({children:t,persistent:r=!1,open:a=!0,onClose:l,onUnmount:d,variant:s})=>{const c=!(!s||"alert"!==s)||r,u=e.useRef(null),{refs:b,context:f}=i.useFloating({open:a,onOpenChange:l}),v=i.useClick(f),p=i.useDismiss(f,{outsidePress:!1}),{getFloatingProps:m}=i.useInteractions([v,p]);return e.useEffect((()=>{let e=null;return a&&!r&&(e=window.setTimeout((()=>l()),5300)),()=>{null!==e&&window.clearTimeout(e)}}),[r,a]),h.default.createElement(i.FloatingPortal,null,h.default.createElement(gi,T({ref:b.setFloating},m()),h.default.createElement(n.CSSTransition,{in:a,nodeRef:u,timeout:400,unmountOnExit:!0,onExited:()=>d?.(),classNames:"toast"},h.default.createElement(hi,{role:"status",ref:u},h.default.createElement(wi,null,h.default.createElement(ki,null,c&&h.default.createElement($i,null,h.default.createElement(o.IconActionAlert,null)),h.default.createElement(A,{color:"var(--base-text-oninvert-primary)",font:"var(--body-xs-emphasis)"},t)),h.default.createElement(Ci,{"aria-label":"close notification",onClick:l})),h.default.createElement(yi,null,!c&&a&&h.default.createElement(Ei,null))))))},[Ii,Ti]=ke({strict:!1});const Fi=e.createContext(null),Ri=()=>{const t=e.useContext(Fi);if(null==t)throw new Error("Tooltip components must be wrapped in <Tooltip />");return t},Mi=({children:t,...r})=>{const a=function({initialOpen:t=!1,placement:r="top",open:a,onOpenChange:o}){const[l,n]=e.useState(t),d=a??l,s=o??n,c=i.useFloating({placement:r,open:d,onOpenChange:s,whileElementsMounted:i.autoUpdate,middleware:[i.offset(5),i.flip({fallbackAxisSideDirection:"start"}),i.shift({padding:5})]}),{context:u}=c,b=i.useHover(u,{move:!1,enabled:null==a}),f=i.useFocus(u,{enabled:null==a}),v=i.useDismiss(u),p=i.useRole(u,{role:"tooltip"}),m=i.useInteractions([b,f,v,p]);return e.useMemo((()=>({open:d,setOpen:s,...m,...c})),[d,s,m,c])}(r);return h.default.createElement(Fi.Provider,{value:a},t)},Li=y.default.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`,Oi=e.forwardRef((({children:t,asChild:r=!1,...a},o)=>{const l=Ri(),n=t.ref,d=i.useMergeRefs([l.refs.setReference,o,n]);return r&&e.isValidElement(t)?e.cloneElement(t,l.getReferenceProps({ref:d,...a,...t.props,"data-state":l.open?"open":"closed"})):h.default.createElement(Li,T({"data-state":l.open?"open":"closed",ref:d},l.getReferenceProps(a)),t)})),Ai=y.default.div`
  z-index: 9999;

  padding: ${({type:e})=>"alert"===e?"var(--layout-sandgrain) var(--layout-stamp) var(--layout-seed)":"var(--layout-seed) var(--layout-stamp)"};

  font: var(--body-xs);
  color: var(--control-text-secondary);
  text-align: left;
  word-wrap: break-word;

  background-color: var(--control-bg-primary);
  border-top: ${({type:e})=>"alert"===e&&"var(--border-b-stamp) solid var(--control-border-bad)"};
  border-radius: var(--border-r-seed);
  box-shadow: var(--control-e-shoe);
`,Pi=y.default(A)`
  width: 100%;
  max-width: 400px;
  color: inherit;
`,Ni=({type:e,text:t})=>{const{open:r,refs:a,floatingStyles:o,getFloatingProps:l}=Ri();return r?h.default.createElement(i.FloatingPortal,null,h.default.createElement(Ai,T({type:e,ref:a.setFloating,style:o},l(),{"data-testid":"tooltip"}),h.default.createElement(Pi,null,t))):null},Di=({children:e,defaultDirection:t="top",onShowChange:r,show:a,text:o,triggerAsChild:l,type:n="default"})=>h.default.createElement(Mi,{placement:t,open:a,onOpenChange:r},h.default.createElement(Oi,{asChild:l},e),h.default.createElement(Ni,{type:n,text:o})),Bi=e=>{const{hasFlag:t}=I();return t("v10")?h.default.createElement(gl,e):h.default.createElement(Di,e)},[Hi,Vi]=ke({strict:!1}),[zi,Wi]=ke({hookName:"useSelectContext",providerName:"Select or Combobox"}),ji=y.default(qt)`
  gap: var(--layout-stamp);
  align-items: flex-start;

  ${xn}:disabled + & {
    cursor: not-allowed;
  }

  &:hover label {
    text-decoration: underline;
  }
`;y.default(xn)`
  &:focus + div > button > div:first-of-type {
    background: var(--control-bg-focus);
    border-color: var(--control-border-focus);
    outline: var(--control-border-focus-ring) solid var(--border-b-stamp);
  }

  &:focus + div label {
    text-decoration: underline;
  }
`;const qi=y.default(me).attrs((()=>({variant:"unstyled"})))`
  display: flex;

  &:focus {
    outline: none;
  }
`,Gi=a.css((({hasErrors:e=!1,hasWarnings:t=!1})=>{let r="var(--control-border-default)";return e?r="var(--control-border-bad)":t&&(r="var(--control-border-warn)"),`\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 16px;\n      min-width: 16px;\n      height: 16px;\n      transition: background 300ms;\n      border: var(--border-b-seed) solid ${r};\n      background: var(--control-bg-primary);\n      margin: var(--layout-seed) 0;\n      transition: background 0.2s, border-color 0.2s, box-shadow 0.2s;\n\n      ${xn}:disabled + ${ji} > ${qi} & {\n        background: var(--control-bg-primary-disabled);\n      }\n    `}));y.default(ze)`
  position: relative;
  display: flex;
  align-items: center;
`,y.default(qt)`
  flex-direction: column;
`,y.default.label`
  font: var(--body-xs);
  color: ${({disabled:e})=>e?"var(--control-text-disabled)":"var(--control-text-secondary)"};
`;const Ki=a.css`
  background: var(--control-bg-primary-disabled);
  border: var(--border-b-seed) solid var(--control-border-disabled);
`,Ui=a.css`
  background: var(--control-bg-hover);
  border-color: var(--control-border-hover);
`,Zi=a.css`
  background: var(--control-bg-selected);
  border-color: var(--control-border-selected);
`,_i=y.default(ze)`
  position: relative;
  color: transparent;
  border-radius: var(--border-r-seed);
  box-shadow: none;
  ${Gi}

  ${ji}:hover & {
    ${Ui}
    color: var(--control-icon-hover);
  }

  ${xn}:disabled + ${ji} & {
    border-color: var(--control-border-disabled);
  }

  ${xn}:disabled + ${ji}:hover & {
    color: var(--control-icon-disabled);
    border-color: var(--control-border-disabled);
  }

  ${xn}:checked + ${ji} > ${qi} & {
    ${Zi}
    color: var(--control-icon-oninvert-selected);
  }

  ${xn}:focus:checked + ${qt} > ${qi} & {
    color: var(--control-icon-oninvert-selected);
    background: var(--control-bg-selected-focus);
    border-color: var(--control-border-selected);
  }

  ${xn}:hover:checked + ${qt} > ${qi} & {
    color: var(--control-icon-oninvert-selected);
    background: var(--control-bg-selected-hover);
    border-color: var(--control-border-hover);
  }

  ${xn}:checked + ${ji}:hover &,
  ${xn}:focus:checked + ${qt} > ${qi}:hover & {
    background: var(--control-bg-selected-hover);
    border-color: var(--control-border-hover);
  }

  ${xn}:disabled:checked + ${ji} > ${qi} & {
    color: var(--control-icon-disabled);
    background: var(--control-bg-primary-disabled);
    border-color: var(--control-border-disabled);
  }

  svg {
    position: absolute;
    left: -1px;
  }
`,Yi=e.forwardRef((({indeterminate:e,...t},r)=>h.default.createElement(_i,T({"data-testid":"styled-checkbox",ref:r},t),e?h.default.createElement(o.IconActionCheckboxMinus,null):h.default.createElement(o.IconActionCheckboxTick,null)))),Xi=y.default(G)`
  margin-bottom: var(--layout-seed);

  &:last-of-type {
    margin-bottom: var(--layout-sandgrain);
  }
`,Ji=y.default(Yi)`
  /* stylelint-disable no-empty-source */
`,Qi=y.default.button`
  cursor: pointer;

  display: flex;
  gap: var(--layout-soybean);
  align-items: center;

  width: 100%;
  margin-bottom: var(--layout-seed);
  padding: var(--layout-seed) var(--layout-soybean);

  font: var(--body-xs);
  color: var(--control-text-primary);

  background-color: var(--control-bg-primary);
  border: none;
  border-radius: var(--border-r-seed);

  &:last-of-type {
    margin-bottom: var(--layout-sandgrain);
  }

  &:hover,
  &:focus {
    color: var(--control-text-primary);
    background-color: var(--control-bg-decorative-hover);
  }

  ${({isActive:e})=>e&&a.css`
      color: var(--control-text-primary);
      background-color: var(--control-bg-decorative-hover);
    `}

  ${({isSelected:e,multiSelect:t})=>e&&!t&&a.css`
      color: var(--control-text-oninvert-selected);
      background-color: var(--control-bg-selected);

      &:hover {
        color: var(--control-text-oninvert-selected);
        background-color: var(--control-bg-selected-hover);
      }

      &:focus {
        color: var(--control-text-oninvert-selected);
        background-color: var(--control-bg-selected-focus);
      }
    `}

  ${Ji} {
    color: transparent;

    & path {
      fill: transparent !important;
    }
  }

  :hover {
    ${Ji} {
      ${Ui}
      color: var(--control-icon-hover);
    }
  }

  ${({isSelected:e})=>e&&a.css`
      ${Ji} {
        ${Zi}
        color: var(--control-icon-oninvert-selected);
      }

      :hover {
        ${Ji} {
          ${Zi}
          color: var(--control-icon-oninvert-selected);
        }
      }
    `}

  &[aria-disabled='true'] {
    cursor: not-allowed;
    color: var(--control-text-disabled);
    background-color: var(--control-bg-primary);

    ${Ji} {
      ${Ki}
      color: var(--control-bg-primary-disabled);
    }

    ${({isSelected:e})=>e&&a.css`
        &,
        &:hover {
          ${Ji} {
            ${Ki}
            color: var(--control-text-disabled);
          }
        }
      `}
  }
`;y.default(A)`
  position: relative;

  overflow: hidden;

  color: inherit;
  text-overflow: ellipsis;
  white-space: nowrap;
`;const es=({label:t,value:r,prefix:a,disabled:o=!1,...l})=>{const{activeSelectItem:{activeIndex:n,setActiveItem:d},interactions:s,handleSelect:c,multiSelect:u,selectedItems:{selectedLabels:b}}=Wi(),{renderItemsAsLinks:f}=Vi()??{},{ref:v,index:p}=i.useListItem({label:t}),m=e.useId(),g=n===p,x=b.includes(t);return e.useEffect((()=>{g&&d?.({label:t,value:r,...a&&{prefix:a},index:p})}),[g,d]),h.default.createElement(Ye,{condition:Boolean(f),wrap:e=>h.default.createElement(Xi,null,e)},h.default.createElement(Qi,T({ref:v,role:f?"link":"option",id:m},o&&{"aria-disabled":o},u&&{"aria-checked":x},!u&&{"aria-selected":x},{tabIndex:g?0:-1},s.getItemProps({onClick:()=>!o&&c({label:t,value:r,...a&&{prefix:a},index:p})}),{isSelected:x,isActive:g,multiSelect:u},l),u&&h.default.createElement(Ji,{"aria-hidden":!0}),h.default.createElement(fl,{prefix:a},t)))},ts=y.default.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`,rs=y.default.div`
  width: 100%;
  padding: var(--layout-seed) var(--layout-soybean);
  font: var(--body-xs-emphasis);
`,as=({children:e,label:t,...r})=>h.default.createElement(ts,T({"data-component-type":"select-group",role:"group","aria-label":t},r),h.default.createElement(rs,null,t),e),os=y.default(Zt)`
  display: inline-block;
  margin: var(--layout-soybean) var(--layout-sandgrain);
`,ls=({...e})=>h.default.createElement(os,e),ns=a.css`
  background-color: var(--control-bg-primary);
  border-radius: var(--border-r-seed);
  border: var(--border-b-seed) var(--control-border-default) solid;

  &:hover {
    background-color: var(--control-bg-hover);
    border-color: var(--control-border-hover);
  }

  &:focus-within {
    background-color: var(--control-bg-focus);
    border-color: var(--control-border-focus);
    outline: var(--border-b-soybean) var(--control-border-focus-ring) solid;
  }

  ${({hasWarning:e})=>e&&a.css`
      border-color: var(--control-border-warn);

      &:hover {
        border-color: var(--control-border-warn);
      }

      &:focus-within {
        border-color: var(--control-border-warn);
      }
    `}

  ${({hasError:e})=>e&&a.css`
      border-color: var(--control-border-bad);

      &:hover {
        border-color: var(--control-border-bad);
      }

      &:focus-within {
        border-color: var(--control-border-bad);
      }
    `}

  ${({disabled:e})=>e&&a.css`
      background-color: var(--control-bg-primary-disabled);
      border-color: var(--control-border-disabled);
      color: var(--action-text-disabled);
      cursor: not-allowed;

      &:hover {
        background-color: var(--control-bg-primary-disabled);
        border-color: var(--control-border-disabled);
      }
    `}
`,ds=a.css`
  font: var(--body-xs);
  color: var(--control-text-primary);
  &::placeholder {
    color: var(--control-text-secondary);
  }
`,is=a.css`
  cursor: pointer;

  padding: var(--layout-sandgrain);

  font: var(--body-xs);
  color: var(--action-text-focus);

  background: none;
  border: none;

  &:hover {
    text-decoration: underline;
  }
`,ss=a.css`
  z-index: 10000;

  overflow-y: auto;
  display: flex;
  flex-direction: column;

  max-height: 320px;

  border-radius: var(--border-r-stamp);
  box-shadow: var(--control-e-shoe);
  border: var(--border-b-seed) solid var(--base-border-secondary);
  padding: var(--layout-soybean);
  background-color: var(--control-bg-primary);
`,cs=a.css`
  cursor: not-allowed;
  color: var(--control-text-disabled);
  background-color: var(--control-bg-primary-disabled);
  border: var(--border-b-seed) solid var(--control-border-disabled);

  &:focus {
    border: var(--border-b-seed) solid var(--control-border-disabled);
    outline: none;
  }
  ${A}, input {
    color: var(--control-text-disabled);
  }
`,us=a.css`
  border: var(--border-b-seed) solid var(--control-border-warn);

  &:focus {
    border: var(--border-b-seed) solid var(--control-border-warn);
  }
`,bs=a.css`
  border: var(--border-b-seed) solid var(--control-border-bad);

  &:focus {
    border: var(--border-b-seed) solid var(--control-border-bad);
  }
`,fs=a.css`
  cursor: pointer;

  overflow: hidden;
  display: flex;
  gap: var(--layout-soybean);
  align-items: center;

  width: 100%;
  min-height: 0;
  padding: var(--layout-seed) var(--layout-stamp);

  background-color: var(--control-bg-primary);
  border: var(--border-b-seed) solid var(--control-border-default);
  border-radius: var(--border-r-seed);

  &:focus-within {
    border: var(--border-b-seed) solid var(--control-border-hover);
    outline: var(--border-b-soybean) solid var(--control-border-focus-ring);
  }
  ${({$hasWarnings:e})=>e&&us};
  ${({$hasErrors:e})=>e&&bs};
  ${({$disabled:e})=>e&&cs};
`,vs=a.css`
  display: flex;
  flex-wrap: wrap;
  gap: var(--layout-soybean);
  overflow: hidden;

  width: 100%;
`,ps=a.css`
  width: 100%;
  height: 34px;
`,ms=y.default.div`
  ${ss}
`,gs=y.default(A)`
  font: var(--body-xs-emphasis);
  color: var(--control-text-primary);
`,hs=y.default(A)`
  color: var(--control-text-secondary);
`,xs=()=>{const{floatingData:t,interactions:r,listRefs:a}=Wi(),{filterValue:o,isOpen:l,onFilterOptions:n,options:d,groupBy:s,renderItemsAsLinks:c}=Vi(),u=e.useId(),b=e.useMemo((()=>d?n?n(o,d):d:[]),[o,d]),f=e.useMemo((()=>((e,t)=>{if(t&&e)return e.reduce(((e,r)=>{const a=t(r);return e[a]||(e[a]=[]),e[a].push(r),e}),{})})(b,s)),[s,b]),v=s&&f&&Object.keys(f)?.length>0,p=!s&&b?.length>0,m=0===b?.length;if(!l)return null;const g=e=>!!Boolean(o)&&!e.toLowerCase().includes(o.toLowerCase());return h.default.createElement(i.FloatingPortal,null,h.default.createElement(i.FloatingFocusManager,{context:t.context,initialFocus:-1,visuallyHiddenDismiss:!0},h.default.createElement(ms,T({ref:t.refs.setFloating,style:{...t.floatingStyles}},r.getFloatingProps(),c&&{role:"dialog"}),h.default.createElement(i.FloatingList,{elementsRef:a.elementsRef,labelsRef:a.labelsRef},p&&b?.map((({label:e,...t})=>h.default.createElement(es,T({key:`${u}-${e}`,label:e},t,g(e)&&{prefix:h.default.createElement(hs,null,"in")})))),v&&Object.keys(f).map(((t,r)=>h.default.createElement(e.Fragment,{key:t},r>0&&h.default.createElement(ls,null),h.default.createElement(as,{label:t},f[t].map((({label:e,...r})=>h.default.createElement(es,T({key:`${t}-${e}`,label:e},r,g(e)&&{prefix:h.default.createElement(hs,null,"in")})))))))),m&&h.default.createElement(gs,null,"No matching results")))))},ys=y.default.div`
  width: 100%;
`,Es=y.default.button`
  ${is}
`,ws=y.default.div`
  ${fs};
`,ks=y.default.input`
  cursor: inherit;

  width: 100%;
  padding: var(--layout-sandgrain);

  background-color: inherit;
  border: none;

  &:focus {
    outline: none;
  }

  ${ds}
`,Cs=y.default.div`
  overflow: hidden;
  display: inline-block;
  width: 100%;
`,$s=y.default.div`
  line-height: 0;
`;y.default(So)`
  ${ps}
`;const Ss=e.forwardRef((({placeholder:t="Search",disabled:r=!1,label:a,onChange:l,initialSelected:n,options:s,groupBy:c,onFilterOptions:u,renderItemsAsLinks:b=!1,...f},v)=>{const[p,m]=e.useState(""),[g,x]=d.useDebounceValue("",300),{componentIds:y}=Tn({}),E=e.useRef(null),w=i.useMergeRefs([E,v]),{floatingData:k,handleClear:C,interactions:$,isOpen:S,setIsOpen:I,activeSelectItem:F,selectedItems:R,handleSelect:M,listRefs:L}=Mn({multiSelect:!1,initialSelected:n,disabled:r,type:"combobox"}),O=e=>{m(e),x(e)};e.useEffect((()=>{l&&l(R.selectedValues);void 0!==R.selectedValues&&m(R.selectedValues.label),x("")}),[R.selectedValues]);const A=e.useCallback((()=>{S&&I(!1)}),[S,I]);d.useOnClickOutside([E,k.refs.floating],A);const P=R.selectedOptions.size>0&&!r,N=e.useMemo((()=>({isOpen:S,options:s,groupBy:c,onFilterOptions:u,filterValue:g,renderItemsAsLinks:b})),[S,s,c,u,g]);return h.default.createElement(ys,T({ref:w},f),h.default.createElement(zi,{value:{activeSelectItem:F,handleSelect:M,multiSelect:!1,selectedItems:R,interactions:$,floatingData:k,listRefs:L}},h.default.createElement(rl,{hidden:!0,id:y.label},a),h.default.createElement(ws,{$disabled:r,ref:k.refs.setPositionReference,onBlur:()=>{const e=R.selectedValues?.label;e&&m(e)},onClick:()=>I((e=>!e))},h.default.createElement($s,{"aria-hidden":!0},h.default.createElement(o.IconActionSearch,null)),h.default.createElement(Cs,null,h.default.createElement(ks,T({},$.getReferenceProps({ref:k.refs.setReference,id:y.input,value:p,placeholder:t,"aria-autocomplete":"list",type:"text",autoComplete:"off",onChange:e=>{const t=e.target.value;O(t),t?(I(!0),F.setActiveIndex(0)):C()},onClick:()=>I((e=>!e)),onKeyDown:e=>{"Enter"===e.key&&void 0!==F.activeItem&&(M(F.activeItem),k.refs.domReference.current?.focus())},readOnly:r,"aria-disabled":r}),{"aria-labelledby":y.label}))),P&&h.default.createElement(Es,{onClick:e=>{e.stopPropagation(),C(),O(""),I(!0)},"aria-label":"Clear selection"},"Clear")),h.default.createElement(Hi,{value:N},h.default.createElement(xs,null))))})),Is=y.default.div`
  ${ss}
`,Ts=(e,t)=>e.toLocaleLowerCase().includes(t.toLocaleLowerCase()),Fs=e=>Boolean(e?.props?.label)&&!Boolean(e?.props?.value),Rs=e=>Boolean(e?.props?.label)&&Boolean(e?.props?.value),Ms=({children:t})=>{const{floatingData:r,interactions:a,listRefs:o,multiSelect:l}=Wi(),{filterValue:n,isOpen:d}=Vi(),s=e.useMemo((()=>{const r=[];e.Children.forEach(t,(t=>{if(h.default.isValidElement(t))if(Fs(t)){const a=e.Children.toArray(t?.props?.children).filter((e=>{if(!h.default.isValidElement(e))return!1;return Rs(e)&&Ts(e.props.label,n)}));a.length>0&&r.push(e.cloneElement(t,{key:t.props.label},a))}else(Rs(t)&&Ts(t.props.label,n)||r.length>0&&Fs(r.slice(-1)[0]))&&r.push(t)}));return r.length>0&&!Rs(r.slice(-1)[0])&&!Fs(r.slice(-1)[0])&&r.pop(),r}),[t,n]);return d?h.default.createElement(i.FloatingPortal,null,h.default.createElement(i.FloatingFocusManager,{context:r.context,initialFocus:-1,visuallyHiddenDismiss:!0},h.default.createElement(Is,T({ref:r.refs.setFloating,style:{...r.floatingStyles}},a.getFloatingProps(),{"aria-multiselectable":l}),h.default.createElement(i.FloatingList,{elementsRef:o.elementsRef,labelsRef:o.labelsRef},s)))):null},Ls=y.default.div`
  ${vs}
`,Os=({id:e})=>{const{selectedItems:t,handleSelect:r}=Wi();return h.default.createElement(Ls,{id:e},t.selectedOptions.size>0&&[...t.selectedOptions.entries()].map((([e,{prefix:t}])=>h.default.createElement(ml,{key:`select-tag-${e}`,prefix:t,onClick:()=>r({label:e,value:e})},e))))},As=y.default.div`
  width: 100%;
`,Ps=y.default.div`
  line-height: 0px;
`,Ns=y.default.button`
  ${is}
`,Ds=y.default.div`
  ${fs};
`,Bs=y.default.input`
  cursor: inherit;

  width: 100%;
  padding: var(--layout-sandgrain);

  background-color: inherit;
  border: none;

  &:focus {
    outline: none;
  }

  ${ds}
`,Hs=y.default.div`
  overflow: hidden;
  display: inline-block;
  width: 100%;
`,Vs=y.default.div`
  line-height: 0;
`,zs=y.default(So)`
  ${ps}
`,Ws=e.forwardRef((({children:t,placeholder:r="Type",warningText:a,errorText:l,helpText:n,disabled:s=!1,isRequired:c=!1,label:u,labelVisible:b=!0,multiSelect:f=!1,onChange:v,initialSelected:p,onOutsideClick:m,showClear:g=!0,...x},y)=>{const[E,w]=e.useState(""),[k,C]=d.useDebounceValue("",200),{showError:$,showHelpText:S,showWarning:I}=Rn({errorText:l,helpText:n,warningText:a}),{ariaDescribedByValues:F,componentIds:R}=Tn({showHelpText:S,showWarning:I}),{isDisabled:M}=Fn({disabled:s}),L=e.useId(),O=e.useRef(null),A=i.useMergeRefs([O,y]),{floatingData:P,handleClear:N,interactions:D,isOpen:B,setIsOpen:H,activeSelectItem:V,selectedItems:z,handleSelect:W,listRefs:j}=Mn({multiSelect:f,initialSelected:p,disabled:M,type:"combobox"}),q=e=>{w(e),C(e)};e.useEffect((()=>{if(v&&v(z.selectedValues),f)q("");else{void 0!==z.selectedValues&&w(z.selectedValues.label),C("")}}),[z.selectedValues]);const G=e.useCallback((()=>{B&&(H(!1),m?.())}),[B,H,m]);d.useOnClickOutside([O,P.refs.floating],G);const K=g&&z.selectedOptions.size>0&&!M,U=e.useMemo((()=>({isOpen:B,filterValue:k})),[B,k]);return h.default.createElement(As,T({ref:A},x),h.default.createElement(zi,{value:{activeSelectItem:V,handleSelect:W,multiSelect:f,selectedItems:z,interactions:D,floatingData:P,listRefs:j}},h.default.createElement(rl,{hidden:!b,isRequired:c,id:R.label},u),h.default.createElement(Ds,{$disabled:M,$hasErrors:$,$hasWarnings:I,ref:P.refs.setPositionReference,onBlur:()=>{if(!f){const e=z.selectedValues?.label;e&&w(e)}},onClick:()=>H((e=>!e))},!f&&z.selectedValues?.prefix&&h.default.createElement(Ps,null,z.selectedValues.prefix),h.default.createElement(Hs,null,f&&h.default.createElement(Os,{id:L}),h.default.createElement(Bs,T({},D.getReferenceProps({ref:P.refs.setReference,id:R.input,value:E,placeholder:r,"aria-autocomplete":"list",type:"text",autoComplete:"off",onChange:e=>{const t=e.target.value;q(t),t?(H(!0),V.setActiveIndex(0)):!f&&N()},onClick:()=>H((e=>!e)),onKeyDown:e=>{"Enter"===e.key&&void 0!==V.activeItem&&(W(V.activeItem),P.refs.domReference.current?.focus())},readOnly:M,"aria-disabled":M}),{"aria-labelledby":f?[R.label,L].join(" "):R.label,"aria-required":c},l&&{"aria-invalid":!0,"aria-errormessage":R.error},F.length>0&&{"aria-describedby":F}))),K&&h.default.createElement(Ns,{onClick:e=>{e.stopPropagation(),N(),q(""),H(!0)},"aria-label":"Clear selection"},"Clear"),h.default.createElement(Vs,null,h.default.createElement(o.IconActionSelect,{"aria-hidden":!0}))),n&&h.default.createElement(Wo,{id:R.help},n),I&&a&&h.default.createElement(Xo,{id:R.warning},a),$&&l&&h.default.createElement(Uo,{id:R.error},l),h.default.createElement(Hi,{value:U},h.default.createElement(Ms,null,t))))})),js=y.default.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`,qs=y.default.div`
  display: flex;
  justify-content: space-between;
`,Gs=y.default.div`
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;

  background-color: var(--control-bg-primary);
  border: var(--border-b-seed) var(--control-border-default) solid;
  border-radius: var(--border-r-seed);

  ${ns}
`,Ks=y.default.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--layout-seed) var(--layout-stamp);
`,Us=y.default.div`
  display: flex;
  padding-right: var(--layout-soybean);
`,Zs=y.default.input`
  width: 100%;
  padding: var(--layout-sandgrain);
  background-color: inherit;
  border: none;

  &:focus {
    outline: none;
  }

  ${({disabled:e})=>e&&a.css`
      cursor: not-allowed;
      color: var(--control-text-disabled);
    `}
  ${ds}
`,_s=y.default(So)`
  width: 100%;
  height: 34px;
`,Ys=y.default(jt)`
  border-radius: var(--border-r-sandgrain);
`,Xs=y.default(Ot)`
  border-radius: var(--border-r-sandgrain);
`,Js={copy:({label:e,value:t})=>h.default.createElement(Ys,{label:e,size:"md",value:t}),default:()=>null,sensitive:({inputId:e,inputType:t,setInputType:r})=>{const a="password"!==t,l=a?o.IconActionPasswordHide:o.IconActionPasswordShow,n=a?"Hide sensitive text":"Reveal sensitive text";return h.default.createElement(Xs,{"aria-controls":e,"aria-label":n,onClick:()=>{r("password"!==t?"password":"text")}},h.default.createElement(l,null))}},Qs=({variant:e,...t})=>{const r=Js[e];return h.default.createElement(r,T({variant:e},t))},ec="16px",tc=y.default.div`
  position: relative;
  display: flex;
  flex-direction: column;
`,rc=y.default.label`
  cursor: pointer;

  display: flex;
  gap: var(--layout-soybean);
  align-items: center;

  font: var(--body-xs-medium);

  ${({isHovered:e,isFocused:t,disabled:r})=>r?"color: var(--control-text-disabled); cursor: not-allowed;":e?"color: var(--control-text-hover);":t?"color: var(--control-text-focus);":"color: var(--control-text-primary);"}
`,ac=y.default(Wo)`
  padding-left: calc(${ec} + var(--layout-soybean));
  ${({disabled:e})=>e&&"color: var(--control-text-disabled);"}
`,oc=y.default.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${ec};
  min-width: ${ec};
  height: ${ec};

  color: transparent;

  background-color: var(--control-bg-primary);
  border: var(--border-b-seed) solid var(--control-border-default);
  border-radius: var(--border-r-circle);
  box-shadow: none;

  ${({checked:e,hasErrors:t,disabled:r})=>r?sc:e?t?ic:dc:t?nc:lc}

  ${({isFocused:e})=>e&&"outline: var(--control-border-focus-ring) solid var(--border-b-stamp);"}
`,lc=a.css`
  background-color: var(--control-bg-primary);
  border-color: var(--control-border-default);

  ${({isHovered:e})=>e&&"background-color: var(--control-bg-hover); border-color: var(--control-border-hover);"}
  ${({isFocused:e})=>e&&"background-color: var(--control-bg-focus); border-color: var(--control-border-focus);"}
`,nc=a.css`
  background-color: var(--control-bg-primary);
  border-color: var(--control-border-bad);
`,dc=a.css`
  color: var(--control-icon-oninvert-selected);
  background-color: var(--control-bg-selected);
  border-color: var(--control-border-selected);

  ${({isHovered:e})=>e&&"background-color: var(--control-bg-selected-hover); border-color: var(--control-border-hover);"}
  ${({isFocused:e})=>e&&"background-color: var(--control-bg-selected-focus); border-color: var(--control-border-focus);"}
`,ic=a.css`
  color: var(--control-icon-oninvert-selected);
  background-color: var(--control-bg-bad-emphasis);
  border-color: var(--control-border-bad);
`,sc=a.css`
  background-color: var(--control-bg-primary-disabled);
  border-color: var(--control-border-disabled);

  ${({checked:e})=>e&&"color: var(--control-icon-disabled);"}
`,cc=e.forwardRef((({checked:t,warningText:r,errorText:a,disabled:l=!1,label:n,helpText:d,style:i,className:s,...c},u)=>{const b=e.useId(),f=e.useId(),[v,p]=e.useState(!1),[m,g]=e.useState(!1),{isDisabled:x,isError:y}=Fn({disabled:l,hasError:Boolean(a)});return h.default.createElement(tc,{style:i,className:s},h.default.createElement(rc,{onMouseEnter:()=>g(!0),onMouseLeave:()=>g(!1),disabled:x,isHovered:m,isFocused:v},h.default.createElement(xn,T({type:"radio","data-testid":"radiobutton-base",ref:u,checked:t,onFocus:()=>p(!0),onBlur:()=>p(!1),disabled:x},a&&{"aria-invalid":!0,"aria-errormessage":b},d&&{"aria-describedby":f},c)),h.default.createElement(oc,{"data-testid":"styled-radiobutton",hasErrors:y,checked:t,isFocused:v,isHovered:m,disabled:x,"aria-hidden":"true"},h.default.createElement(o.IconActionRadio,null)),n),d&&h.default.createElement(ac,{disabled:x,id:f},d),r&&!a&&h.default.createElement(Xo,null,r),a&&h.default.createElement(Uo,{id:b},a))})),uc=y.default.div`
  display: flex;
  flex-direction: column;
  gap: var(--layout-seed);
`,bc=y.default.label`
  cursor: pointer;

  display: flex;
  gap: var(--layout-soybean);
  align-items: center;

  padding: var(--layout-seed) var(--layout-spoon);

  font: var(--body-xs-medium);
  color: var(--control-text-primary);

  background-color: var(--control-bg-primary);
  border: var(--border-b-seed) solid var(--control-border-default);
  border-radius: var(--border-r-shoe);

  &:hover {
    color: var(--control-text-hover);
    background-color: var(--control-bg-decorative-hover);
  }

  &:focus-within {
    color: var(--control-text-focus);
    background-color: var(--control-bg-decorative-focus);
    outline: var(--border-b-soybean) solid var(--control-border-focus-ring);
  }

  ${({isChecked:e})=>e&&a.css`
      color: var(--control-text-selected);
      background-color: var(--control-bg-light-selected);
      border: var(--border-b-seed) solid var(--control-border-selected);

      &:hover {
        color: var(--control-text-hover);
        background-color: var(--control-bg-decorative-hover);
        border: var(--border-b-seed) solid var(--control-border-selected);
      }

      &:focus-within {
        color: var(--control-text-focus);
        background-color: var(--control-bg-decorative-focus);
        border: var(--border-b-seed) solid var(--control-border-selected);
        outline: var(--border-b-soybean) solid var(--control-border-focus-ring);
      }
    `}

  ${({hasError:e})=>e&&a.css`
      color: var(--control-text-primary);
      background-color: var(--control-bg-primary);
      border: var(--border-b-seed) solid var(--control-border-bad);

      &:hover {
        color: var(--control-text-hover);
        background-color: var(--control-bg-decorative-hover);
        border: var(--border-b-seed) solid var(--control-border-bad);
      }

      &:focus-within {
        color: var(--control-text-focus);
        background-color: var(--control-bg-decorative-focus);
        border: var(--border-b-seed) solid var(--control-border-bad);
        outline: var(--border-b-soybean) solid var(--control-border-focus-ring);
      }
    `}

  ${({hasError:e,isChecked:t})=>e&&t&&a.css`
      color: var(--control-text-selected);
      background-color: var(--control-bg-bad-decorative);
      border: var(--border-b-seed) solid var(--control-border-bad);

      &:hover {
        color: var(--control-text-hover);
        background-color: var(--control-bg-bad-decorative);
        border: var(--border-b-seed) solid var(--control-border-bad);
      }

      &:focus-within {
        color: var(--control-text-focus);
        background-color: var(--control-bg-bad-decorative);
        border: var(--border-b-seed) solid var(--control-border-bad);
        outline: var(--border-b-soybean) solid var(--control-border-focus-ring);
      }
    `}

  ${({isDisabled:e})=>e&&a.css`
      color: var(--control-text-neutral);
      background-color: var(--control-bg-primary-disabled);
      border: var(--border-b-seed) solid var(--control-border-disabled);

      &:hover {
        cursor: not-allowed;
        color: var(--control-text-neutral);
        background-color: var(--control-bg-primary-disabled);
        border: var(--border-b-seed) solid var(--control-border-disabled);
      }
    `}
`,fc=e.forwardRef((({checked:e,disabled:t=!1,label:r,...a},o)=>{const{isDisabled:l,isError:n}=Fn({disabled:t});return h.default.createElement(bc,{hasError:n,isChecked:e,isDisabled:l},h.default.createElement(xn,T({checked:e,disabled:l,ref:o,type:"radio"},a)),r)})),vc=y.default.div`
  display: flex;
  flex-direction: row;
  gap: var(--layout-soybean);
`,pc=y.default(ze)`
  display: flex;
  align-items: center;

  width: 100%;

  border-color: var(--control-border-default);
  border-style: solid;
  border-width: var(--border-b-seed);
  border-radius: var(--border-r-seed);
  box-shadow: none;

  ${({isInputHovered:e})=>e&&a.css`
      border-color: var(--control-border-hover);
    `}

  ${({isInputFocused:e})=>e&&a.css`
      border-color: var(--control-border-hover);
      outline: var(--border-b-stamp) solid var(--control-border-focus-ring);
    `}
`,mc=y.default(an)`
  padding: calc(var(--layout-seed) - var(--border-b-seed)) var(--layout-soybean)
    calc(var(--layout-seed) - var(--border-b-seed)) calc(var(--layout-stamp) - var(--border-b-seed));

  &::placeholder {
    color: var(--control-text-secondary);
  }

  &[type='search']::-webkit-search-cancel-button {
    appearance: none;
  }
`,gc=y.default(Ot)`
  border-top-left-radius: var(--border-r-sandgrain);
  border-bottom-left-radius: var(--border-r-sandgrain);
`,hc=y.default(me).attrs((()=>({variant:"link"})))`
  display: inline-block;
  margin-right: var(--layout-stamp);
  visibility: ${({visible:e})=>e?"visible":"hidden"};
`,[xc,yc]=ke({hookName:"useSegmentedControlGroup",providerName:"SegmentedControlGroup"}),Ec=y.default.div`
  width: 100%;
`,wc=y.default.div`
  background: var(--control-bg-secondary);
  border-radius: var(--border-r-seed);
  display: grid;
  gap: var(--layout-spot);
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  padding: var(--layout-spot);
  min-height: 32px;

  ${({buttonSize:e})=>"lg"===e&&a.css`
      min-height: 40px;
    `}
`,kc=y.default(me)`
  background: none;
  border: var(--border-b-sandgrain);
  border-radius: var(--border-r-spot);
  color: var(--control-text-primary);
  display: flex;
  justify-content: center;
  font: var(--body-xs-medium);
  padding: 0 var(--layout-soybean);
  height: 100%;
  white-space: nowrap;

  &:hover {
    background: var(--action-bg-decorative-hover);
    color: var(--control-text-hover);
  }

  &:focus {
    background: var(--control-bg-decorative-focus);
    color: var(--control-text-focus);
  }

  ${({buttonSize:e})=>("md"===e||"lg"===e)&&a.css`
      padding: 0 var(--layout-spoon);
    `}

  ${({isSelected:e})=>e&&a.css`
      background: var(--control-bg-oninvert-selected);
      color: var(--control-text-selected);

      &:focus {
        background: var(--control-bg-focus);
      }
    `}
`,Cc=y.default(A)`
  color: var(--control-text-secondary);
`,$c=y.default.div`
  width: 100%;
`,Sc=y.default.div`
  ${fs}
`,Ic=y.default.div`
  overflow: hidden;
  display: flex;
  flex: 1 1 0;
`,Tc=y.default.div`
  ${vs}
`,Fc=y.default.button`
  ${is}
`,Rc=y.default.div`
  ${ss}
`,Mc=y.default(So)`
  ${ps}
`,Lc="transform, background-color 150ms linear",Oc=y.default.label`
  cursor: ${({disabled:e})=>e?"not-allowed":"pointer"};

  display: flex;
  gap: var(--layout-saxophone);
  justify-content: space-between;

  font: var(--body-xs-emphasis);
`,Ac=y.default.div`
  display: flex;
  gap: var(--layout-soybean);
`,Pc=y.default.div`
  display: flex;
  align-items: center;

  width: ${46}px;
  height: 24px;
  padding: var(--layout-sandgrain) ${3}px;

  background-color: var(--control-icon-neutral);
  border-radius: var(--border-r-pill);

  transition: ${Lc};
  ${({checked:e})=>e?Nc:Dc}
  ${({disabled:e})=>e&&"background-color: var(--control-bg-neutral-disabled)"};
  ${({isFocused:e})=>e&&"outline: var(--border-b-soybean) solid var(--control-border-focus-ring);"}
`,Nc=a.css`
  background-color: var(--control-bg-selected);

  ${({isHovered:e})=>e&&"background-color: var(--control-bg-selected-hover)"};
  ${({isFocused:e})=>e&&"background-color: var(--control-bg-selected-focus)"};
`,Dc=a.css`
  background-color: var(--control-bg-neutral);

  ${({isHovered:e,isFocused:t})=>(e||t)&&"background-color: var(--control-text-disabled)"};
`,Bc=y.default.div`
  transform: ${({checked:e})=>e?"translateX(22px)":"none"};

  width: ${18}px;
  height: ${18}px;

  background-color: ${({disabled:e})=>e?"var(--control-bg-oninvert-surface-disabled)":"var(--control-bg-oninvert-surface)"};
  border-radius: var(--border-r-circle);

  transition: ${Lc};
`,Hc=y.default(A)`
  ${({isFocused:e})=>e&&"color: var(--control-text-focus);"}
  ${({disabled:e})=>e&&"color: var(--control-text-disabled);"}
`,Vc=e.forwardRef((({label:t,labelVisible:r=!0,disabled:a=!1,checked:o,onChange:l,style:n,className:d,statusText:i,...s},c)=>{const[u,b]=e.useState(!1),[f,v]=e.useState(!1),[p,m]=e.useState(!1),g=void 0!==o?o:u,{isDisabled:x}=Fn({disabled:a});return h.default.createElement(Oc,{style:n,className:d,onMouseEnter:()=>m(!0),onMouseLeave:()=>m(!1),disabled:x},r&&t,h.default.createElement(Ac,null,i&&h.default.createElement(Hc,{"aria-hidden":"true",isFocused:f,disabled:x},i),h.default.createElement(xn,T({},s,{type:"checkbox",role:"switch",ref:c},!r&&{"aria-label":t},{disabled:x,checked:g,onChange:e=>{b(e.target.checked),l?.(e)},onFocus:()=>v(!0),onBlur:()=>v(!1)},i&&{"aria-description":i})),h.default.createElement(Pc,{checked:g,"aria-hidden":!0,isFocused:f,isHovered:p,disabled:x},h.default.createElement(Bc,{disabled:x,checked:g}))))})),zc=y.default.div`
  display: flex;
  flex-direction: column;
`,Wc=y.default.div`
  display: flex;
  justify-content: space-between;
`,jc=y.default.textarea`
  overflow: hidden;
  min-height: 72px;
  padding: var(--layout-seed) var(--layout-stamp);
  font: var(--body-xs);

  ${ns}
  ${ds}
`,qc=y.default.div`
  display: flex;
  flex-direction: column;
  gap: var(--layout-soybean);
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;
`,Gc=y.default(A)`
  font: var(--body-xs-medium);
  color: var(--base-text-secondary);
`,Kc=a.keyframes`
  33%, 59.6% {
    height: 12px;
    border-radius: 2px 0px 0px 2px;
  }
  39.6%, 49.5% {
    height: 24px;
    border-radius: 2px;
  }
`,Uc=a.keyframes`
  39.6%, 69.3% {
    height: 12px;
    border-radius: 0px;
  }
  49.6%, 59.4% {
    height: 24px;
    border-radius: 2px;
  }
`,Zc=a.keyframes`
  49.5%, 79.2% {
    height: 12px;
    border-radius: 0px 2px 2px 0px;
  }
  59.4%, 69.3% {
    height: 24px;
    border-radius: 2px;
  }
`,_c=y.default.div`
  width: 18px;
  height: 12px;
`,Yc=y.default.div`
  display: flex;
  align-items: center;
  width: 54px;
  height: 24px;
  & > ${_c}:nth-child(1) {
    background-color: var(--control-bg-light-selected);
    border-radius: 2px 0 0 2px;
    animation: ${Kc} 1s linear infinite;
  }
  & > ${_c}:nth-child(2) {
    background-color: var(--control-data-vis-default-2);
    animation: ${Uc} 1s linear infinite;
  }
  & > ${_c}:nth-child(3) {
    background-color: var(--control-bg-selected);
    border-radius: 0 2px 2px 0;
    animation: ${Zc} 1s linear infinite;
  }
`,Xc=y.default.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;
  padding: var(--layout-shoe);
`,Jc=y.default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
`,Qc=y.default.div`
  display: flex;
  gap: var(--layout-spoon);
  justify-content: center;
  padding-top: var(--layout-shoe);
`,eu=y.default(A)`
  padding-top: var(--layout-soybean);
  font: var(--body-xs-medium);
  color: var(--base-text-secondary);
  text-align: center;
`,tu=y.default(D)`
  padding-top: var(--layout-shoebox);
  text-align: center;
`,ru=y.default(A)((({withBackground:e,interactive:t,uppercase:r,withBorder:o})=>a.css`
    display: inline-flex;
    align-items: center;

    padding: calc(var(--layout-seed) - var(--border-b-seed)) var(--layout-soybean);

    font: var(--legacy-sm);
    text-transform: ${r?"var(--text-loud)":"none"};
    white-space: nowrap;

    border-radius: var(--border-r-pill);

    tr & {
      background-color: 'var(--control-bg-secondary)';
    }

    &:focus {
      text-decoration: ${t?"underline":"none"};
      outline: ${t?"var(--border-r-focus-ring) solid var(--control-border-focus-ring)":"none"};
    }

    &:hover {
      text-decoration: ${t?"underline":"none"};
    }

    ${l.variant({prop:"type",variants:{default:{color:"var(--control-text-primary)",backgroundColor:"var(--control-bg-secondary)",border:o?"var(--border-b-seed) solid var(--control-border-default)":"var(--border-b-sandgrain)"},info:{color:"var(--control-text-neutral)",backgroundColor:"var(--control-bg-neutral-decorative)",border:o?"var(--border-b-seed) solid var(--control-border-neutral)":"var(--border-b-sandgrain)"},success:{color:"var(--control-text-good)",backgroundColor:"var(--control-bg-good-decorative)",border:o?"var(--border-b-seed) solid var(--control-border-good)":"var(--border-b-sandgrain)"},alert:{color:"var(--control-text-bad)",backgroundColor:"var(--control-bg-bad-decorative)",border:o?"var(--border-b-seed) solid var(--control-border-bad)":"var(--border-b-sandgrain)"},warning:{color:"var(--control-text-warn)",backgroundColor:"var(--control-bg-warn-decorative)",border:o?"var(--border-b-seed) solid var(--control-border-warn)":"var(--border-b-sandgrain)"}}})}

    tr &&:hover {
      ${l.variant({prop:"type",variants:{default:{backgroundColor:"var(--control-bg-secondary)"},info:{backgroundColor:"var(--control-bg-neutral-decorative)"},success:{backgroundColor:"var(--control-bg-good-decorative)"},alert:{backgroundColor:"var(--control-bg-bad-decorative)"},warning:{backgroundColor:"var(--control-bg-warn-decorative)"}}})}
    }

    tr:hover && {
      cursor: pointer;
    }

    svg {
      margin-right: var(--layout-soybean);

      path {
        fill: currentcolor;
      }
    }

    ${!e&&"background-color: var(--control-bg-primary)"};
    ${!o&&"padding: var(--layout-seed) var(--layout-soybean)"};
    ${!t&&"text-decoration: none"};
    ${t&&"cursor: pointer;"};
  `)),au=({icon:e,children:t,withBackground:r=!0,uppercase:a=!1,interactive:o=!0,type:l="default",withBorder:n=!0,...d})=>h.default.createElement(ru,T({withBackground:r,interactive:o,type:l,"data-testid":"text-status",uppercase:a,as:o?"a":"span",tabIndex:o?0:-1,withBorder:n},d),e&&h.default.createElement(e,null),t),ou=y.default.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  padding: var(--layout-saxophone) var(--layout-sandgrain);
`,lu=y.default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 480px;
`,nu=y.default.div`
  width: 24px;
  height: 24px;
  margin-bottom: var(--layout-stamp);
`,[du,iu]=ke(),[su,cu]=ke({hookName:"useTableCellContext",providerName:"Table"}),uu=a.css`
  position: relative;
  border-spacing: 0;
  border-collapse: collapse;
  width: 100%;
`,bu=y.default.table`
  ${uu}
  table-layout: ${({$tableLayout:e})=>e};
`,fu=y.default.tbody``,vu=l.compose(l.typography,l.width,l.space,l.color),pu=()=>a.css`
  ${l.typography({textAlign:"left"})}
  ${({density:e})=>"compact"===e?"padding: var(--layout-soybean) var(--layout-shoebox);":"padding: var(--layout-spoon) var(--layout-shoebox);"}
`,mu=y.default.th`
  font: var(--body-xs-emphasis);
  ${pu}
  ${vu}
`,gu=y.default.td`
  font: var(--body-xs-medium);
  vertical-align: middle;
  ${pu}
  ${vu}
`,hu=y.default.button`
  position: absolute !important;

  overflow: hidden;

  width: 1px;
  height: 1px;

  white-space: nowrap;

  clip: rect(0 0 0 0);
  clip-path: inset(50%);

  &:focus {
    outline: none; /* Focus within is set on TR element instead */
  }
`,xu={td:gu,th:mu},yu=({children:e,ref:t,as:r="td",density:a,...o})=>{const l=xu[r],{isActionable:n}=cu(),{density:d}=iu();return h.default.createElement(l,T({},o,{density:a??d}),n&&h.default.createElement(hu,null,"Open table row"),e)},Eu=a.css`
  color: var(--control-text-selected);
  background: var(--control-bg-light-selected);
`,wu=a.css`
  ${fu} &&:nth-of-type(even) {
    background: var(--control-bg-secondary);
  }
`,ku=y.default.tr.withConfig({shouldForwardProp:e=>!["isActive","isActionable"].includes(e)})`
  color: var(--control-text-secondary);

  tbody &:not(:last-child) {
    border-bottom: var(--border-b-seed) solid var(--base-border-secondary);
  }
  ${({$alternatingBackground:e})=>e&&wu}

  ${fu} &&:hover {
    color: var(--control-text-hover);
    background: var(--control-bg-decorative-hover);
  }

  ${fu} &&:focus {
    color: var(--control-text-focus);
    background: var(--control-bg-decorative-focus);
  }

  && {
    ${({isActive:e})=>e&&Eu}
  }

  ${({isActionable:e})=>e&&a.css`
      && {
        cursor: pointer;
      }

      ${fu} &&:focus-within, ${fu} &&:active {
        background: var(--control-bg-light-selected);
        outline: var(--control-border-focus-ring) solid var(--border-b-stamp);
      }
    `}

  ${({$hasBorders:e})=>e?void 0:a.css`
          ${fu} &&:not(:last-child) {
            border-bottom: none;
          }
        `}
`,Cu=h.default.forwardRef((({active:e,children:t,onInteraction:r,hasBorders:a=!0,...o},l)=>{const n="function"==typeof r,{alternatingBackground:d}=iu();return h.default.createElement(ku,T({},o,{ref:l,isActive:e,isActionable:n,$hasBorders:a,$alternatingBackground:d,onClick:e=>r&&r(e)}),h.default.Children.map(t,((e,t)=>h.default.createElement(su,{value:{isActionable:0===t&&n}},e))))})),$u=y.default.thead`
  background-color: var(--base-bg-primary);
  box-shadow: inset 0 calc(var(--border-b-seed) * -1) 0 var(--base-border-secondary);
`,Su=({children:e,headers:t,...r})=>t?h.default.createElement($u,r,h.default.createElement(Cu,null,t.map((e=>h.default.createElement(yu,{as:"th",key:e,density:"compact"},e))))):h.default.createElement($u,r,e),Iu=y.default(Su)`
  position: sticky;
  top: 0;
`,Tu=y.default(A)`
  display: inline-flex;
  order: 2;
`,[Fu,Ru]=ke({hookName:"useTablePaginationContext",providerName:"TablePagination"}),Mu=()=>{const{totalResults:e,resultsPerPage:t,currentStep:r}=Ru();if("number"==typeof e&&t&&r){const a=e>0?t*(r-1)+1:0,o=e>0?Math.min(t*(r-1)+t,e):0,l=e>1e4?"10,000+":new Intl.NumberFormat("en-US").format(e);return h.default.createElement(Tu,null,a," —",` ${o} of ${l} results`)}return null},Lu=y.default(A)`
  padding: var(--layout-seed) var(--layout-stamp);
  color: var(--base-text-secondary);
`,Ou=y.default($a)`
  ${({selected:e})=>e&&"background-color: var(--action-bg-selected); color: var(--action-text-oninvert-secondary)"}
`,Au=({number:e,...t})=>{const{currentStep:r}=Ru();return h.default.createElement(Ou,T({"aria-current":r===e,selected:r===e,"aria-label":`Go to page ${e}`},t),e.toString())},Pu=()=>{const{currentStep:t,totalPages:r,setPage:a}=Ru(),o=e.useMemo((()=>{if(!r)return[];if(r<=7){return[...Array(r+1).keys()].slice(1)}if(t<=4){return[...[...Array(6).keys()].slice(1),void 0,r]}if(t>4&&t<r-3)return[1,void 0,t-1,t,t+1,void 0,r];if(t>=r-3){return[1,void 0,...[...Array(5).keys()].reverse().map((e=>r-e))]}return[]}),[r,t]);return h.default.createElement(h.default.Fragment,null,o.map(((e,t)=>"number"==typeof e?h.default.createElement(Au,{key:`pagination-button-${e}`,onClick:()=>a(e),number:e,size:"sm"}):h.default.createElement(Lu,{key:`pagination-ellipsis-${t}`},"..."))))},Nu=y.default.div`
  display: inline-flex;
  gap: var(--layout-spoon);
  order: 1;
`,Du=y.default.div`
  display: inline-flex;
  gap: var(--layout-seed);
`,Bu=()=>{const{goToFirstStep:e,goToLastStep:t,canGoToNextStep:r,goToPrevStep:a,canGoToPrevStep:l,goToNextStep:n,totalPages:d}=Ru();return h.default.createElement(h.default.Fragment,null,h.default.createElement(Mu,null),h.default.createElement(Nu,null,h.default.createElement(Du,null,e&&h.default.createElement(gl,{text:"First"},h.default.createElement(Ot,{disabled:!l,"aria-label":"Go to first page",onClick:e,size:"sm"},h.default.createElement(o.IconActionChevronDoubleLeft,null))),h.default.createElement(gl,{text:"Previous"},h.default.createElement(Ot,{disabled:!l,"aria-label":"Go to previous page",onClick:a,size:"sm"},h.default.createElement(o.IconActionChevronLeft,null)))),0!==d&&h.default.createElement(Du,null,h.default.createElement(Pu,null)),h.default.createElement(Du,null,h.default.createElement(gl,{text:"Next"},h.default.createElement(Ot,{disabled:!r,"aria-label":"Go to next page",onClick:n,size:"sm"},h.default.createElement(o.IconActionChevronRight,null))),t&&h.default.createElement(gl,{text:"Last"},h.default.createElement(Ot,{disabled:!r,"aria-label":"Go to last page",onClick:t,size:"sm"},h.default.createElement(o.IconActionChevronDoubleRight,null))))))},Hu=y.default.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;

  width: 100%;
  padding-top: var(--layout-spoon);
`;y.default.div`
  display: inline-flex;
  gap: var(--layout-spoon);
  order: 1;
`,y.default.div`
  display: inline-flex;
  gap: var(--layout-seed);
`;const Vu=e=>{const t=e instanceof Date&&!isNaN(e.getTime())?e:new Date(e);if(!p.isValid(t))throw new Error("Invalid Date");return t};let zu=function(e){return e[e.False=0]="False",e[e.True=1]="True",e[e.Loading=2]="Loading",e}({});exports.Accordion=({children:t,id:r,isOpen:a=!1,onClick:o,title:l,headingLevel:n=4,description:d,descriptionPlacement:i,slotEnd:s,variant:c="primary",slot:u,slotPlacement:b="end",close:f,errorMessage:v,hasError:p=!1,open:m,showIcon:g=!0,showTitleHighlight:x=!1,titleIcon:y})=>{const E=e.useId(),w=e.useMemo((()=>"string"==typeof r?r:E),[E,r]);return h.default.createElement(Ne,null,h.default.createElement(Ce,{value:{isOpen:a,title:l,description:d,descriptionPlacement:i??b,variant:c,headingLevel:n,buttonId:w}},h.default.createElement(De,{as:`h${n}`},h.default.createElement(Se,{onClick:o},h.default.createElement(Pe,null,u&&h.default.createElement(Be,null,u)),s&&h.default.createElement(He,null,s))),h.default.createElement(Me,null,t)))},exports.AccordionVariant=Ve,exports.ActionBox=Gt,exports.ActionMenu=e=>{const{hasFlag:t}=I();return t("v11")?h.default.createElement(wa,e):h.default.createElement(ha,e)},exports.ActionMenuButton=({children:t,prefix:r,...a})=>{const{closeMenu:l,isOpen:n,openMenu:d,refs:i,setActiveIndex:s}=ya(),c=()=>n?l():d(),u=e=>{"ArrowDown"!==e.key&&"Enter"!==e.key&&" "!==e.key||(e.preventDefault(),d(),s(0))},b=e.useMemo((()=>({...a,"aria-expanded":!!n,"aria-haspopup":!0,onClick:c,onKeyDown:u,ref:i.setReference})),[c,n,i,a]),f=r||h.default.createElement(o.IconActionMore,null);return t?h.default.createElement($a,T({},b,{prefix:f}),t):h.default.createElement(Ot,b,f)},exports.ActionMenuDivider=({...e})=>h.default.createElement(Sa,e),exports.ActionMenuGroup=({children:t,label:r,...a})=>{const o=e.useId();return h.default.createElement("div",null,h.default.createElement(Ta,{id:o},r),h.default.createElement(Ia,T({},a,{"aria-labelledby":o,role:"group"}),t))},exports.ActionMenuItem=Ra,exports.ActionMenuList=({children:e,...t})=>{const{context:r,listRef:a,getFloatingProps:o,floatingStyles:l,isOpen:n,refs:d}=ya();return n?h.default.createElement(i.FloatingPortal,null,h.default.createElement(i.FloatingFocusManager,{context:r,modal:!1},h.default.createElement(Ma,T({},t,{ref:d.setFloating,role:"menu",style:l},o()),h.default.createElement(i.FloatingList,{elementsRef:a},e)))):null},exports.AlertButton=Xa,exports.AlertButtonStyle=Ya,exports.Announcement=({children:e,open:t,onOpenChange:r,...a})=>h.default.createElement(xd,{open:t,onOpenChange:r},h.default.createElement(Ld,a,e)),exports.AutoCompleteSearchBox=Ss,exports.Badge=ao,exports.BadgeButton=go,exports.BaseButtonStyle=Pa,exports.Box=ze,exports.BrandedLoader=({...t})=>{const r=e.useId(),[a,o]=e.useState("Loading");return d.useTimeout((()=>o("This is taking longer than expected")),3e3),h.default.createElement(h.default.Fragment,null,h.default.createElement(qc,T({role:"status","aria-labelledby":r},t),h.default.createElement(Yc,{"aria-hidden":!0},h.default.createElement(_c,null),h.default.createElement(_c,null),h.default.createElement(_c,null)),h.default.createElement(Gc,{id:r},a)))},exports.BreadcrumbItem=rt,exports.Breadcrumbs=({children:e,"aria-label":t="Breadcrumbs",...r})=>h.default.createElement(Xe,T({},r,{"aria-label":t,role:"navigation"}),h.default.createElement("ul",null,e)),exports.Breakpoint=({breakpoint:e,children:t})=>Ct(e)?h.default.createElement(h.default.Fragment,null,t):null,exports.Card=({children:e,variant:t="primary",...r})=>h.default.createElement(We,T({variant:t},r),e),exports.CardBody=({children:e,...t})=>h.default.createElement(je,t,e),exports.CardFooter=({children:e,...t})=>h.default.createElement(qe,t,e),exports.CardHeading=({children:e,level:t,...r})=>({1:h.default.createElement(Ke,r,e),2:h.default.createElement(Ue,r,e),3:h.default.createElement(Ze,r,e),4:h.default.createElement(_e,r,e)}[t]),exports.Checkbox=Ln,exports.CheckboxGroup=({children:e,selectAll:t,disabled:r=!1,...a})=>h.default.createElement(nl,T({disabled:r},a),h.default.createElement(On,{selectAll:t},e)),exports.CheckoutLogo=({fillColor:e="var(--base-icon-primary)",...t})=>h.default.createElement("svg",T({role:"img",width:"394",height:"68",viewBox:"0 0 394 68",fill:"none",xmlns:"http://www.w3.org/2000/svg"},t),h.default.createElement("title",null,"Checkout.com logo"),h.default.createElement("g",{"clip-path":"url(#clip0_6053_67)"},h.default.createElement("path",{d:"M59 1H9C4.6 1 1 4.6 1 9V59C1 63.4 4.6 67 9 67H59C63.4 67 67 63.4 67 59V9C67 4.6 63.4 1 59 1Z",fill:"#006CFF"}),h.default.createElement("path",{d:"M40.2 34.5C39.961 34.021 39.9476 33.7086 40.2 33.2L50.2 16.1C50.7 15.2 50.1 13.9 48.9 13.9H26.7C26.2 13.9 25.7758 14.1453 25.5 14.6L14.3 33.1C14.0327 33.5575 14.0425 34.1437 14.3 34.6L25.5 53.1C25.7465 53.5559 26.1568 53.8 26.7 53.8H48.9C50 53.8 50.7 52.6 50.2 51.6L40.2 34.5ZM45.1 17.7L37.8 30.2L30.5 17.7H45.1ZM18.3 34L26.9 19.6L35.3 34L26.9 48.4L18.3 34ZM30.6 50.3L37.9 37.8L45.2 50.3H30.6Z",fill:"white"}),h.default.createElement("path",{d:"M100.47 21.2283C104.912 21.2283 107.786 23.3259 109.257 27.6414L109.37 27.9734L115.167 26.4236L115.077 26.0652C113.35 19.2097 108.027 15.2771 100.473 15.2761C96.0294 15.2166 91.8707 16.8836 88.8126 19.947C85.4146 23.3494 83.6573 28.1179 83.731 33.7273C83.6573 39.3465 85.4146 44.116 88.8126 47.5183C91.8253 50.5359 95.8878 52.1902 100.268 52.1902C100.336 52.1902 100.403 52.1902 100.47 52.1892C108.026 52.1892 113.35 48.2566 115.077 41.4002L115.167 41.0418L109.37 39.492L109.257 39.824C107.786 44.1394 104.912 46.2371 100.47 46.2371C94.128 46.2371 90.188 41.4451 90.188 33.7322C90.188 26.0193 94.128 21.2283 100.47 21.2283Z",fill:"var(--brand-logo-text)"}),h.default.createElement("path",{d:"M132.254 25.1755C128.995 25.1755 126.086 26.658 124.245 29.2V15.2761H118.142V51.7849H124.245V40.6013C124.245 33.7107 127.533 30.572 130.587 30.572C133.226 30.572 134.455 32.0095 134.455 35.0964V51.7849H140.559V33.4294C140.559 28.1843 137.532 25.1755 132.254 25.1755Z",fill:"var(--brand-logo-text)"}),h.default.createElement("path",{d:"M155.621 25.1755C147.174 25.1755 143.326 32.1775 143.326 38.6824C143.326 45.1873 147.174 52.1892 155.621 52.1892C161.237 52.1892 164.941 49.7927 167.276 44.6462L167.439 44.2859L162.37 42.3044L162.211 42.5925C160.571 45.5759 158.734 46.7927 155.873 46.7927C152.396 46.7927 150.119 44.4958 149.578 40.4714H167.663V37.8738C167.663 31.5632 163.527 25.1755 155.621 25.1755ZM155.621 30.572C158.624 30.572 160.652 32.2742 161.372 35.3777H149.889C150.725 32.3582 152.84 30.572 155.621 30.572Z",fill:"var(--brand-logo-text)"}),h.default.createElement("path",{d:"M189.374 42.5115C187.969 45.4724 186.095 46.7927 183.299 46.7927C179.454 46.7927 177.158 43.7605 177.158 38.6824C177.158 33.6042 179.454 30.572 183.299 30.572C186.108 30.572 188.037 31.9304 189.372 34.8484L189.523 35.1775L194.946 32.9275L194.81 32.5837C192.881 27.7371 188.9 25.1755 183.299 25.1755C175.855 25.1755 170.853 30.6033 170.853 38.6824C170.853 46.7615 175.855 52.1892 183.299 52.1892C188.887 52.1892 192.868 49.6101 194.81 44.7302L194.947 44.3835L189.526 42.1921L189.374 42.5115Z",fill:"var(--brand-logo-text)"}),h.default.createElement("path",{d:"M219.405 25.5798H211.833L203.388 35.3044V15.2761H197.284V51.7849H203.388V40.071L212.579 51.7849H220.116L208.658 37.6824L219.405 25.5798Z",fill:"var(--brand-logo-text)"}),h.default.createElement("path",{d:"M232.15 25.1755C224.495 25.1755 219.149 30.7302 219.149 38.6824C219.149 46.6345 224.495 52.1892 232.15 52.1892C239.805 52.1892 245.151 46.6345 245.151 38.6824C245.151 30.7302 239.805 25.1755 232.15 25.1755ZM237.003 44.4656C235.817 46.032 234.23 46.7927 232.15 46.7927C230.066 46.7927 228.416 46.0095 227.246 44.4656C226.04 42.8748 225.454 40.9832 225.454 38.6824C225.454 36.3826 226.04 34.49 227.246 32.8982C228.416 31.3542 230.066 30.572 232.15 30.572C234.229 30.572 235.817 31.3328 237.003 32.8982C238.209 34.49 238.795 36.3826 238.795 38.6824C238.795 40.9832 238.209 42.8748 237.003 44.4656Z",fill:"var(--brand-logo-text)"}),h.default.createElement("path",{d:"M264.279 36.4099C264.279 42.5232 261.733 46.7927 258.088 46.7927C255.588 46.7927 254.372 45.3787 254.372 42.4705V25.5798H248.268V43.9353C248.268 49.0261 251.412 52.1892 256.471 52.1892C259.421 52.1892 262.214 50.7205 264.279 48.1208V51.7849H270.332V25.5798H264.279V36.4099Z",fill:"var(--brand-logo-text)"}),h.default.createElement("path",{d:"M288.393 46.1892C287.726 46.5896 286.891 46.7927 285.909 46.7927C283.8 46.7927 282.9 45.6667 282.9 43.0261V30.9763H289.668V25.5798H282.9V14.9705L276.796 18.8279V25.5798H272.705V30.9763H276.796V42.9246C276.796 48.8992 279.942 52.1892 285.656 52.1892C287.289 52.1892 288.756 51.8699 290.017 51.241L290.295 51.1013L288.811 45.9373L288.393 46.1892Z",fill:"var(--brand-logo-text)"}),h.default.createElement("path",{d:"M296.246 43.8123C293.893 43.8123 292.185 45.5417 292.185 47.9246C292.185 50.2693 293.931 52.0378 296.246 52.0378C298.659 52.0378 300.41 50.3083 300.41 47.9246C300.41 45.5417 298.659 43.8123 296.246 43.8123Z",fill:"var(--brand-logo-text)"}),h.default.createElement("path",{d:"M320.721 42.5115C319.316 45.4724 317.442 46.7927 314.645 46.7927C310.801 46.7927 308.506 43.7605 308.506 38.6824C308.506 33.6042 310.801 30.572 314.645 30.572C317.454 30.572 319.384 31.9304 320.72 34.8484L320.87 35.1775L326.293 32.9275L326.156 32.5837C324.228 27.7371 320.248 25.1755 314.645 25.1755C307.201 25.1755 302.2 30.6033 302.2 38.6824C302.2 46.7615 307.201 52.1892 314.645 52.1892C320.235 52.1892 324.215 49.6101 326.156 44.7302L326.294 44.3835L320.873 42.1921L320.721 42.5115Z",fill:"var(--brand-logo-text)"}),h.default.createElement("path",{d:"M341.098 25.1755C333.444 25.1755 328.097 30.7302 328.097 38.6824C328.097 46.6345 333.444 52.1892 341.098 52.1892C348.753 52.1892 354.1 46.6345 354.1 38.6824C354.1 30.7302 348.753 25.1755 341.098 25.1755ZM345.952 44.4656C344.765 46.032 343.178 46.7927 341.098 46.7927C339.014 46.7927 337.365 46.0095 336.195 44.4656C334.989 42.8748 334.403 40.9832 334.403 38.6824C334.403 36.3826 334.989 34.49 336.195 32.8982C337.365 31.3542 339.014 30.572 341.098 30.572C343.177 30.572 344.765 31.3328 345.952 32.8982C347.158 34.49 347.744 36.3826 347.744 38.6824C347.744 40.9832 347.158 42.8748 345.952 44.4656Z",fill:"var(--brand-logo-text)"}),h.default.createElement("path",{d:"M385.602 25.1755C382.586 25.1755 379.708 26.9646 377.773 30.0027C376.603 26.8816 374.085 25.1755 370.602 25.1755C367.741 25.1755 365.341 26.5076 363.451 29.1384V25.5798H357.348V51.7849H363.451V41.5105C363.451 34.866 365.703 30.572 369.188 30.572C371.408 30.572 372.399 31.7498 372.399 34.3894V51.7849H378.451V41.1062C378.451 34.8054 380.757 30.572 384.188 30.572C386.408 30.572 387.399 31.7498 387.399 34.3894V51.7849H393.452V33.531C393.452 28.2214 390.591 25.1755 385.602 25.1755Z",fill:"var(--brand-logo-text)"})),h.default.createElement("defs",null,h.default.createElement("clipPath",{id:"clip0_6053_67"},h.default.createElement("rect",{width:"394",height:"68",fill:"white"})))),exports.ChoiceGroup=({children:e,legend:t,helpText:r,warningText:a,errorText:l,withTooltip:n=!1,tooltipText:d,isRequired:i})=>{let s;return l?s=h.default.createElement(Uo,null,l):a?s=h.default.createElement(Xo,null,a):r&&(s=h.default.createElement(Wo,null,r)),h.default.createElement(kl,null,t&&(n?h.default.createElement(Sl,null,h.default.createElement(Il,{isRequired:i,forwardedAs:"legend",withTooltip:n},t),h.default.createElement(yl,{text:d},h.default.createElement(o.IconActionAbout,{"data-testid":"choice-tooltip"}))):h.default.createElement(Il,{isRequired:i,forwardedAs:"legend",withTooltip:n},t)),h.default.createElement(Cl,null,e.map((e=>h.default.createElement($l,{key:`checkbox-${e.props.id}`},e)))),s)},exports.ClickableElement=Ja,exports.CoachMark=({steps:e,open:t,onOpenChange:r,isNew:a,onCompleted:o,onDismissed:l,handleScrollToNext:n,...d})=>h.default.createElement(Gd,{steps:e,open:t,isNew:a,onOpenChange:r,onCompleted:o,onDismissed:l,handleScrollToNext:n},e.map(((e,t)=>h.default.createElement(qd,T({index:t+1,key:`coachmark-step-${t+1}`},d))))),exports.CodeBlock=({content:t,headerActions:r,title:a,tabListAriaLabel:o})=>{const[l,n]=e.useState(!1),[d,i]=e.useState(!1),s=Array.isArray(t),c=s?t.map((e=>e.tabName??"")):[],[u,b]=e.useState(s?t[0]?.tabName??"":""),f=e.useMemo((()=>s?t.find((e=>e.tabName===u))??{rawCode:"",innerTitle:void 0}:t),[u,s,t]),{rawCode:v,innerTitle:p}=f,m=(e,t)=>{const r=t.doc.lines??0;i(r>10)};return h.default.createElement(Ye,{condition:s,wrap:e=>h.default.createElement(Rt,{currentValue:u,onChange:e=>b(e)},e)},h.default.createElement(ze,{className:"dark-mode"},h.default.createElement(Gr,{$isExpanded:l},s?h.default.createElement(dr,{tabNames:c,code:v,headerActions:r,tabListAriaLabel:o||""}):h.default.createElement(br,{title:a,code:v,headerActions:r}),p&&h.default.createElement(_r,null,h.default.createElement(Yr,null,p)),h.default.createElement(Kr,null,s?t.map((e=>h.default.createElement(Tt,{value:e.tabName??"",key:e.tabName},h.default.createElement(Zr,{$isExpanded:l,$hasOverflow:d},h.default.createElement(qr,{content:e,handleEditorCreate:m})),d&&!l&&h.default.createElement(Ur,null)))):h.default.createElement(h.default.Fragment,null,h.default.createElement(Zr,{$isExpanded:l,$hasOverflow:d},h.default.createElement(qr,{content:t,handleEditorCreate:m})),d&&!l&&h.default.createElement(Ur,null))),h.default.createElement(pr,{isExpanded:l,hasOverflow:d,onToggleExpand:()=>n((e=>!e))}))))},exports.Combobox=Ws,exports.ComboboxSkeleton=({helpText:e,...t})=>h.default.createElement(As,t,h.default.createElement(al,null),h.default.createElement(zs,null),e&&h.default.createElement(jo,null)),exports.CopyToClipboardButton=jt,exports.DangerButton=eo,exports.DangerButtonStyle=Qa,exports.DestructiveButton=ka,exports.Divider=Zt,exports.Drawer=ia,exports.DrawerBody=({children:e,...t})=>h.default.createElement("div",t,e),exports.DrawerProvider=({children:t,...r})=>{const a=(({open:t,onOpenChange:r})=>{const a=i.useFloating({open:t,onOpenChange:r}),o=a.context,l=i.useClick(o,{enabled:null==t}),n=i.useDismiss(o,{outsidePressEvent:"mousedown",outsidePress:e=>!e?.target?.closest(".drawer-trigger")}),d=i.useRole(o),s=i.useInteractions([l,n,d]);return e.useMemo((()=>({open:t,onOpenChange:r,...s,...a})),[t,r,s,a])})({...r});return h.createElement(na,{value:a},t)},exports.DrawerTrigger=sa,exports.EmptyTableState=({children:e,...t})=>h.default.createElement(ou,t,h.default.createElement(lu,null,e)),exports.EmptyTableStateDescription=({children:e,...t})=>h.default.createElement(A,T({font:"var(--body-xs-medium)",color:"var(--base-text-secondary)",textAlign:"center"},t),e),exports.EmptyTableStateIconContainer=({children:e,...t})=>h.default.createElement(nu,T({"aria-hidden":"true"},t),e),exports.EmptyTableStateTitle=({children:e,...t})=>h.default.createElement(B,t,e),exports.ErrorBoundary=Tl,exports.Fieldset=({children:e,...t})=>h.default.createElement(nl,t,e),exports.FieldsetSkeleton=({...e})=>h.default.createElement(dl,e),exports.FilterButton=({id:e,onClick:t,count:r=0,children:a="Filter"})=>h.default.createElement($a,{"aria-controls":e?`control-${e}`:void 0,suffix:r>0?h.default.createElement(ao,{"data-testid":"badge-btn-value"},r):void 0,"data-testid":"filter-btn",prefix:h.default.createElement(o.IconActionFilter,null),id:e,onClick:t},a),exports.FilterContainer=({actions:e,children:t,isOpen:r,targetId:a})=>{const{ref:o,styles:l}=Fl({isOpen:r});return h.default.createElement(ze,{"aria-expanded":r},h.default.createElement(ze,{ref:o,"aria-labelledby":a,style:{...l}},h.default.createElement(Yt,{gridTemplateColumns:"repeat(auto-fit, minmax(150px, auto))",gridGap:"var(--layout-shoe)"},t),e&&h.default.createElement(qt,{justifyContent:"flex-end",borderBottom:"var(--control-border-default)",py:"var(--layout-spoon)"},e)))},exports.FilterMenu=({children:t,...r})=>{const a=(({open:t,onOpenChange:r})=>{const a=i.useFloating({placement:"bottom-start",open:t,onOpenChange:r,whileElementsMounted:i.autoUpdate,middleware:[i.offset(4),i.flip({crossAxis:!0,fallbackAxisSideDirection:"end",padding:4}),i.shift({padding:4})]}),o=a.context,l=i.useClick(o,{enabled:null==t}),n=i.useDismiss(o),d=i.useRole(o),s=i.useInteractions([l,n,d]);return e.useMemo((()=>({open:t,onOpenChange:r,...s,...a,modal:!0})),[t,r,s,a])})({...r});return h.default.createElement(to,{value:a},t)},exports.FilterMenuButton=oo,exports.FilterMenuContainer=no,exports.FilterMenuContainerBody=io,exports.FilterMenuContainerFooter=so,exports.FilterRow=({children:t,...r})=>{const a=e.Children.toArray(t).slice(0,4);return a.length<3?(console.error("Must have at least 3 children"),null):3===a.length?h.default.createElement(uo,r,h.default.createElement(bo,null,a[0]),h.default.createElement(fo,null,a[1]),a[2]):h.default.createElement(uo,r,h.default.createElement(bo,null,a[0]),h.default.createElement(bo,null,a[1]),h.default.createElement(fo,null,a[2]),a[3])},exports.FilterRowsContainer=({children:e,...t})=>h.default.createElement(vo,t,e),exports.Flex=qt,exports.FormDescription=Rl,exports.FormError=Ll,exports.FormLabel=wl,exports.FormWarning=Ol,exports.FormWrapperWithLabel=({id:t=e.useId(),title:r,hasErrors:a,localError:o,description:l,children:n,warningText:d,isRequired:i,...s})=>{let c;return a?c=h.default.createElement(Uo,null,o??""):d?c=h.default.createElement(Xo,null,d):l&&(c=h.default.createElement(Wo,null,l)),h.default.createElement(Pl,null,h.default.createElement(Al,{htmlFor:t,isRequired:i},r),e.cloneElement(n,{id:t,hasErrors:a,error:a,warning:d,...s}),c)},exports.FullPageError=({children:e,...t})=>h.default.createElement(Xc,t,h.default.createElement(Jc,null,h.default.createElement(o.IconIllustrationWarning,null),e)),exports.FullPageErrorActions=({children:e,...t})=>h.default.createElement(Qc,t,e),exports.FullPageErrorDescription=({children:e,...t})=>h.default.createElement(eu,t,e),exports.FullPageErrorTitle=({children:e,...t})=>h.default.createElement(tu,t,e),exports.Grid=Yt,exports.GridItem=({children:e,...t})=>h.default.createElement(Xt,t,e),exports.GroupSelectMenu=({initialSelectedItem:t,selectedItem:r,options:a,onChange:o,onOuterClick:l,onInputValueChange:n,onInputKeyDown:d,onInputKeyUp:i,itemToString:s,placeholder:c,disabled:u,hasErrors:b=!1,isClearable:f=!1,isFilterable:v=!0,placeholderIcon:p,...m})=>{const[g,x]=e.useState(""),y=e.useMemo((()=>{if(a){if("string"!=typeof a[0])return a;return a.map((e=>({value:e})))}return[]}),[a]),E=e.useCallback((e=>e?s?s(e):e.label?e.label:e.value:e),[s]),w=e.useCallback((e=>E(e).toLowerCase().includes(g.toLowerCase())),[g,E]),k=e.useCallback((e=>{const t=e.options?.filter(w);return t.length>0?[e,...t]:[]}),[w]),C=y&&y.filter((e=>e.options?e:w(e))),$=e.useMemo((()=>C.flatMap((e=>e.options?[...k(e)]:e))),[k,C]),S=e.useMemo((()=>$.filter((e=>void 0===e.options)).reduce(((e,t,r)=>({...e,[t.value]:r})),{})),[$]);return h.default.createElement(Wl,T({onChange:(e,t)=>{o&&("string"==typeof a[0]?o(e&&e.value,t):o(e,t))},onOuterClick:l,placeholder:c,initialSelectedItem:t,onInputValueChange:(e,t)=>{n&&n(e,t),x(e)},selectedItem:r},m),h.default.createElement(Yl,{isFilter:v,isClearable:f,hasErrors:b,itemToString:E,disabled:u,placeholderIcon:p}),v&&h.default.createElement(nn,{hasErrors:b,disabled:u,onKeyDown:e=>{d&&d(e)},onKeyUp:e=>{i&&i(e)}}),h.default.createElement(en,{noResults:$&&0===$.length},$.map((e=>e.options?(e=>h.default.createElement(sn,{item:e,key:`key_group_${e.value}`,itemToString:()=>E(e)}))(e):((e,t)=>h.default.createElement(rn,{item:e,index:t,key:`key_${e.value}`,itemToString:()=>E(e)}))(e,S[e.value])))))},exports.HiddenInput=xn,exports.IconButton=Ga,exports.InlineNotification=({children:e,type:t="success",withIcon:r=!1,...a})=>h.default.createElement(_d,T({type:t},a),h.default.createElement(Kd,null,Xd[t]),h.default.createElement(Yd,null,e)),exports.Input=({disabled:t=!1,errorText:r,helpText:a,id:o,isRequired:l,label:n,labelVisible:d=!0,maxLength:i,prefix:s,required:c=!1,showCharacterCount:u=!1,value:b,variant:f="default",warningText:v,type:p="text",style:m,className:g,...x})=>{const[y,E]=e.useState(p),{showError:w,showHelpText:k,showWarning:C}=Rn({errorText:r,helpText:a,warningText:v}),$=e.useMemo((()=>"default"!==f),[f]),{ariaDescribedByValues:S,componentIds:I}=Tn({id:o,showCharacterCount:u,showHelpText:k,showWarning:C}),{isDisabled:F}=Fn({disabled:t}),R=e.useMemo((()=>b?.toString()??""),[b]);return h.default.createElement(js,{style:m,className:g},h.default.createElement(qs,null,h.default.createElement(rl,{hidden:!d,id:I.label,isRequired:l??c},n),u&&i&&h.default.createElement(yo,{currentLength:R.length,id:I.characterCount,maximumLength:i})),h.default.createElement(Gs,{disabled:F,hasError:w,hasWarning:C},h.default.createElement(Ks,null,s&&h.default.createElement(Us,null,s),h.default.createElement(Zs,T({},x,{"aria-labelledby":I.label},w&&{"aria-invalid":!0,"aria-errormessage":I.error},S.length>0&&{"aria-describedby":S},{disabled:F,id:I.input,maxLength:i,required:l??c,type:y,value:b}))),$&&h.default.createElement(Qs,{inputId:I.input,inputType:y,label:n,setInputType:E,variant:f,value:R})),a&&h.default.createElement(Wo,{id:I.help},a),C&&v&&h.default.createElement(Xo,{id:I.warning},v),w&&r&&h.default.createElement(Uo,{id:I.error},r))},exports.InputSkeleton=({helpText:e,...t})=>h.default.createElement(js,t,h.default.createElement(al,null),h.default.createElement(_s,null),e&&h.default.createElement(jo,null)),exports.LayoutGrid=({fullWidth:e=!1,children:t,...r})=>h.default.createElement(Jt,T({fullWidth:e},r),t),exports.LayoutGridCenteredContent=({children:e,...t})=>h.default.createElement(Qt,t,e),exports.LayoutGridItem=({children:e,...t})=>h.default.createElement(er,t,e),exports.LayoutGridMainContent=({children:e,...t})=>h.default.createElement(tr,t,e),exports.LayoutGridSider=({children:e,...t})=>h.default.createElement(rr,t,e),exports.Link=e=>{const{hasFlag:t}=I();return t("v10")?h.default.createElement(Qe,e):h.default.createElement(mo,e)},exports.LinkStyle=po,exports.List=R,exports.ListItem=G,exports.LoadableBoolean=zu,exports.Loading=ae,exports.Menu=ua,exports.MenuContext=Dl,exports.Modal=e=>{const{hasFlag:t}=I();return t("v10")?h.default.createElement($d,e):h.default.createElement(li,e)},exports.ModalBody=({children:e,...t})=>h.default.createElement("div",t,e),exports.ModalFooter=({children:e,...t})=>h.default.createElement(Sd,t,e),exports.ModalProvider=xd,exports.ModalTrigger=Id,exports.MultiLineTextField=cn,exports.NavLogoutButton=un,exports.NavSpacer=bn,exports.OptionalFormGroup=({children:e,errorMessage:t,id:r,isOpen:a=!1,hasError:o,onClick:l,showHighlightOnSelected:n=!1,slot:d,slotPlacement:i="end",title:s,titleIcon:c})=>{const{ref:u,styles:b}=Fl({isOpen:a});return h.default.createElement(h.default.Fragment,null,h.default.createElement(vn,{"aria-expanded":a,hasError:o},h.default.createElement(pn,{type:"button","data-testid":"optional-form-group-btn",id:r,isOpen:a,"aria-controls":`control-${r}`,onClick:l,showHighlightOnSelected:n},h.default.createElement(qt,null,h.default.createElement(mn,null,h.default.createElement(Ln,{checked:a,id:"optional-form-group-checkbox",onChange:()=>{}})),h.default.createElement(gn,{"data-testid":"optional-form-group-wrapper",slotPlacement:i},h.default.createElement(ze,{className:"optional-form-group-title"},c&&h.default.createElement(c,{"data-testid":a?"optional-form-group-icon-open":"optional-form-group-icon-closed"}),s),d&&h.default.createElement("span",null,d)))),h.default.createElement(hn,{"data-testid":"optional-form-group-content",ref:u,style:b,"aria-labelledby":r,isOpen:a,showHighlightOnSelected:n},e)),o&&t&&h.default.createElement(Uo,null,t))},exports.OrderedList=U,exports.OutlineButton=Ha,exports.OutlineButtonStyle=Ba,exports.Overlay=Qd,exports.PageTitle=W,exports.Pagination=({limit:e,skip:t,setSkip:r,itemCount:a,showNumbers:o,maxTotal:l})=>a<e?null:h.default.createElement(Kn,null,h.default.createElement(Gn,{skip:t,limit:e,itemCount:a,maxTotal:l}),h.default.createElement(qn,{showNumbers:o,itemCount:a,skip:t,limit:e,onPageChange:r})),exports.PaginationControls=qn,exports.Panel=Un,exports.Popover=si,exports.PopoverProvider=({children:t,...r})=>{const a=(({open:t,onOpenChange:r})=>{const[a,o]=e.useState(),[l,n]=e.useState(),d=i.useFloating({open:t,onOpenChange:r,placement:l,whileElementsMounted:i.autoUpdate,middleware:[i.offset(4),i.size({apply({availableHeight:e,availableWidth:t,elements:r}){Object.assign(r.floating.style,{maxHeight:`${Math.max(parseInt(r.floating.style?.minHeight||"100"),e-32)}px`,maxWidth:`${Math.max(parseInt(r.floating.style?.minWidth||"100"),t-32)}px`})}}),i.flip({crossAxis:l?.includes("-"),padding:32})]}),s=d.context,c=i.useClick(s,{enabled:null==t}),u=i.useDismiss(s),b=i.useRole(s),f=i.useInteractions([c,u,b]);return e.useMemo((()=>({open:t,onOpenChange:r,...f,...d,labelId:a,setLabelId:o,setDefaultDirection:n})),[t,r,f,d,a,n])})({...r});return h.createElement(di,{value:a},t)},exports.PopoverTrigger=ci,exports.Portal=Jd,exports.PrimaryButton=Za,exports.ProductStateTag=({text:e})=>h.default.createElement(Zn,null,e),exports.ProgressVariant=re,exports.RadioButton=cc,exports.RadioButtonGroup=({children:e,errorText:t,disabled:r=!1,...a})=>h.default.createElement(nl,T({errorText:t,disabled:r,role:"radiogroup"},a),h.default.createElement(uc,null,e)),exports.RadioPill=fc,exports.RadioPillGroup=({children:e,disabled:t=!1,...r})=>h.default.createElement(nl,T({disabled:t,role:"radiogroup"},r),h.default.createElement(vc,null,e)),exports.RemoveFilterRowButton=({"aria-label":e="Remove Filter Row",...t})=>h.default.createElement(co,T({"aria-label":e},t),h.default.createElement(o.IconActionCross,null)),exports.SearchBox=({children:t,disabled:r,name:a,onClear:l,onSearch:n,onChange:d,initialValue:i,value:s,...c})=>{const[u,b]=e.useState(i??""),[f,v]=e.useState(!1),[p,m]=e.useState(!1),g=()=>{n(void 0!==s?s:u)},x=void 0!==s?s:u;return h.default.createElement("div",null,h.default.createElement(pc,{isInputHovered:f,isInputFocused:p,"data-testid":"searchinputwrapper"},h.default.createElement(mc,T({onKeyDown:e=>{"Enter"===e.key&&g()},onMouseEnter:()=>v(!0),onMouseLeave:()=>v(!1),onFocus:()=>m(!0),onBlur:()=>m(!1),type:"search",name:"q",onChange:e=>{b(e.target.value),d&&d(e.target.value),""===e.target.value&&l&&l()},value:x},c)),h.default.createElement(hc,{"aria-label":"Clear search",onClick:()=>{b(""),d&&d(""),l&&l()},visible:x.length>0},"Clear"),h.default.createElement(gc,{"aria-label":"Submit search",onClick:g},h.default.createElement(o.IconActionSearch,null))))},exports.SearchField=({title:t,description:r,children:a,border:l,disabled:n,name:d,ariaLabel:i="Search",onClear:s,onBtnClick:c,...u})=>{const[b,f]=e.useState(!1),[v,p]=e.useState(!1),[m,g]=e.useState(!1),[x,y]=e.useState(!1);return h.default.createElement(ze,{"data-testid":"searchfield"},h.default.createElement(_n,{isInputHovered:b,isInputFocused:v,isButtonFocused:x,"data-testid":"searchinputwrapper"},h.default.createElement(Yn,T({"aria-label":i,onKeyDown:e=>{"Enter"===e.key&&c()},onMouseEnter:()=>f(!0),onMouseLeave:()=>f(!1),onFocus:()=>p(!0),onBlur:()=>p(!1),type:"text",disabled:n},u)),!n&&!!s&&!!u.value?.length&&h.default.createElement(Zl,{"aria-label":"Clear search",onClick:s,"data-testid":"searchreset"},"Clear"),h.default.createElement(Xn,{"aria-label":"Submit search","data-testid":"searchsubmit",onClick:c,isButtonHovered:m,isButtonFocused:x,isInputHovered:b,isInputFocused:v,onMouseEnter:()=>g(!0),onMouseLeave:()=>g(!1),onFocus:()=>y(!0),onBlur:()=>y(!1)},h.default.createElement(o.IconActionSearch,null))),r&&h.default.createElement(Wo,null,r))},exports.SecondaryButton=_a,exports.SegmentedControl=({disabled:t,errors:r,onChange:a,options:o,selectedValue:l,variant:n="large",equalWidth:d=!1})=>{const i=e.useId();return h.default.createElement(Qn,{errors:r,disabled:t},o.map((({value:e,label:o,selectedColor:s="var(--control-border-selected)",disabled:c})=>h.default.createElement(rd,{disabled:c||t,errors:r,equalWidth:d,key:i+e,name:i,onChange:a,checked:e===l,selectedColor:s,value:e,variant:n},o))))},exports.SegmentedControlButton=({children:e,checked:t,onChange:r,tooltip:a,value:o,...l})=>{const{size:n}=yc(),d=Boolean(a);return h.default.createElement(Ye,{condition:d,wrap:e=>h.default.createElement(Bi,{defaultDirection:"top",text:a},e)},h.default.createElement(kc,T({},l,{"aria-checked":t,buttonSize:n,isSelected:t,onClick:()=>{t||r(o)},role:"radio"}),e))},exports.SegmentedControlGroup=({children:t,label:r,labelVisible:a=!1,size:o="sm"})=>{const l=e.useId();return h.default.createElement(S,{flag:"v10"},h.default.createElement(hl,null,h.default.createElement(xc,{value:{size:o}},h.default.createElement(Ec,null,h.default.createElement(rl,{hidden:!a,id:l,isRequired:!0},r),h.default.createElement(wc,{"aria-labelledby":l,buttonSize:o,role:"radiogroup"},t)))))},exports.Select=({children:t,placeholder:r="Select",warningText:a,errorText:l,helpText:n,disabled:d=!1,isRequired:s=!1,label:c,labelVisible:u=!0,multiSelect:b=!1,onChange:f,initialSelected:v,showClear:p=!0,...m})=>{const{showError:g,showHelpText:x,showWarning:y}=Rn({errorText:l,helpText:n,warningText:a}),{ariaDescribedByValues:E,componentIds:w}=Tn({showHelpText:x,showWarning:y}),{isDisabled:k}=Fn({disabled:d}),{floatingData:C,handleClear:$,selectedItems:S,listRefs:I,activeSelectItem:F,interactions:R,isOpen:M,handleSelect:L}=Mn({multiSelect:b,initialSelected:v,disabled:k});e.useEffect((()=>{f&&f(S.selectedValues)}),[S.selectedValues]);const O=p&&S.selectedOptions.size>0&&!k;return h.default.createElement($c,m,h.default.createElement(zi,{value:{activeSelectItem:F,handleSelect:L,multiSelect:b,selectedItems:S,interactions:R,floatingData:C,listRefs:I}},h.default.createElement(rl,{hidden:!u,isRequired:s,id:w.label},c),h.default.createElement(Sc,T({ref:C.refs.setReference,tabIndex:0},R.getReferenceProps(),{"aria-labelledby":w.label,"aria-disabled":!!k,"aria-required":s,$disabled:k,$hasErrors:g,$hasWarnings:y},l&&{"aria-invalid":!0,"aria-errormessage":w.error},E.length>0&&{"aria-describedby":E}),h.default.createElement(Ic,null,h.default.createElement(Tc,null,0===S.selectedOptions.size&&h.default.createElement(Cc,null,r),S.selectedOptions.size>0&&[...S.selectedOptions.entries()].map((([e,{prefix:t}])=>b?h.default.createElement(ml,{key:`select-tag-${e}`,prefix:t,onClick:()=>L({label:e,value:e})},e):h.default.createElement(fl,{key:`select-tag-${e}`,prefix:t},e))))),O&&h.default.createElement(Fc,{onClick:e=>{e.stopPropagation(),$()},"aria-label":"Clear selection"},"Clear"),h.default.createElement(o.IconActionSelect,{"aria-hidden":!0})),n&&h.default.createElement(Wo,{id:w.help},n),y&&a&&h.default.createElement(Xo,{id:w.warning},a),g&&l&&h.default.createElement(Uo,{id:w.error},l),M&&h.default.createElement(i.FloatingPortal,null,h.default.createElement(i.FloatingFocusManager,{context:C.context,modal:!1},h.default.createElement(Rc,T({ref:C.refs.setFloating,style:C.floatingStyles},R.getFloatingProps(),b&&{"aria-multiselectable":!0}),h.default.createElement(i.FloatingList,{elementsRef:I.elementsRef,labelsRef:I.labelsRef},t))))))},exports.SelectGroup=as,exports.SelectGroupDivider=ls,exports.SelectItem=es,exports.SelectMenu=Wl,exports.SelectMenuButton=Yl,exports.SelectMenuFilter=nn,exports.SelectMenuGroup=sn,exports.SelectMenuItem=rn,exports.SelectMenuList=en,exports.SelectSkeleton=({helpText:e,...t})=>h.default.createElement($c,t,h.default.createElement(al,null),h.default.createElement(Mc,null),e&&h.default.createElement(jo,null)),exports.SimpleSelectMenu=({initialSelectedItem:t,selectedItem:r,options:a,onChange:o,onOuterClick:l,onInputValueChange:n,onInputKeyDown:d,onInputKeyUp:i,itemToString:s,placeholder:c,disabled:u,hasErrors:b=!1,hasWarnings:f=!1,isClearable:v=!1,isFilterable:p=!0,placeholderIcon:m,...g})=>{const[x,y]=e.useState(""),E=e.useRef(null),w=e.useMemo((()=>{if(a){if("string"!=typeof a[0])return a;return a.map((e=>({value:e})))}return[]}),[a]),k=e=>e?s?s(e):e.label?e.label:e.value:e,C=w&&w.filter((e=>k(e).toLowerCase().includes(x.toLowerCase())));return h.default.createElement(Wl,T({onChange:(e,t)=>{o&&("string"==typeof a[0]?o(e&&e.value,t):o(e,t)),E?.current&&E.current.focus()},onOuterClick:l,placeholder:c,initialSelectedItem:t,onInputValueChange:(e,t)=>{n&&n(e,t),y(e)},selectedItem:r},g),h.default.createElement(Yl,{buttonRef:E,isFilter:p,isClearable:v,hasErrors:b,hasWarnings:f,itemToString:k,disabled:u,placeholderIcon:m}),p&&h.default.createElement(nn,{hasErrors:b,hasWarnings:f,disabled:u,onKeyDown:e=>{d&&d(e)},onKeyUp:e=>{i&&i(e)}}),h.default.createElement(en,{noResults:C&&0===C.length},C.map(((e,t)=>h.default.createElement(rn,{item:e,index:t,key:`key_${e.value}`,itemToString:()=>k(e)})))))},exports.Skeleton=({children:e,...t})=>h.default.createElement(Eo,T({role:"status","aria-label":"Loading","aria-busy":"true"},t),e),exports.SkeletonCircle=({...e})=>h.default.createElement(Co,T({"aria-hidden":"true"},e)),exports.SkeletonRectangle=So,exports.SkeletonText=Ho,exports.SpaceBetween=ad,exports.StyledMenu=Hl,exports.Switch=Vc,exports.SwitchButton=({id:e,disabled:t=!1,checked:r,position:a=od.START,label:o,icon:l,supportingText:n,warningText:d,width:i,tooltipText:s,withTooltip:c=!1,...u})=>{const b=t?xn:id;return h.default.createElement(qt,null,h.default.createElement(b,T({id:e,"data-testid":"switch-button-input-hidden",type:"checkbox",checked:r,disabled:t,tabIndex:t?-1:0},u)),h.default.createElement(ld,{position:a,"data-testid":"switch-button-wrapper"},o&&h.default.createElement(cd,null,h.default.createElement(ud,{width:i},h.default.createElement(bd,{"data-testid":"switch-button-textlabel",htmlFor:e,color:t?"var(--control-text-disabled)":"var(--control-text-primary)"},o),l&&(c&&!t?h.default.createElement(yl,{text:s},h.default.createElement(l,{"data-testid":"switch-button-icon"})):h.default.createElement(l,{"data-testid":"switch-button-icon"}))),n&&h.default.createElement(h.default.Fragment,null,h.default.createElement(bd,null,n),d&&h.default.createElement(Xo,null,d))),h.default.createElement(nd,{checked:r,disabled:t,"data-testid":"switch-button-styled"},h.default.createElement(sd,{htmlFor:e,"data-testid":"switch-button-label",disabled:t},h.default.createElement(dd,{checked:r,disabled:t,"data-testid":"switch-button-circle"})))))},exports.SwitchGroup=({children:e,legend:t,withTooltip:r=!1,tooltipText:a,isRequired:l})=>h.default.createElement(fd,null,t&&(r?h.default.createElement(vd,null,h.default.createElement(rl,{isRequired:l,as:"legend",mb:"var(--layout-soybean)"},t),h.default.createElement(yl,{text:a},h.default.createElement(o.IconActionAbout,{"data-testid":"choice-tooltip"}))):h.default.createElement(rl,{isRequired:l,as:"legend"},t)),h.default.createElement(pd,null,e.map((e=>h.default.createElement(md,{key:`radio-${e.props.id}`},e))))),exports.SwitchPosition=od,exports.SystemLevelNotification=({title:e,description:t,actionText:r,onActionClick:a})=>h.default.createElement(ui,null,h.default.createElement(bi,null,h.default.createElement(fi,null,e&&h.default.createElement(vi,{id:"system-notification-title"},e),h.default.createElement(pi,{id:"system-notification-description"},t)),h.default.createElement(Ca,{size:"sm",onClick:a},r))),exports.Tab=ct,exports.TabList=e=>{const{hasFlag:t}=I();return t("v11")?h.default.createElement(St,e):h.default.createElement(wt,e)},exports.TabPanel=Tt,exports.TabProvider=Rt,exports.Table=({density:e="comfortable",tableLayout:t="auto",alternatingBackground:r=!1,children:a,...o})=>h.default.createElement(du,{value:{density:e,alternatingBackground:r}},h.default.createElement(bu,T({$tableLayout:t},o),a)),exports.TableBody=fu,exports.TableCell=yu,exports.TableHead=Su,exports.TableHeadSticky=Iu,exports.TablePagination=({totalResults:t,resultsPerPage:r,onPageChange:a,canGoNext:o,canGoPrev:l,goToNextPage:n,goToPrevPage:i,goToFirstPage:s,goToLastPage:c,currentPageNumber:u,...b})=>{const f=Boolean(o||l||n||i||s||c||c),v=t&&r&&!f?Math.ceil(t/r):0,[p,{canGoToNextStep:m,canGoToPrevStep:g,setStep:x}]=d.useStep(v);e.useEffect((()=>{u&&x(u)}),[u,x]);const y=e=>{x(e),a?.(e)},E=e.useCallback((()=>{f?s?.():y(1)}),[f,s,y]),w=e.useCallback((()=>{f?c?.():y(v)}),[f,c,y,v]),k=e.useCallback((()=>{f?n?.():y(p+1)}),[f,n,y,p]),C=e.useCallback((()=>{f?i?.():y(p-1)}),[f,i,y,p]);return h.default.createElement(hl,{delay:{open:0,close:500}},h.default.createElement(Fu,{value:{totalResults:t,resultsPerPage:r,totalPages:v,currentStep:p,setPage:y,canGoToNextStep:o??m,canGoToPrevStep:l??g,goToNextStep:k,goToPrevStep:C,goToFirstStep:f&&!s?void 0:E,goToLastStep:f&&!c?void 0:w}},h.default.createElement(Hu,b,h.default.createElement(Bu,null))))},exports.TableRow=Cu,exports.Text=A,exports.TextCardNumber=P,exports.TextField=ln,exports.TextFieldBase=an,exports.TextFieldContainer=on,exports.TextHeadingFour=H,exports.TextHeadingOne=N,exports.TextHeadingThree=B,exports.TextHeadingTwo=D,exports.TextInline=V,exports.TextMono=z,exports.TextStatus=e=>{const{hasFlag:t}=I();return t("v10")?h.default.createElement(Ad,e):h.default.createElement(au,e)},exports.Textarea=({disabled:t=!1,errorText:r,helpText:a,id:o,isRequired:l,label:n,labelVisible:d=!0,maxLength:i,required:s=!1,showCharacterCount:c=!1,value:u,warningText:b,style:f,className:v,...p})=>{const{showError:m,showHelpText:g,showWarning:x}=Rn({errorText:r,helpText:a,warningText:b}),{ariaDescribedByValues:y,componentIds:E}=Tn({id:o,showCharacterCount:c,showHelpText:g,showWarning:x}),{isDisabled:w}=Fn({disabled:t}),k=e.useMemo((()=>u?.toString()??""),[u]);return h.default.createElement(zc,{style:f,className:v},h.default.createElement(Wc,null,h.default.createElement(rl,{hidden:!d,id:E.label,isRequired:l??s},n),c&&i&&h.default.createElement(yo,{currentLength:k.length,id:E.characterCount,maximumLength:i})),h.default.createElement(jc,T({},p,m&&{"aria-invalid":!0,"aria-errormessage":E.error},y.length>0&&{"aria-describedby":y},{disabled:w,hasError:m,hasWarning:x,"aria-labelledby":E.label,id:E.input,maxLength:i,required:l??s,value:u})),a&&h.default.createElement(Wo,{id:E.help},a),x&&b&&h.default.createElement(Xo,{id:E.warning},b),m&&r&&h.default.createElement(Uo,{id:E.error},r))},exports.ThemeDefaultProvider=({children:t,theme:r={},migration:a})=>(e.useEffect((()=>console.warn("ThemeDefaultProvider has no effect and should be removed")),[]),h.default.createElement(h.default.Fragment,null,t)),exports.Toast=Si,exports.ToastProvider=({children:t})=>{const[r,a]=e.useState(),[o,l]=e.useState([]),[n,d]=e.useState(!1),i=e.useCallback(((e,t)=>{r?l((r=>[...r,{message:e,...t}])):(a({message:e,...t}),d(!0))}),[l,r,d]),s=e.useCallback((()=>{o.length>0?(a(o[0]),l((e=>e.length>1?[...e.slice(1)]:[])),d(!0)):(a(void 0),l([]))}),[l,a,o,d]);return h.default.createElement(Ii,{value:{showToast:i}},t,h.default.createElement(Si,T({open:n,onClose:()=>d(!1),onUnmount:s},r?.persistent&&{persistent:r.persistent}),r?.message))},exports.ToolkitFeatureFlag=S,exports.ToolkitFeatureFlagContext=$,exports.Tooltip=Bi,exports.TooltipFloatingDelayGroup=hl,exports.UnorderedList=_,exports.UserProfileNav=({children:e,userName:t,onLogout:r,IconLogout:a,IconLogoutSelected:o})=>h.default.createElement(h.default.Fragment,null,t&&h.default.createElement(A,{"data-testid":"username"},t),h.default.createElement(un,{onClick:r,type:"button",RestingIcon:a,ActiveIcon:o},e)),exports.Variant=vt,exports.baseTextStyles=O,exports.closeMenuOnEscape=zl,exports.debounce=(e,t)=>{let r;return(...a)=>{clearTimeout(r),r=setTimeout((()=>e(...a)),t)}},exports.formatDateString=e=>p.format(Vu(e),"dd MMM yyyy"),exports.formatDateTimeString=e=>p.format(Vu(e),"dd MMM yyyy, h:mm aaa"),exports.formatTimeString=e=>p.format(Vu(e),"h:mm aaa"),exports.useCollapsible=Fl,exports.useHasUserVisited=t=>{const[r,a]=d.useLocalStorage(t,!1);return[r,e.useCallback((()=>a(!0)),[a])]},exports.useIsOverflow=kt,exports.useMatchMedia=Ct,exports.useMenuContext=Bl,exports.useRoveFocus=yt,exports.useToast=Ti,exports.useToolkitFeatureFlag=I;
//# sourceMappingURL=index.cjs.map
